(() => {
  (function () {
    "use strict";
    var e =
        "function" == typeof Promise
          ? Promise
          : function (e) {
              var t,
                i = [],
                n = 0;
              return (
                e(function (e) {
                  (t = e), (n = 1), i.splice(0).forEach(s);
                }),
                { then: s }
              );
              function s(e) {
                return n ? setTimeout(e, 0, t) : i.push(e), this;
              }
            },
      t = function (e, t) {
        var i = function e(t) {
            for (var i = 0, s = t.length; i < s; i++) n(t[i]);
          },
          n = function e(t) {
            var i = t.target,
              n = t.attributeName,
              s = t.oldValue;
            i.attributeChangedCallback(n, s, i.getAttribute(n));
          };
        return function (s, r) {
          var a = s.constructor.observedAttributes;
          return (
            a &&
              e(r).then(function () {
                new t(i).observe(s, {
                  attributes: !0,
                  attributeOldValue: !0,
                  attributeFilter: a,
                });
                for (var e = 0, r = a.length; e < r; e++)
                  s.hasAttribute(a[e]) &&
                    n({ target: s, attributeName: a[e], oldValue: null });
              }),
            s
          );
        };
      },
      i = "querySelectorAll";
    function n(e) {
      this.observe(e, { subtree: !0, childList: !0 });
    }
    var s = function e(t, s, r) {
        var a = function e(n, s, r, a, o) {
            for (var l = 0, c = n.length; l < c; l++) {
              var h = n[l];
              (o || i in h) &&
                (a
                  ? s.has(h) || (s.add(h), r.delete(h), t(h, a))
                  : r.has(h) || (r.add(h), s.delete(h), t(h, a)),
                o || e(h[i]("*"), s, r, a, !0));
            }
          },
          o = new (r || MutationObserver)(function (e) {
            for (
              var t = new Set(), i = new Set(), n = 0, s = e.length;
              n < s;
              n++
            ) {
              var r = e[n],
                o = r.addedNodes;
              a(r.removedNodes, t, i, !1, !1), a(o, t, i, !0, !1);
            }
          });
        return (o.add = n), o.add(s || document), o;
      },
      r = "querySelectorAll",
      a = self,
      o = a.document,
      l = a.Element,
      c = a.MutationObserver,
      h = a.Set,
      d = a.WeakMap,
      u = function e(t) {
        return r in t;
      },
      p = [].filter,
      m = function (e) {
        var t = new d(),
          i = function e(i) {
            for (var n = 0, s = i.length; n < s; n++) t.delete(i[n]);
          },
          n = function e() {
            for (var t = g.takeRecords(), i = 0, n = t.length; i < n; i++)
              m(p.call(t[i].removedNodes, u), !1),
                m(p.call(t[i].addedNodes, u), !0);
          },
          a = function i(n, s) {
            var r;
            if (s)
              for (
                var a,
                  o,
                  l =
                    (a = n).matches ||
                    a.webkitMatchesSelector ||
                    a.msMatchesSelector,
                  c = 0,
                  d = f.length;
                c < d;
                c++
              )
                l.call(n, (o = f[c])) &&
                  (t.has(n) || t.set(n, new h()),
                  (r = t.get(n)).has(o) || (r.add(o), e.handle(n, s, o)));
            else
              t.has(n) &&
                ((r = t.get(n)),
                t.delete(n),
                r.forEach(function (t) {
                  e.handle(n, s, t);
                }));
          },
          m = function e(t) {
            for (
              var i =
                  !(arguments.length > 1) ||
                  void 0 === arguments[1] ||
                  arguments[1],
                n = 0,
                s = t.length;
              n < s;
              n++
            )
              a(t[n], i);
          },
          f = e.query,
          $ = e.root || o,
          g = s(a, $, c),
          b = l.prototype.attachShadow;
        return (
          b &&
            (l.prototype.attachShadow = function (e) {
              var t = b.call(this, e);
              return g.add(t), t;
            }),
          f.length && m($[r](f)),
          { drop: i, flush: n, observer: g, parse: m }
        );
      },
      f = self,
      $ = f.document,
      g = f.Map,
      b = f.MutationObserver,
      v = f.Object,
      y = f.Set,
      _ = f.WeakMap,
      w = f.Element,
      E = f.HTMLElement,
      x = f.Node,
      k = f.Error,
      S = f.TypeError,
      L = f.Reflect,
      T = self.Promise || e,
      A = v.defineProperty,
      C = v.keys,
      P = v.getOwnPropertyNames,
      I = v.setPrototypeOf,
      q = !self.customElements,
      V = function e(t) {
        for (var i = C(t), n = [], s = i.length, r = 0; r < s; r++)
          (n[r] = t[i[r]]), delete t[i[r]];
        return function () {
          for (var e = 0; e < s; e++) t[i[e]] = n[e];
        };
      };
    if (q) {
      var M = function e() {
          var t = this.constructor;
          if (!O.has(t)) throw new S("Illegal constructor");
          var i = O.get(t);
          if (W) return Y(W, i);
          var n = D.call($, i);
          return Y(I(n, t.prototype), i);
        },
        D = $.createElement,
        O = new g(),
        B = new g(),
        R = new g(),
        N = new g(),
        H = [],
        F = function e(t, i, n) {
          var s = R.get(n);
          if (i && !s.isPrototypeOf(t)) {
            var r = V(t);
            W = I(t, s);
            try {
              new s.constructor();
            } finally {
              (W = null), r();
            }
          }
          var a = "".concat(i ? "" : "dis", "connectedCallback");
          a in s && t[a]();
        },
        z = m({ query: H, handle: F }).parse,
        W = null,
        U = function t(i) {
          if (!B.has(i)) {
            var n,
              s = new e(function (e) {
                n = e;
              });
            B.set(i, { $: s, _: n });
          }
          return B.get(i).$;
        },
        Y = t(U, b);
      A(self, "customElements", {
        configurable: !0,
        value: {
          define: function e(t, i) {
            if (N.has(t))
              throw new k(
                'the name "'.concat(
                  t,
                  '" has already been used with this registry'
                )
              );
            O.set(i, t),
              R.set(t, i.prototype),
              N.set(t, i),
              H.push(t),
              U(t).then(function () {
                z($.querySelectorAll(t));
              }),
              B.get(t)._(i);
          },
          get: function e(t) {
            return N.get(t);
          },
          whenDefined: U,
        },
      }),
        A((M.prototype = E.prototype), "constructor", { value: M }),
        A(self, "HTMLElement", { configurable: !0, value: M }),
        A($, "createElement", {
          configurable: !0,
          value: function e(t, i) {
            var n = i && i.is,
              s = n ? N.get(n) : N.get(t);
            return s ? new s() : D.call($, t);
          },
        }),
        "isConnected" in x.prototype ||
          A(x.prototype, "isConnected", {
            configurable: !0,
            get: function e() {
              return !(
                this.ownerDocument.compareDocumentPosition(this) &
                this.DOCUMENT_POSITION_DISCONNECTED
              );
            },
          });
    } else
      try {
        var j = function e() {
          return self.Reflect.construct(HTMLLIElement, [], e);
        };
        j.prototype = HTMLLIElement.prototype;
        var X = "extends-li";
        self.customElements.define("extends-li", j, { extends: "li" }),
          (q = 0 > $.createElement("li", { is: X }).outerHTML.indexOf(X));
        var G = self.customElements,
          K = G.get,
          Z = G.whenDefined;
        A(self.customElements, "whenDefined", {
          configurable: !0,
          value: function e(t) {
            var i = this;
            return Z.call(this, t).then(function (e) {
              return e || K.call(i, t);
            });
          },
        });
      } catch (Q) {
        q = !q;
      }
    if (q) {
      var J = function e(t) {
          ef(ea.get(t).querySelectorAll(this), t.isConnected);
        },
        ee = self.customElements,
        et = w.prototype.attachShadow,
        ei = $.createElement,
        en = ee.define,
        es = ee.get,
        er = (
          L || {
            construct: function e(t) {
              return t.call(this);
            },
          }
        ).construct,
        ea = new _(),
        eo = new y(),
        el = new g(),
        ec = new g(),
        eh = new g(),
        ed = new g(),
        eu = [],
        ep = [],
        em = function e(t) {
          return ed.get(t) || es.call(ee, t);
        },
        ef = m({
          query: ep,
          handle: function e(t, i, n) {
            var s = eh.get(n);
            if (i && !s.isPrototypeOf(t)) {
              var r = V(t);
              ev = I(t, s);
              try {
                new s.constructor();
              } finally {
                (ev = null), r();
              }
            }
            var a = "".concat(i ? "" : "dis", "connectedCallback");
            a in s && t[a]();
          },
        }).parse,
        e$ = m({
          query: eu,
          handle: function e(t, i) {
            ea.has(t) &&
              (i ? eo.add(t) : eo.delete(t), ep.length && J.call(ep, t));
          },
        }).parse,
        eg = function e(t) {
          if (!ec.has(t)) {
            var i,
              n = new T(function (e) {
                i = e;
              });
            ec.set(t, { $: n, _: i });
          }
          return ec.get(t).$;
        },
        eb = t(eg, b),
        ev = null;
      P(self)
        .filter(function (e) {
          return /^HTML/.test(e);
        })
        .forEach(function (e) {
          var t = self[e];
          function i() {
            var e = this.constructor;
            if (!el.has(e)) throw new S("Illegal constructor");
            var i = el.get(e),
              n = i.is,
              s = i.tag;
            if (!n) return er.call(this, t, [], e);
            if (ev) return eb(ev, n);
            var r = ei.call($, s);
            return r.setAttribute("is", n), eb(I(r, e.prototype), n);
          }
          A((i.prototype = t.prototype), "constructor", { value: i }),
            A(self, e, { value: i });
        }),
        A($, "createElement", {
          configurable: !0,
          value: function e(t, i) {
            var n = i && i.is;
            if (n) {
              var s = ed.get(n);
              if (s && el.get(s).tag === t) return new s();
            }
            var r = ei.call($, t);
            return n && r.setAttribute("is", n), r;
          },
        }),
        et &&
          (w.prototype.attachShadow = function (e) {
            var t = et.call(this, e);
            return ea.set(this, t), t;
          }),
        A(ee, "get", { configurable: !0, value: em }),
        A(ee, "whenDefined", { configurable: !0, value: eg }),
        A(ee, "define", {
          configurable: !0,
          value: function e(t, i, n) {
            if (em(t))
              throw new k(
                "'".concat(t, "' has already been defined as a custom element")
              );
            var s,
              r = n && n.extends;
            el.set(i, r ? { is: t, tag: r } : { is: "", tag: t }),
              r
                ? ((s = "".concat(r, '[is="').concat(t, '"]')),
                  eh.set(s, i.prototype),
                  ed.set(t, i),
                  ep.push(s))
                : (en.apply(ee, arguments), eu.push((s = t))),
              eg(t).then(function () {
                r
                  ? (ef($.querySelectorAll(s)), eo.forEach(J, [s]))
                  : e$($.querySelectorAll(s));
              }),
              ec.get(t)._(i);
          },
        });
    }
  })(),
    (function () {
      var e,
        t,
        i = {},
        n = {};
      (function (e, t) {
        function i() {
          (this._delay = 0),
            (this._endDelay = 0),
            (this._fill = "none"),
            (this._iterationStart = 0),
            (this._iterations = 1),
            (this._duration = 0),
            (this._playbackRate = 1),
            (this._direction = "normal"),
            (this._easing = "linear"),
            (this._easingFunction = u);
        }
        function n() {
          return e.isDeprecated(
            "Invalid timing inputs",
            "2016-03-02",
            "TypeError exceptions will be thrown instead.",
            !0
          );
        }
        function s(t, n, s) {
          var r = new i();
          return (
            n && ((r.fill = "both"), (r.duration = "auto")),
            "number" != typeof t || isNaN(t)
              ? void 0 !== t &&
                Object.getOwnPropertyNames(t).forEach(function (i) {
                  "auto" != t[i] &&
                    !(
                      ("number" == typeof r[i] || "duration" == i) &&
                      ("number" != typeof t[i] || isNaN(t[i]))
                    ) &&
                    ("fill" != i || -1 != h.indexOf(t[i])) &&
                    ("direction" != i || -1 != d.indexOf(t[i])) &&
                    (("playbackRate" == i &&
                      1 !== t[i] &&
                      e.isDeprecated(
                        "AnimationEffectTiming.playbackRate",
                        "2014-11-28",
                        "Use Animation.playbackRate instead."
                      )) ||
                      (r[i] = t[i]));
                })
              : (r.duration = t),
            r
          );
        }
        function r(e, t, i, n) {
          return e < 0 || e > 1 || i < 0 || i > 1
            ? u
            : function (s) {
                function r(e, t, i) {
                  return (
                    3 * e * (1 - i) * (1 - i) * i +
                    3 * t * (1 - i) * i * i +
                    i * i * i
                  );
                }
                if (s <= 0) {
                  var a = 0;
                  return (
                    e > 0 ? (a = t / e) : !t && i > 0 && (a = n / i), a * s
                  );
                }
                if (s >= 1) {
                  var o = 0;
                  return (
                    i < 1
                      ? (o = (n - 1) / (i - 1))
                      : 1 == i && e < 1 && (o = (t - 1) / (e - 1)),
                    1 + o * (s - 1)
                  );
                }
                for (var l = 0, c = 1; l < c; ) {
                  var h = (l + c) / 2,
                    d = r(e, i, h);
                  if (1e-5 > Math.abs(s - d)) break;
                  d < s ? (l = h) : (c = h);
                }
                return r(t, n, h);
              };
        }
        function a(e, t) {
          return function (i) {
            if (i >= 1) return 1;
            var n = 1 / e;
            return (i += t * n) - (i % n);
          };
        }
        function o(e) {
          g || (g = document.createElement("div").style),
            (g.animationTimingFunction = ""),
            (g.animationTimingFunction = e);
          var t = g.animationTimingFunction;
          if ("" == t && n())
            throw TypeError(e + " is not a valid value for easing");
          return t;
        }
        function l(e) {
          if ("linear" == e) return u;
          var t = v.exec(e);
          if (t) return r.apply(this, t.slice(1).map(Number));
          var i = y.exec(e);
          if (i) return a(Number(i[1]), f);
          var n = _.exec(e);
          return n
            ? a(Number(n[1]), { start: p, middle: m, end: f }[n[2]])
            : $[e] || u;
        }
        function c(e, t, i) {
          if (null == t) return w;
          var n = i.delay + e + i.endDelay;
          return t < Math.min(i.delay, n)
            ? E
            : t >= Math.min(i.delay + e, n)
            ? x
            : k;
        }
        var h = "backwards|forwards|both|none".split("|"),
          d = "reverse|alternate|alternate-reverse".split("|"),
          u = function (e) {
            return e;
          };
        i.prototype = {
          _setMember: function (t, i) {
            (this["_" + t] = i),
              this._effect &&
                ((this._effect._timingInput[t] = i),
                (this._effect._timing = e.normalizeTimingInput(
                  this._effect._timingInput
                )),
                (this._effect.activeDuration = e.calculateActiveDuration(
                  this._effect._timing
                )),
                this._effect._animation &&
                  this._effect._animation._rebuildUnderlyingAnimation());
          },
          get playbackRate() {
            return this._playbackRate;
          },
          set delay(a3) {
            this._setMember("delay", a3);
          },
          get delay() {
            return this._delay;
          },
          set endDelay(a3) {
            this._setMember("endDelay", a3);
          },
          get endDelay() {
            return this._endDelay;
          },
          set fill(a3) {
            this._setMember("fill", a3);
          },
          get fill() {
            return this._fill;
          },
          set iterationStart(a3) {
            if ((isNaN(a3) || a3 < 0) && n())
              throw TypeError(
                "iterationStart must be a non-negative number, received: " + a3
              );
            this._setMember("iterationStart", a3);
          },
          get iterationStart() {
            return this._iterationStart;
          },
          set duration(a3) {
            if ("auto" != a3 && (isNaN(a3) || a3 < 0) && n())
              throw TypeError(
                "duration must be non-negative or auto, received: " + a3
              );
            this._setMember("duration", a3);
          },
          get duration() {
            return this._duration;
          },
          set direction(a3) {
            this._setMember("direction", a3);
          },
          get direction() {
            return this._direction;
          },
          set easing(a3) {
            (this._easingFunction = l(o(a3))), this._setMember("easing", a3);
          },
          get easing() {
            return this._easing;
          },
          set iterations(a3) {
            if ((isNaN(a3) || a3 < 0) && n())
              throw TypeError(
                "iterations must be non-negative, received: " + a3
              );
            this._setMember("iterations", a3);
          },
          get iterations() {
            return this._iterations;
          },
        };
        var p = 1,
          m = 0.5,
          f = 0,
          $ = {
            ease: r(0.25, 0.1, 0.25, 1),
            "ease-in": r(0.42, 0, 1, 1),
            "ease-out": r(0, 0, 0.58, 1),
            "ease-in-out": r(0.42, 0, 0.58, 1),
            "step-start": a(1, p),
            "step-middle": a(1, m),
            "step-end": a(1, f),
          },
          g = null,
          b = "\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*",
          v = RegExp(
            "cubic-bezier\\(" + b + "," + b + "," + b + "," + b + "\\)"
          ),
          y = /steps\(\s*(\d+)\s*\)/,
          _ = /steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/,
          w = 0,
          E = 1,
          x = 2,
          k = 3;
        (e.cloneTimingInput = function e(t) {
          if ("number" == typeof t) return t;
          var i = {};
          for (var n in t) i[n] = t[n];
          return i;
        }),
          (e.makeTiming = s),
          (e.numericTimingToObject = function e(t) {
            return (
              "number" == typeof t &&
                (t = isNaN(t) ? { duration: 0 } : { duration: t }),
              t
            );
          }),
          (e.normalizeTimingInput = function t(i, n) {
            return s((i = e.numericTimingToObject(i)), n);
          }),
          (e.calculateActiveDuration = function e(t) {
            var i;
            return Math.abs(
              ((i = t),
              (0 === i.duration || 0 === i.iterations
                ? 0
                : i.duration * i.iterations) / t.playbackRate)
            );
          }),
          (e.calculateIterationProgress = function e(t, i, n) {
            var s = c(t, i, n),
              r = (function e(t, i, n, s, r) {
                switch (s) {
                  case E:
                    return "backwards" == i || "both" == i ? 0 : null;
                  case k:
                    return n - r;
                  case x:
                    return "forwards" == i || "both" == i ? t : null;
                  case w:
                    return null;
                }
              })(t, n.fill, i, s, n.delay);
            if (null === r) return null;
            var a,
              o,
              l,
              h,
              d,
              u,
              p,
              m,
              f,
              $,
              g,
              b,
              v,
              y,
              _,
              S,
              L,
              T =
                ((a = n.duration),
                (o = s),
                (l = n.iterations),
                (h = r),
                (u = d = n.iterationStart),
                0 === a ? o !== E && (u += l) : (u += h / a),
                u),
              A =
                ((p = T),
                (m = n.iterationStart),
                (f = s),
                ($ = n.iterations),
                (g = r),
                (b = n.duration),
                0 != (v = p === 1 / 0 ? m % 1 : p % 1) ||
                  f !== x ||
                  0 === $ ||
                  (0 === g && 0 !== b) ||
                  (v = 1),
                v),
              C =
                ((y = s),
                (_ = n.iterations),
                (S = A),
                (L = T),
                y === x && _ === 1 / 0
                  ? 1 / 0
                  : 1 === S
                  ? Math.floor(L) - 1
                  : Math.floor(L)),
              P = (function e(t, i, n) {
                var s = t;
                if ("normal" !== t && "reverse" !== t) {
                  var r = i;
                  "alternate-reverse" === t && (r += 1),
                    (s = "normal"),
                    r !== 1 / 0 && r % 2 != 0 && (s = "reverse");
                }
                return "normal" === s ? n : 1 - n;
              })(n.direction, C, A);
            return n._easingFunction(P);
          }),
          (e.calculatePhase = c),
          (e.normalizeEasing = o),
          (e.parseEasingFunction = l);
      })(i),
        (function (e, t) {
          function i(e, t) {
            return (e in l && l[e][t]) || t;
          }
          function n(e, t, n) {
            var s;
            if (
              "display" !== (s = e) &&
              0 !== s.lastIndexOf("animation", 0) &&
              0 !== s.lastIndexOf("transition", 0)
            ) {
              var o = r[e];
              if (o)
                for (var l in ((a.style[e] = t), o)) {
                  var c = o[l],
                    h = a.style[c];
                  n[c] = i(c, h);
                }
              else n[e] = i(e, t);
            }
          }
          function s(e) {
            var t = [];
            for (var i in e)
              if (!(i in ["easing", "offset", "composite"])) {
                var n = e[i];
                Array.isArray(n) || (n = [n]);
                for (var s, r = n.length, a = 0; a < r; a++)
                  ((s = {}).offset =
                    "offset" in e ? e.offset : 1 == r ? 1 : a / (r - 1)),
                    "easing" in e && (s.easing = e.easing),
                    "composite" in e && (s.composite = e.composite),
                    (s[i] = n[a]),
                    t.push(s);
              }
            return (
              t.sort(function (e, t) {
                return e.offset - t.offset;
              }),
              t
            );
          }
          var r = {
              background: [
                "backgroundImage",
                "backgroundPosition",
                "backgroundSize",
                "backgroundRepeat",
                "backgroundAttachment",
                "backgroundOrigin",
                "backgroundClip",
                "backgroundColor",
              ],
              border: [
                "borderTopColor",
                "borderTopStyle",
                "borderTopWidth",
                "borderRightColor",
                "borderRightStyle",
                "borderRightWidth",
                "borderBottomColor",
                "borderBottomStyle",
                "borderBottomWidth",
                "borderLeftColor",
                "borderLeftStyle",
                "borderLeftWidth",
              ],
              borderBottom: [
                "borderBottomWidth",
                "borderBottomStyle",
                "borderBottomColor",
              ],
              borderColor: [
                "borderTopColor",
                "borderRightColor",
                "borderBottomColor",
                "borderLeftColor",
              ],
              borderLeft: [
                "borderLeftWidth",
                "borderLeftStyle",
                "borderLeftColor",
              ],
              borderRadius: [
                "borderTopLeftRadius",
                "borderTopRightRadius",
                "borderBottomRightRadius",
                "borderBottomLeftRadius",
              ],
              borderRight: [
                "borderRightWidth",
                "borderRightStyle",
                "borderRightColor",
              ],
              borderTop: ["borderTopWidth", "borderTopStyle", "borderTopColor"],
              borderWidth: [
                "borderTopWidth",
                "borderRightWidth",
                "borderBottomWidth",
                "borderLeftWidth",
              ],
              flex: ["flexGrow", "flexShrink", "flexBasis"],
              font: [
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontVariant",
                "fontWeight",
                "lineHeight",
              ],
              margin: [
                "marginTop",
                "marginRight",
                "marginBottom",
                "marginLeft",
              ],
              outline: ["outlineColor", "outlineStyle", "outlineWidth"],
              padding: [
                "paddingTop",
                "paddingRight",
                "paddingBottom",
                "paddingLeft",
              ],
            },
            a = document.createElementNS("http://www.w3.org/1999/xhtml", "div"),
            o = { thin: "1px", medium: "3px", thick: "5px" },
            l = {
              borderBottomWidth: o,
              borderLeftWidth: o,
              borderRightWidth: o,
              borderTopWidth: o,
              fontSize: {
                "xx-small": "60%",
                "x-small": "75%",
                small: "89%",
                medium: "100%",
                large: "120%",
                "x-large": "150%",
                "xx-large": "200%",
              },
              fontWeight: { normal: "400", bold: "700" },
              outlineWidth: o,
              textShadow: { none: "0px 0px 0px transparent" },
              boxShadow: { none: "0px 0px 0px 0px transparent" },
            };
          (e.convertToArrayForm = s),
            (e.normalizeKeyframes = function t(i) {
              if (null == i) return [];
              window.Symbol &&
                Symbol.iterator &&
                Array.prototype.from &&
                i[Symbol.iterator] &&
                (i = Array.from(i)),
                Array.isArray(i) || (i = s(i));
              for (
                var r = i.map(function (t) {
                    var i = {};
                    for (var s in t) {
                      var r = t[s];
                      if ("offset" == s) {
                        if (null != r) {
                          if (!isFinite((r = Number(r))))
                            throw TypeError(
                              "Keyframe offsets must be numbers."
                            );
                          if (r < 0 || r > 1)
                            throw TypeError(
                              "Keyframe offsets must be between 0 and 1."
                            );
                        }
                      } else if ("composite" == s) {
                        if ("add" == r || "accumulate" == r)
                          throw {
                            type: DOMException.NOT_SUPPORTED_ERR,
                            name: "NotSupportedError",
                            message: "add compositing is not supported",
                          };
                        if ("replace" != r)
                          throw TypeError("Invalid composite mode " + r + ".");
                      } else r = "easing" == s ? e.normalizeEasing(r) : "" + r;
                      n(s, r, i);
                    }
                    return (
                      void 0 == i.offset && (i.offset = null),
                      void 0 == i.easing && (i.easing = "linear"),
                      i
                    );
                  }),
                  a = !0,
                  o = -1 / 0,
                  l = 0;
                l < r.length;
                l++
              ) {
                var c = r[l].offset;
                if (null != c) {
                  if (c < o)
                    throw TypeError(
                      "Keyframes are not loosely sorted by offset. Sort or specify offsets."
                    );
                  o = c;
                } else a = !1;
              }
              return (
                (r = r.filter(function (e) {
                  return e.offset >= 0 && e.offset <= 1;
                })),
                a ||
                  (function e() {
                    var t = r.length;
                    null == r[t - 1].offset && (r[t - 1].offset = 1),
                      t > 1 && null == r[0].offset && (r[0].offset = 0);
                    for (var i = 0, n = r[0].offset, s = 1; s < t; s++) {
                      var a = r[s].offset;
                      if (null != a) {
                        for (var o = 1; o < s - i; o++)
                          r[i + o].offset = n + ((a - n) * o) / (s - i);
                        (i = s), (n = a);
                      }
                    }
                  })(),
                r
              );
            });
        })(i),
        (t = {}),
        ((e = i).isDeprecated = function (e, i, n, s) {
          var r = new Date(),
            a = new Date(i);
          return (
            a.setMonth(a.getMonth() + 3),
            !(
              r < a &&
              (e in t ||
                console.warn(
                  "Web Animations: " +
                    e +
                    " " +
                    (s ? "are" : "is") +
                    " deprecated and will stop working on " +
                    a.toDateString() +
                    ". " +
                    n
                ),
              (t[e] = !0),
              1)
            )
          );
        }),
        (e.deprecated = function (t, i, n, s) {
          if (e.isDeprecated(t, i, n, s))
            throw Error(
              t + " " + (s ? "are" : "is") + " no longer supported. " + n
            );
        }),
        (function () {
          if (document.documentElement.animate) {
            var e,
              t,
              s,
              r,
              a,
              o,
              l,
              c,
              h,
              d,
              u,
              p = document.documentElement.animate([], 0),
              m = !0;
            if (
              (p &&
                ((m = !1),
                "play|currentTime|pause|reverse|playbackRate|cancel|finish|startTime|playState"
                  .split("|")
                  .forEach(function (e) {
                    void 0 === p[e] && (m = !0);
                  })),
              !m)
            )
              return;
          }
          (e = i),
            ((t = n).convertEffectInput = function (i) {
              var n = (function e(t) {
                  for (var i = {}, n = 0; n < t.length; n++)
                    for (var s in t[n])
                      if ("offset" != s && "easing" != s && "composite" != s) {
                        var r = {
                          offset: t[n].offset,
                          easing: t[n].easing,
                          value: t[n][s],
                        };
                        (i[s] = i[s] || []), i[s].push(r);
                      }
                  for (var a in i) {
                    var o = i[a];
                    if (0 != o[0].offset || 1 != o[o.length - 1].offset)
                      throw {
                        type: DOMException.NOT_SUPPORTED_ERR,
                        name: "NotSupportedError",
                        message: "Partial keyframes are not supported",
                      };
                  }
                  return i;
                })(e.normalizeKeyframes(i)),
                s = (function i(n) {
                  var s = [];
                  for (var r in n)
                    for (var a = n[r], o = 0; o < a.length - 1; o++) {
                      var l = o,
                        c = o + 1,
                        h = a[l].offset,
                        d = a[c].offset,
                        u = h,
                        p = d;
                      0 == o && ((u = -1 / 0), 0 == d && (c = l)),
                        o == a.length - 2 && ((p = 1 / 0), 1 == h && (l = c)),
                        s.push({
                          applyFrom: u,
                          applyTo: p,
                          startOffset: a[l].offset,
                          endOffset: a[c].offset,
                          easingFunction: e.parseEasingFunction(a[l].easing),
                          property: r,
                          interpolation: t.propertyInterpolation(
                            r,
                            a[l].value,
                            a[c].value
                          ),
                        });
                    }
                  return (
                    s.sort(function (e, t) {
                      return e.startOffset - t.startOffset;
                    }),
                    s
                  );
                })(n);
              return function (e, i) {
                if (null != i)
                  s.filter(function (e) {
                    return i >= e.applyFrom && i < e.applyTo;
                  }).forEach(function (n) {
                    var s = i - n.startOffset,
                      r = n.endOffset - n.startOffset,
                      a = 0 == r ? 0 : n.easingFunction(s / r);
                    t.apply(e, n.property, n.interpolation(a));
                  });
                else
                  for (var r in n)
                    "offset" != r &&
                      "easing" != r &&
                      "composite" != r &&
                      t.clear(e, r);
              };
            }),
            (function (e, t, i) {
              function n(e) {
                return e.replace(/-(.)/g, function (e, t) {
                  return t.toUpperCase();
                });
              }
              function s(e, t, i) {
                (r[i] = r[i] || []), r[i].push([e, t]);
              }
              var r = {};
              t.addPropertiesHandler = function e(t, i, r) {
                for (var a = 0; a < r.length; a++) s(t, i, n(r[a]));
              };
              var a = {
                backgroundColor: "transparent",
                backgroundPosition: "0% 0%",
                borderBottomColor: "currentColor",
                borderBottomLeftRadius: "0px",
                borderBottomRightRadius: "0px",
                borderBottomWidth: "3px",
                borderLeftColor: "currentColor",
                borderLeftWidth: "3px",
                borderRightColor: "currentColor",
                borderRightWidth: "3px",
                borderSpacing: "2px",
                borderTopColor: "currentColor",
                borderTopLeftRadius: "0px",
                borderTopRightRadius: "0px",
                borderTopWidth: "3px",
                bottom: "auto",
                clip: "rect(0px, 0px, 0px, 0px)",
                color: "black",
                fontSize: "100%",
                fontWeight: "400",
                height: "auto",
                left: "auto",
                letterSpacing: "normal",
                lineHeight: "120%",
                marginBottom: "0px",
                marginLeft: "0px",
                marginRight: "0px",
                marginTop: "0px",
                maxHeight: "none",
                maxWidth: "none",
                minHeight: "0px",
                minWidth: "0px",
                opacity: "1.0",
                outlineColor: "invert",
                outlineOffset: "0px",
                outlineWidth: "3px",
                paddingBottom: "0px",
                paddingLeft: "0px",
                paddingRight: "0px",
                paddingTop: "0px",
                right: "auto",
                strokeDasharray: "none",
                strokeDashoffset: "0px",
                textIndent: "0px",
                textShadow: "0px 0px 0px transparent",
                top: "auto",
                transform: "",
                verticalAlign: "0px",
                visibility: "visible",
                width: "auto",
                wordSpacing: "normal",
                zIndex: "auto",
              };
              t.propertyInterpolation = function i(s, o, l) {
                var c = s;
                /-/.test(s) &&
                  !e.isDeprecated(
                    "Hyphenated property names",
                    "2016-03-22",
                    "Use camelCase instead.",
                    !0
                  ) &&
                  (c = n(s)),
                  ("initial" != o && "initial" != l) ||
                    ("initial" == o && (o = a[c]),
                    "initial" == l && (l = a[c]));
                for (
                  var h = o == l ? [] : r[c], d = 0;
                  h && d < h.length;
                  d++
                ) {
                  var u = h[d][0](o),
                    p = h[d][0](l);
                  if (void 0 !== u && void 0 !== p) {
                    var m = h[d][1](u, p);
                    if (m) {
                      var f = t.Interpolation.apply(null, m);
                      return function (e) {
                        return 0 == e ? o : 1 == e ? l : f(e);
                      };
                    }
                  }
                }
                return t.Interpolation(!1, !0, function (e) {
                  return e ? l : o;
                });
              };
            })(i, n),
            (s = i),
            ((r = n).KeyframeEffect = function (e, t, i, n) {
              var a,
                o,
                l,
                c,
                h =
                  ((a = s.normalizeTimingInput(i)),
                  (o = s.calculateActiveDuration(a)),
                  ((l = function (e) {
                    return s.calculateIterationProgress(o, e, a);
                  })._totalDuration = a.delay + o + a.endDelay),
                  l),
                d = r.convertEffectInput(t),
                u = function () {
                  d(e, c);
                };
              return (
                (u._update = function (e) {
                  return null !== (c = h(e));
                }),
                (u._clear = function () {
                  d(e, null);
                }),
                (u._hasSameTarget = function (t) {
                  return e === t;
                }),
                (u._target = e),
                (u._totalDuration = h._totalDuration),
                (u._id = n),
                u
              );
            }),
            (function (e, t) {
              function i(e, t, i) {
                (i.enumerable = !0),
                  (i.configurable = !0),
                  Object.defineProperty(e, t, i);
              }
              function n(e) {
                var t, i;
                (this._element = e),
                  (this._surrogateStyle = document.createElementNS(
                    "http://www.w3.org/1999/xhtml",
                    "div"
                  ).style),
                  (this._style = e.style),
                  (this._length = 0),
                  (this._isAnimatedProperty = {}),
                  (this._updateSvgTransformAttr =
                    ((t = window),
                    !(
                      !(i = e).namespaceURI ||
                      -1 == i.namespaceURI.indexOf("/svg")
                    ) &&
                      (s in t ||
                        (t[s] = /Trident|MSIE|IEMobile|Edge|Android 4/i.test(
                          t.navigator.userAgent
                        )),
                      t[s]))),
                  (this._savedTransformAttr = null);
                for (var n = 0; n < this._style.length; n++) {
                  var r = this._style[n];
                  this._surrogateStyle[r] = this._style[r];
                }
                this._updateIndices();
              }
              var s = "_webAnimationsUpdateSvgTransformAttr",
                r = { cssText: 1, length: 1, parentRule: 1 },
                a = {
                  getPropertyCSSValue: 1,
                  getPropertyPriority: 1,
                  getPropertyValue: 1,
                  item: 1,
                  removeProperty: 1,
                  setProperty: 1,
                },
                o = { removeProperty: 1, setProperty: 1 };
              for (var l in ((n.prototype = {
                get cssText() {
                  return this._surrogateStyle.cssText;
                },
                set cssText(a3) {
                  for (var c = {}, h = 0; h < this._surrogateStyle.length; h++)
                    c[this._surrogateStyle[h]] = !0;
                  (this._surrogateStyle.cssText = a3), this._updateIndices();
                  for (var h = 0; h < this._surrogateStyle.length; h++)
                    c[this._surrogateStyle[h]] = !0;
                  for (var d in c)
                    this._isAnimatedProperty[d] ||
                      this._style.setProperty(
                        d,
                        this._surrogateStyle.getPropertyValue(d)
                      );
                },
                get length() {
                  return this._surrogateStyle.length;
                },
                get parentRule() {
                  return this._style.parentRule;
                },
                _updateIndices: function () {
                  for (; this._length < this._surrogateStyle.length; )
                    Object.defineProperty(this, this._length, {
                      configurable: !0,
                      enumerable: !1,
                      get: (function (e) {
                        return function () {
                          return this._surrogateStyle[e];
                        };
                      })(this._length),
                    }),
                      this._length++;
                  for (; this._length > this._surrogateStyle.length; )
                    this._length--,
                      Object.defineProperty(this, this._length, {
                        configurable: !0,
                        enumerable: !1,
                        value: void 0,
                      });
                },
                _set: function (t, i) {
                  (this._style[t] = i),
                    (this._isAnimatedProperty[t] = !0),
                    this._updateSvgTransformAttr &&
                      "transform" == e.unprefixedPropertyName(t) &&
                      (null == this._savedTransformAttr &&
                        (this._savedTransformAttr =
                          this._element.getAttribute("transform")),
                      this._element.setAttribute(
                        "transform",
                        e.transformToSvgMatrix(i)
                      ));
                },
                _clear: function (t) {
                  (this._style[t] = this._surrogateStyle[t]),
                    this._updateSvgTransformAttr &&
                      "transform" == e.unprefixedPropertyName(t) &&
                      (this._savedTransformAttr
                        ? this._element.setAttribute(
                            "transform",
                            this._savedTransformAttr
                          )
                        : this._element.removeAttribute("transform"),
                      (this._savedTransformAttr = null)),
                    delete this._isAnimatedProperty[t];
                },
              }),
              a))
                n.prototype[l] = (function (e, t) {
                  return function () {
                    var i = this._surrogateStyle[e].apply(
                      this._surrogateStyle,
                      arguments
                    );
                    return (
                      t &&
                        (this._isAnimatedProperty[arguments[0]] ||
                          this._style[e].apply(this._style, arguments),
                        this._updateIndices()),
                      i
                    );
                  };
                })(l, l in o);
              for (var u in document.documentElement.style)
                u in r ||
                  u in a ||
                  (function (e) {
                    i(n.prototype, e, {
                      get: function () {
                        return this._surrogateStyle[e];
                      },
                      set: function (t) {
                        (this._surrogateStyle[e] = t),
                          this._updateIndices(),
                          this._isAnimatedProperty[e] || (this._style[e] = t);
                      },
                    });
                  })(u);
              (e.apply = function (t, s, r) {
                (function e(t) {
                  if (!t._webAnimationsPatchedStyle) {
                    var s = new n(t);
                    try {
                      i(t, "style", {
                        get: function () {
                          return s;
                        },
                      });
                    } catch (r) {
                      (t.style._set = function (e, i) {
                        t.style[e] = i;
                      }),
                        (t.style._clear = function (e) {
                          t.style[e] = "";
                        });
                    }
                    t._webAnimationsPatchedStyle = t.style;
                  }
                })(t),
                  t.style._set(e.propertyName(s), r);
              }),
                (e.clear = function (t, i) {
                  t._webAnimationsPatchedStyle &&
                    t.style._clear(e.propertyName(i));
                });
            })(n),
            (a = n),
            (window.Element.prototype.animate = function (e, t) {
              var i = "";
              return (
                t && t.id && (i = t.id),
                a.timeline._play(a.KeyframeEffect(this, e, t, i))
              );
            }),
            (n.Interpolation = function (e, t, i) {
              return function (n) {
                return i(
                  (function e(t, i, n) {
                    if ("number" == typeof t && "number" == typeof i)
                      return t * (1 - n) + i * n;
                    if ("boolean" == typeof t && "boolean" == typeof i)
                      return n < 0.5 ? t : i;
                    if (t.length == i.length) {
                      for (var s = [], r = 0; r < t.length; r++)
                        s.push(e(t[r], i[r], n));
                      return s;
                    }
                    throw "Mismatched interpolation arguments " + t + ":" + i;
                  })(e, t, n)
                );
              };
            }),
            (l = n),
            (c = (function () {
              function e(e, t) {
                for (
                  var i = [
                      [0, 0, 0, 0],
                      [0, 0, 0, 0],
                      [0, 0, 0, 0],
                      [0, 0, 0, 0],
                    ],
                    n = 0;
                  n < 4;
                  n++
                )
                  for (var s = 0; s < 4; s++)
                    for (var r = 0; r < 4; r++) i[n][s] += t[n][r] * e[r][s];
                return i;
              }
              return function t(i, n, s, r, a) {
                for (
                  var o,
                    l = [
                      [1, 0, 0, 0],
                      [0, 1, 0, 0],
                      [0, 0, 1, 0],
                      [0, 0, 0, 1],
                    ],
                    c = 0;
                  c < 4;
                  c++
                )
                  l[c][3] = a[c];
                for (var c = 0; c < 3; c++)
                  for (var h = 0; h < 3; h++) l[3][c] += i[h] * l[h][c];
                var d = r[0],
                  u = r[1],
                  p = r[2],
                  m = r[3],
                  f = [
                    [1, 0, 0, 0],
                    [0, 1, 0, 0],
                    [0, 0, 1, 0],
                    [0, 0, 0, 1],
                  ];
                (f[0][0] = 1 - 2 * (u * u + p * p)),
                  (f[0][1] = 2 * (d * u - p * m)),
                  (f[0][2] = 2 * (d * p + u * m)),
                  (f[1][0] = 2 * (d * u + p * m)),
                  (f[1][1] = 1 - 2 * (d * d + p * p)),
                  (f[1][2] = 2 * (u * p - d * m)),
                  (f[2][0] = 2 * (d * p - u * m)),
                  (f[2][1] = 2 * (u * p + d * m)),
                  (f[2][2] = 1 - 2 * (d * d + u * u)),
                  (l = e(l, f));
                var $ = [
                  [1, 0, 0, 0],
                  [0, 1, 0, 0],
                  [0, 0, 1, 0],
                  [0, 0, 0, 1],
                ];
                s[2] && (($[2][1] = s[2]), (l = e(l, $))),
                  s[1] && (($[2][1] = 0), ($[2][0] = s[0]), (l = e(l, $))),
                  s[0] && (($[2][0] = 0), ($[1][0] = s[0]), (l = e(l, $)));
                for (var c = 0; c < 3; c++)
                  for (var h = 0; h < 3; h++) l[c][h] *= n[c];
                return 0 == (o = l)[0][2] &&
                  0 == o[0][3] &&
                  0 == o[1][2] &&
                  0 == o[1][3] &&
                  0 == o[2][0] &&
                  0 == o[2][1] &&
                  1 == o[2][2] &&
                  0 == o[2][3] &&
                  0 == o[3][2] &&
                  1 == o[3][3]
                  ? [l[0][0], l[0][1], l[1][0], l[1][1], l[3][0], l[3][1]]
                  : l[0].concat(l[1], l[2], l[3]);
              };
            })()),
            (l.composeMatrix = c),
            (l.quat = function e(t, i, n) {
              var s,
                r = l.dot(t, i);
              r = Math.max(Math.min((s = r), 1), -1);
              var a = [];
              if (1 === r) a = t;
              else
                for (
                  var o = Math.acos(r),
                    c = (1 * Math.sin(n * o)) / Math.sqrt(1 - r * r),
                    h = 0;
                  h < 4;
                  h++
                )
                  a.push(t[h] * (Math.cos(n * o) - r * c) + i[h] * c);
              return a;
            }),
            (h = i),
            (d = n),
            (h.sequenceNumber = 0),
            (u = function (e, t, i) {
              (this.target = e),
                (this.currentTime = t),
                (this.timelineTime = i),
                (this.type = "finish"),
                (this.bubbles = !1),
                (this.cancelable = !1),
                (this.currentTarget = e),
                (this.defaultPrevented = !1),
                (this.eventPhase = Event.AT_TARGET),
                (this.timeStamp = Date.now());
            }),
            (d.Animation = function (e) {
              (this.id = ""),
                e && e._id && (this.id = e._id),
                (this._sequenceNumber = h.sequenceNumber++),
                (this._currentTime = 0),
                (this._startTime = null),
                (this._paused = !1),
                (this._playbackRate = 1),
                (this._inTimeline = !0),
                (this._finishedFlag = !0),
                (this.onfinish = null),
                (this._finishHandlers = []),
                (this._effect = e),
                (this._inEffect = this._effect._update(0)),
                (this._idle = !0),
                (this._currentTimePending = !1);
            }),
            (d.Animation.prototype = {
              _ensureAlive: function () {
                this.playbackRate < 0 && 0 === this.currentTime
                  ? (this._inEffect = this._effect._update(-1))
                  : (this._inEffect = this._effect._update(this.currentTime)),
                  this._inTimeline ||
                    (!this._inEffect && this._finishedFlag) ||
                    ((this._inTimeline = !0),
                    d.timeline._animations.push(this));
              },
              _tickCurrentTime: function (e, t) {
                e != this._currentTime &&
                  ((this._currentTime = e),
                  this._isFinished &&
                    !t &&
                    (this._currentTime =
                      this._playbackRate > 0 ? this._totalDuration : 0),
                  this._ensureAlive());
              },
              get currentTime() {
                return this._idle || this._currentTimePending
                  ? null
                  : this._currentTime;
              },
              set currentTime(a3) {
                isNaN((a3 = +a3)) ||
                  (d.restart(),
                  this._paused ||
                    null == this._startTime ||
                    (this._startTime =
                      this._timeline.currentTime - a3 / this._playbackRate),
                  (this._currentTimePending = !1),
                  this._currentTime != a3 &&
                    (this._idle && ((this._idle = !1), (this._paused = !0)),
                    this._tickCurrentTime(a3, !0),
                    d.applyDirtiedAnimation(this)));
              },
              get startTime() {
                return this._startTime;
              },
              set startTime(a3) {
                isNaN((a3 = +a3)) ||
                  this._paused ||
                  this._idle ||
                  ((this._startTime = a3),
                  this._tickCurrentTime(
                    (this._timeline.currentTime - this._startTime) *
                      this.playbackRate
                  ),
                  d.applyDirtiedAnimation(this));
              },
              get playbackRate() {
                return this._playbackRate;
              },
              set playbackRate(a3) {
                if (a3 != this._playbackRate) {
                  var f = this.currentTime;
                  (this._playbackRate = a3),
                    (this._startTime = null),
                    "paused" != this.playState &&
                      "idle" != this.playState &&
                      ((this._finishedFlag = !1),
                      (this._idle = !1),
                      this._ensureAlive(),
                      d.applyDirtiedAnimation(this)),
                    null != f && (this.currentTime = f);
                }
              },
              get _isFinished() {
                return (
                  !this._idle &&
                  ((this._playbackRate > 0 &&
                    this._currentTime >= this._totalDuration) ||
                    (this._playbackRate < 0 && this._currentTime <= 0))
                );
              },
              get _totalDuration() {
                return this._effect._totalDuration;
              },
              get playState() {
                return this._idle
                  ? "idle"
                  : (null == this._startTime &&
                      !this._paused &&
                      0 != this.playbackRate) ||
                    this._currentTimePending
                  ? "pending"
                  : this._paused
                  ? "paused"
                  : this._isFinished
                  ? "finished"
                  : "running";
              },
              _rewind: function () {
                if (this._playbackRate >= 0) this._currentTime = 0;
                else {
                  if (!(this._totalDuration < 1 / 0))
                    throw new DOMException(
                      "Unable to rewind negative playback rate animation with infinite duration",
                      "InvalidStateError"
                    );
                  this._currentTime = this._totalDuration;
                }
              },
              play: function () {
                (this._paused = !1),
                  (this._isFinished || this._idle) &&
                    (this._rewind(), (this._startTime = null)),
                  (this._finishedFlag = !1),
                  (this._idle = !1),
                  this._ensureAlive(),
                  d.applyDirtiedAnimation(this);
              },
              pause: function () {
                this._isFinished || this._paused || this._idle
                  ? this._idle && (this._rewind(), (this._idle = !1))
                  : (this._currentTimePending = !0),
                  (this._startTime = null),
                  (this._paused = !0);
              },
              finish: function () {
                this._idle ||
                  ((this.currentTime =
                    this._playbackRate > 0 ? this._totalDuration : 0),
                  (this._startTime = this._totalDuration - this.currentTime),
                  (this._currentTimePending = !1),
                  d.applyDirtiedAnimation(this));
              },
              cancel: function () {
                this._inEffect &&
                  ((this._inEffect = !1),
                  (this._idle = !0),
                  (this._paused = !1),
                  (this._finishedFlag = !0),
                  (this._currentTime = 0),
                  (this._startTime = null),
                  this._effect._update(null),
                  d.applyDirtiedAnimation(this));
              },
              reverse: function () {
                (this.playbackRate *= -1), this.play();
              },
              addEventListener: function (e, t) {
                "function" == typeof t &&
                  "finish" == e &&
                  this._finishHandlers.push(t);
              },
              removeEventListener: function (e, t) {
                if ("finish" == e) {
                  var i = this._finishHandlers.indexOf(t);
                  i >= 0 && this._finishHandlers.splice(i, 1);
                }
              },
              _fireEvents: function (e) {
                if (this._isFinished) {
                  if (!this._finishedFlag) {
                    var t = new u(this, this._currentTime, e),
                      i = this._finishHandlers.concat(
                        this.onfinish ? [this.onfinish] : []
                      );
                    setTimeout(function () {
                      i.forEach(function (e) {
                        e.call(t.target, t);
                      });
                    }, 0),
                      (this._finishedFlag = !0);
                  }
                } else this._finishedFlag = !1;
              },
              _tick: function (e, t) {
                this._idle ||
                  this._paused ||
                  (null == this._startTime
                    ? t &&
                      (this.startTime =
                        e - this._currentTime / this.playbackRate)
                    : this._isFinished ||
                      this._tickCurrentTime(
                        (e - this._startTime) * this.playbackRate
                      )),
                  t && ((this._currentTimePending = !1), this._fireEvents(e));
              },
              get _needsTick() {
                return (
                  this.playState in { pending: 1, running: 1 } ||
                  !this._finishedFlag
                );
              },
              _targetAnimations: function () {
                var e = this._effect._target;
                return (
                  e._activeAnimations || (e._activeAnimations = []),
                  e._activeAnimations
                );
              },
              _markTarget: function () {
                var e = this._targetAnimations();
                -1 === e.indexOf(this) && e.push(this);
              },
              _unmarkTarget: function () {
                var e = this._targetAnimations(),
                  t = e.indexOf(this);
                -1 !== t && e.splice(t, 1);
              },
            }),
            (function (e, t, i) {
              function n(e) {
                var t = c;
                (c = []),
                  e < $.currentTime && (e = $.currentTime),
                  $._animations.sort(s),
                  ($._animations = o(e, !0, $._animations)[0]),
                  t.forEach(function (t) {
                    t[1](e);
                  }),
                  a(),
                  (d = void 0);
              }
              function s(e, t) {
                return e._sequenceNumber - t._sequenceNumber;
              }
              function r() {
                (this._animations = []),
                  (this.currentTime =
                    window.performance && performance.now
                      ? performance.now()
                      : 0);
              }
              function a() {
                m.forEach(function (e) {
                  e();
                }),
                  (m.length = 0);
              }
              function o(e, i, n) {
                (f = !0), (p = !1), (t.timeline.currentTime = e), (u = !1);
                var s = [],
                  r = [],
                  a = [],
                  o = [];
                return (
                  n.forEach(function (t) {
                    t._tick(e, i),
                      t._inEffect
                        ? (r.push(t._effect), t._markTarget())
                        : (s.push(t._effect), t._unmarkTarget()),
                      t._needsTick && (u = !0);
                    var n = t._inEffect || t._needsTick;
                    (t._inTimeline = n), n ? a.push(t) : o.push(t);
                  }),
                  m.push.apply(m, s),
                  m.push.apply(m, r),
                  u && requestAnimationFrame(function () {}),
                  (f = !1),
                  [a, o]
                );
              }
              var l = window.requestAnimationFrame,
                c = [],
                h = 0;
              (window.requestAnimationFrame = function (e) {
                var t = h++;
                return 0 == c.length && l(n), c.push([t, e]), t;
              }),
                (window.cancelAnimationFrame = function (e) {
                  c.forEach(function (t) {
                    t[0] == e && (t[1] = function () {});
                  });
                }),
                (r.prototype = {
                  _play: function (i) {
                    i._timing = e.normalizeTimingInput(i.timing);
                    var n = new t.Animation(i);
                    return (
                      (n._idle = !1),
                      (n._timeline = this),
                      this._animations.push(n),
                      t.restart(),
                      t.applyDirtiedAnimation(n),
                      n
                    );
                  },
                });
              var d = void 0,
                u = !1,
                p = !1;
              (t.restart = function () {
                return (
                  u ||
                    ((u = !0), requestAnimationFrame(function () {}), (p = !0)),
                  p
                );
              }),
                (t.applyDirtiedAnimation = function (e) {
                  if (!f) {
                    e._markTarget();
                    var i = e._targetAnimations();
                    i.sort(s),
                      o(t.timeline.currentTime, !1, i.slice())[1].forEach(
                        function (e) {
                          var t = $._animations.indexOf(e);
                          -1 !== t && $._animations.splice(t, 1);
                        }
                      ),
                      a();
                  }
                });
              var m = [],
                f = !1,
                $ = new r();
              t.timeline = $;
            })(i, n),
            (function (e, t) {
              function i(e, t) {
                for (var i = 0, n = 0; n < e.length; n++) i += e[n] * t[n];
                return i;
              }
              function n(e, t) {
                return [
                  e[0] * t[0] + e[4] * t[1] + e[8] * t[2] + e[12] * t[3],
                  e[1] * t[0] + e[5] * t[1] + e[9] * t[2] + e[13] * t[3],
                  e[2] * t[0] + e[6] * t[1] + e[10] * t[2] + e[14] * t[3],
                  e[3] * t[0] + e[7] * t[1] + e[11] * t[2] + e[15] * t[3],
                  e[0] * t[4] + e[4] * t[5] + e[8] * t[6] + e[12] * t[7],
                  e[1] * t[4] + e[5] * t[5] + e[9] * t[6] + e[13] * t[7],
                  e[2] * t[4] + e[6] * t[5] + e[10] * t[6] + e[14] * t[7],
                  e[3] * t[4] + e[7] * t[5] + e[11] * t[6] + e[15] * t[7],
                  e[0] * t[8] + e[4] * t[9] + e[8] * t[10] + e[12] * t[11],
                  e[1] * t[8] + e[5] * t[9] + e[9] * t[10] + e[13] * t[11],
                  e[2] * t[8] + e[6] * t[9] + e[10] * t[10] + e[14] * t[11],
                  e[3] * t[8] + e[7] * t[9] + e[11] * t[10] + e[15] * t[11],
                  e[0] * t[12] + e[4] * t[13] + e[8] * t[14] + e[12] * t[15],
                  e[1] * t[12] + e[5] * t[13] + e[9] * t[14] + e[13] * t[15],
                  e[2] * t[12] + e[6] * t[13] + e[10] * t[14] + e[14] * t[15],
                  e[3] * t[12] + e[7] * t[13] + e[11] * t[14] + e[15] * t[15],
                ];
              }
              function s(e) {
                var t = e.rad || 0;
                return (
                  ((e.deg || 0) / 360 + (e.grad || 0) / 400 + (e.turn || 0)) *
                    (2 * Math.PI) +
                  t
                );
              }
              function r(e) {
                switch (e.t) {
                  case "rotatex":
                    var t = s(e.d[0]);
                    return [
                      1,
                      0,
                      0,
                      0,
                      0,
                      Math.cos(t),
                      Math.sin(t),
                      0,
                      0,
                      -Math.sin(t),
                      Math.cos(t),
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "rotatey":
                    var t = s(e.d[0]);
                    return [
                      Math.cos(t),
                      0,
                      -Math.sin(t),
                      0,
                      0,
                      1,
                      0,
                      0,
                      Math.sin(t),
                      0,
                      Math.cos(t),
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "rotate":
                  case "rotatez":
                    var t = s(e.d[0]);
                    return [
                      Math.cos(t),
                      Math.sin(t),
                      0,
                      0,
                      -Math.sin(t),
                      Math.cos(t),
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "rotate3d":
                    var i = e.d[0],
                      n = e.d[1],
                      r = e.d[2],
                      t = s(e.d[3]),
                      a = i * i + n * n + r * r;
                    if (0 === a) (i = 1), (n = 0), (r = 0);
                    else if (1 !== a) {
                      var o = Math.sqrt(a);
                      (i /= o), (n /= o), (r /= o);
                    }
                    var l = Math.sin(t / 2),
                      c = l * Math.cos(t / 2),
                      h = l * l;
                    return [
                      1 - 2 * (n * n + r * r) * h,
                      2 * (i * n * h + r * c),
                      2 * (i * r * h - n * c),
                      0,
                      2 * (i * n * h - r * c),
                      1 - 2 * (i * i + r * r) * h,
                      2 * (n * r * h + i * c),
                      0,
                      2 * (i * r * h + n * c),
                      2 * (n * r * h - i * c),
                      1 - 2 * (i * i + n * n) * h,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "scale":
                    return [
                      e.d[0],
                      0,
                      0,
                      0,
                      0,
                      e.d[1],
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "scalex":
                    return [
                      e.d[0],
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "scaley":
                    return [
                      1,
                      0,
                      0,
                      0,
                      0,
                      e.d[0],
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "scalez":
                    return [
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      e.d[0],
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "scale3d":
                    return [
                      e.d[0],
                      0,
                      0,
                      0,
                      0,
                      e.d[1],
                      0,
                      0,
                      0,
                      0,
                      e.d[2],
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "skew":
                    var d = s(e.d[0]);
                    return [
                      1,
                      Math.tan(s(e.d[1])),
                      0,
                      0,
                      Math.tan(d),
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "skewx":
                    var t = s(e.d[0]);
                    return [
                      1,
                      0,
                      0,
                      0,
                      Math.tan(t),
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "skewy":
                    var t = s(e.d[0]);
                    return [
                      1,
                      Math.tan(t),
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "translate":
                    var i = e.d[0].px || 0,
                      n = e.d[1].px || 0;
                    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, i, n, 0, 1];
                  case "translatex":
                    var i = e.d[0].px || 0;
                    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, i, 0, 0, 1];
                  case "translatey":
                    var n = e.d[0].px || 0;
                    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, n, 0, 1];
                  case "translatez":
                    var r = e.d[0].px || 0;
                    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, r, 1];
                  case "translate3d":
                    var i = e.d[0].px || 0,
                      n = e.d[1].px || 0,
                      r = e.d[2].px || 0;
                    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, i, n, r, 1];
                  case "perspective":
                    return [
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      0,
                      0,
                      0,
                      1,
                      e.d[0].px ? -1 / e.d[0].px : 0,
                      0,
                      0,
                      0,
                      1,
                    ];
                  case "matrix":
                    return [
                      e.d[0],
                      e.d[1],
                      0,
                      0,
                      e.d[2],
                      e.d[3],
                      0,
                      0,
                      0,
                      0,
                      1,
                      0,
                      e.d[4],
                      e.d[5],
                      0,
                      1,
                    ];
                  case "matrix3d":
                    return e.d;
                }
              }
              function a(e) {
                return 0 === e.length
                  ? [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
                  : e.map(r).reduce(n);
              }
              var o = (function () {
                function e(e) {
                  return (
                    e[0][0] * e[1][1] * e[2][2] +
                    e[1][0] * e[2][1] * e[0][2] +
                    e[2][0] * e[0][1] * e[1][2] -
                    e[0][2] * e[1][1] * e[2][0] -
                    e[1][2] * e[2][1] * e[0][0] -
                    e[2][2] * e[0][1] * e[1][0]
                  );
                }
                function t(e) {
                  var t = n(e);
                  return [e[0] / t, e[1] / t, e[2] / t];
                }
                function n(e) {
                  return Math.sqrt(e[0] * e[0] + e[1] * e[1] + e[2] * e[2]);
                }
                function s(e, t, i, n) {
                  return [
                    i * e[0] + n * t[0],
                    i * e[1] + n * t[1],
                    i * e[2] + n * t[2],
                  ];
                }
                return function r(a) {
                  var o = [
                    a.slice(0, 4),
                    a.slice(4, 8),
                    a.slice(8, 12),
                    a.slice(12, 16),
                  ];
                  if (1 !== o[3][3]) return null;
                  for (var l = [], c = 0; c < 4; c++) l.push(o[c].slice());
                  for (var c = 0; c < 3; c++) l[c][3] = 0;
                  if (0 === e(l)) return null;
                  var h,
                    d,
                    u = [];
                  o[0][3] || o[1][3] || o[2][3]
                    ? (u.push(o[0][3]),
                      u.push(o[1][3]),
                      u.push(o[2][3]),
                      u.push(o[3][3]),
                      (h = (function e(t, i) {
                        for (var n = [], s = 0; s < 4; s++) {
                          for (var r = 0, a = 0; a < 4; a++)
                            r += t[a] * i[a][s];
                          n.push(r);
                        }
                        return n;
                      })(u, [
                        [
                          (d = (function t(i) {
                            for (
                              var n = 1 / e(i),
                                s = i[0][0],
                                r = i[0][1],
                                a = i[0][2],
                                o = i[1][0],
                                l = i[1][1],
                                c = i[1][2],
                                h = i[2][0],
                                d = i[2][1],
                                u = i[2][2],
                                p = [
                                  [
                                    (l * u - c * d) * n,
                                    (a * d - r * u) * n,
                                    (r * c - a * l) * n,
                                    0,
                                  ],
                                  [
                                    (c * h - o * u) * n,
                                    (s * u - a * h) * n,
                                    (a * o - s * c) * n,
                                    0,
                                  ],
                                  [
                                    (o * d - l * h) * n,
                                    (h * r - s * d) * n,
                                    (s * l - r * o) * n,
                                    0,
                                  ],
                                ],
                                m = [],
                                f = 0;
                              f < 3;
                              f++
                            ) {
                              for (var $ = 0, g = 0; g < 3; g++)
                                $ += i[3][g] * p[g][f];
                              m.push($);
                            }
                            return m.push(1), p.push(m), p;
                          })(l))[0][0],
                          d[1][0],
                          d[2][0],
                          d[3][0],
                        ],
                        [d[0][1], d[1][1], d[2][1], d[3][1]],
                        [d[0][2], d[1][2], d[2][2], d[3][2]],
                        [d[0][3], d[1][3], d[2][3], d[3][3]],
                      ])))
                    : (h = [0, 0, 0, 1]);
                  var p = o[3].slice(0, 3),
                    m = [];
                  m.push(o[0].slice(0, 3));
                  var f = [];
                  f.push(n(m[0])), (m[0] = t(m[0]));
                  var $,
                    g,
                    b = [];
                  m.push(o[1].slice(0, 3)),
                    b.push(i(m[0], m[1])),
                    (m[1] = s(m[1], m[0], 1, -b[0])),
                    f.push(n(m[1])),
                    (m[1] = t(m[1])),
                    (b[0] /= f[1]),
                    m.push(o[2].slice(0, 3)),
                    b.push(i(m[0], m[2])),
                    (m[2] = s(m[2], m[0], 1, -b[1])),
                    b.push(i(m[1], m[2])),
                    (m[2] = s(m[2], m[1], 1, -b[2])),
                    f.push(n(m[2])),
                    (m[2] = t(m[2])),
                    (b[1] /= f[2]),
                    (b[2] /= f[2]);
                  var v =
                    (($ = m[1]),
                    (g = m[2]),
                    [
                      $[1] * g[2] - $[2] * g[1],
                      $[2] * g[0] - $[0] * g[2],
                      $[0] * g[1] - $[1] * g[0],
                    ]);
                  if (0 > i(m[0], v))
                    for (var c = 0; c < 3; c++)
                      (f[c] *= -1),
                        (m[c][0] *= -1),
                        (m[c][1] *= -1),
                        (m[c][2] *= -1);
                  var y,
                    _,
                    w = m[0][0] + m[1][1] + m[2][2] + 1;
                  return (
                    w > 1e-4
                      ? ((y = 0.5 / Math.sqrt(w)),
                        (_ = [
                          (m[2][1] - m[1][2]) * y,
                          (m[0][2] - m[2][0]) * y,
                          (m[1][0] - m[0][1]) * y,
                          0.25 / y,
                        ]))
                      : m[0][0] > m[1][1] && m[0][0] > m[2][2]
                      ? (_ = [
                          0.25 *
                            (y =
                              2 * Math.sqrt(1 + m[0][0] - m[1][1] - m[2][2])),
                          (m[0][1] + m[1][0]) / y,
                          (m[0][2] + m[2][0]) / y,
                          (m[2][1] - m[1][2]) / y,
                        ])
                      : m[1][1] > m[2][2]
                      ? ((y = 2 * Math.sqrt(1 + m[1][1] - m[0][0] - m[2][2])),
                        (_ = [
                          (m[0][1] + m[1][0]) / y,
                          0.25 * y,
                          (m[1][2] + m[2][1]) / y,
                          (m[0][2] - m[2][0]) / y,
                        ]))
                      : ((y = 2 * Math.sqrt(1 + m[2][2] - m[0][0] - m[1][1])),
                        (_ = [
                          (m[0][2] + m[2][0]) / y,
                          (m[1][2] + m[2][1]) / y,
                          0.25 * y,
                          (m[1][0] - m[0][1]) / y,
                        ])),
                    [p, f, b, _, h]
                  );
                };
              })();
              (e.dot = i),
                (e.makeMatrixDecomposition = function e(t) {
                  return [o(a(t))];
                }),
                (e.transformListToMatrix = a);
            })(n),
            (function (e) {
              function t(e, t) {
                var i = e.exec(t);
                if (i)
                  return [
                    (i = e.ignoreCase ? i[0].toLowerCase() : i[0]),
                    t.substr(i.length),
                  ];
              }
              function i(e, t) {
                var i = e((t = t.replace(/^\s*/, "")));
                if (i) return [i[0], i[1].replace(/^\s*/, "")];
              }
              function n(e, t, i, n, s) {
                for (
                  var r = [],
                    a = [],
                    o = [],
                    l = (function e(t, i) {
                      for (var n = t, s = i; n && s; )
                        n > s ? (n %= s) : (s %= n);
                      return (t * i) / (n + s);
                    })(n.length, s.length),
                    c = 0;
                  c < l;
                  c++
                ) {
                  var h = t(n[c % n.length], s[c % s.length]);
                  if (!h) return;
                  r.push(h[0]), a.push(h[1]), o.push(h[2]);
                }
                return [
                  r,
                  a,
                  function (t) {
                    var n = t
                      .map(function (e, t) {
                        return o[t](e);
                      })
                      .join(i);
                    return e ? e(n) : n;
                  },
                ];
              }
              (e.consumeToken = t),
                (e.consumeTrimmed = i),
                (e.consumeRepeated = function e(n, s, r) {
                  n = i.bind(null, n);
                  for (var a = []; ; ) {
                    var o = n(r);
                    if (
                      !o ||
                      (a.push(o[0]), !(o = t(s, (r = o[1]))) || "" == o[1])
                    )
                      return [a, r];
                    r = o[1];
                  }
                }),
                (e.consumeParenthesised = function e(t, i) {
                  for (
                    var n = 0, s = 0;
                    s < i.length && (!/\s|,/.test(i[s]) || 0 != n);
                    s++
                  )
                    if ("(" == i[s]) n++;
                    else if (")" == i[s] && (0 == --n && s++, n <= 0)) break;
                  var r = t(i.substr(0, s));
                  return void 0 == r ? void 0 : [r, i.substr(s)];
                }),
                (e.ignore = function e(t) {
                  return function (e) {
                    var i = t(e);
                    return i && (i[0] = void 0), i;
                  };
                }),
                (e.optional = function e(t, i) {
                  return function (e) {
                    return t(e) || [i, e];
                  };
                }),
                (e.consumeList = function t(i, n) {
                  for (var s = [], r = 0; r < i.length; r++) {
                    var a = e.consumeTrimmed(i[r], n);
                    if (!a || "" == a[0]) return;
                    void 0 !== a[0] && s.push(a[0]), (n = a[1]);
                  }
                  if ("" == n) return s;
                }),
                (e.mergeNestedRepeated = n.bind(null, null)),
                (e.mergeWrappedNestedRepeated = n),
                (e.mergeList = function e(t, i, n) {
                  for (
                    var s = [], r = [], a = [], o = 0, l = 0;
                    l < n.length;
                    l++
                  )
                    if ("function" == typeof n[l]) {
                      var c = n[l](t[o], i[o++]);
                      s.push(c[0]), r.push(c[1]), a.push(c[2]);
                    } else
                      !(function (e) {
                        s.push(!1),
                          r.push(!1),
                          a.push(function () {
                            return n[e];
                          });
                      })(l);
                  return [
                    s,
                    r,
                    function (e) {
                      for (var t = "", i = 0; i < e.length; i++)
                        t += a[i](e[i]);
                      return t;
                    },
                  ];
                });
            })(n),
            (function (e) {
              function t(t) {
                var i = { inset: !1, lengths: [], color: null },
                  n = e.consumeRepeated(
                    function t(n) {
                      var s = e.consumeToken(/^inset/i, n);
                      return s
                        ? ((i.inset = !0), s)
                        : (s = e.consumeLengthOrPercent(n))
                        ? (i.lengths.push(s[0]), s)
                        : (s = e.consumeColor(n))
                        ? ((i.color = s[0]), s)
                        : void 0;
                    },
                    /^/,
                    t
                  );
                if (n && n[0].length) return [i, n[1]];
              }
              var i = function t(i, n, s, r) {
                function a(e) {
                  return {
                    inset: e,
                    color: [0, 0, 0, 0],
                    lengths: [{ px: 0 }, { px: 0 }, { px: 0 }, { px: 0 }],
                  };
                }
                for (
                  var o = [], l = [], c = 0;
                  c < s.length || c < r.length;
                  c++
                ) {
                  var h = s[c] || a(r[c].inset),
                    d = r[c] || a(s[c].inset);
                  o.push(h), l.push(d);
                }
                return e.mergeNestedRepeated(i, n, o, l);
              }.bind(
                null,
                function t(i, n) {
                  for (
                    ;
                    i.lengths.length <
                    Math.max(i.lengths.length, n.lengths.length);

                  )
                    i.lengths.push({ px: 0 });
                  for (
                    ;
                    n.lengths.length <
                    Math.max(i.lengths.length, n.lengths.length);

                  )
                    n.lengths.push({ px: 0 });
                  if (i.inset == n.inset && !!i.color == !!n.color) {
                    for (
                      var s, r = [], a = [[], 0], o = [[], 0], l = 0;
                      l < i.lengths.length;
                      l++
                    ) {
                      var c = e.mergeDimensions(
                        i.lengths[l],
                        n.lengths[l],
                        2 == l
                      );
                      a[0].push(c[0]), o[0].push(c[1]), r.push(c[2]);
                    }
                    if (i.color && n.color) {
                      var h = e.mergeColors(i.color, n.color);
                      (a[1] = h[0]), (o[1] = h[1]), (s = h[2]);
                    }
                    return [
                      a,
                      o,
                      function (e) {
                        for (
                          var t = i.inset ? "inset " : " ", n = 0;
                          n < r.length;
                          n++
                        )
                          t += r[n](e[0][n]) + " ";
                        return s && (t += s(e[1])), t;
                      },
                    ];
                  }
                },
                ", "
              );
              e.addPropertiesHandler(
                function i(n) {
                  var s = e.consumeRepeated(t, /^,/, n);
                  if (s && "" == s[1]) return s[0];
                },
                i,
                ["box-shadow", "text-shadow"]
              );
            })(n),
            (function (e, t) {
              function i(e) {
                return e.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
              }
              function n(e, t, i) {
                return Math.min(t, Math.max(e, i));
              }
              function s(e) {
                if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(e)) return Number(e);
              }
              function r(e, t) {
                return function (s, r) {
                  return [
                    s,
                    r,
                    function (s) {
                      return i(n(e, t, s));
                    },
                  ];
                };
              }
              function a(e) {
                var t = e.trim().split(/\s*[\s,]\s*/);
                if (0 !== t.length) {
                  for (var i = [], n = 0; n < t.length; n++) {
                    var r = s(t[n]);
                    if (void 0 === r) return;
                    i.push(r);
                  }
                  return i;
                }
              }
              (e.clamp = n),
                e.addPropertiesHandler(
                  a,
                  function e(t, n) {
                    if (t.length == n.length)
                      return [
                        t,
                        n,
                        function (e) {
                          return e.map(i).join(" ");
                        },
                      ];
                  },
                  ["stroke-dasharray"]
                ),
                e.addPropertiesHandler(s, r(0, 1 / 0), [
                  "border-image-width",
                  "line-height",
                ]),
                e.addPropertiesHandler(s, r(0, 1), [
                  "opacity",
                  "shape-image-threshold",
                ]),
                e.addPropertiesHandler(
                  s,
                  function e(t, i) {
                    if (0 != t) return r(0, 1 / 0)(t, i);
                  },
                  ["flex-grow", "flex-shrink"]
                ),
                e.addPropertiesHandler(
                  s,
                  function e(t, i) {
                    return [
                      t,
                      i,
                      function (e) {
                        return Math.round(n(1, 1 / 0, e));
                      },
                    ];
                  },
                  ["orphans", "widows"]
                ),
                e.addPropertiesHandler(
                  s,
                  function e(t, i) {
                    return [t, i, Math.round];
                  },
                  ["z-index"]
                ),
                (e.parseNumber = s),
                (e.parseNumberList = a),
                (e.mergeNumbers = function e(t, n) {
                  return [t, n, i];
                }),
                (e.numberToString = i);
            })(n),
            (function (e, t) {
              e.addPropertiesHandler(
                String,
                function e(t, i) {
                  if ("visible" == t || "visible" == i)
                    return [
                      0,
                      1,
                      function (e) {
                        return e <= 0 ? t : e >= 1 ? i : "visible";
                      },
                    ];
                },
                ["visibility"]
              );
            })(n),
            (function (e, t) {
              function i(e) {
                (e = e.trim()), (r.fillStyle = "#000"), (r.fillStyle = e);
                var t = r.fillStyle;
                if (
                  ((r.fillStyle = "#fff"), (r.fillStyle = e), t == r.fillStyle)
                ) {
                  r.fillRect(0, 0, 1, 1);
                  var i = r.getImageData(0, 0, 1, 1).data;
                  r.clearRect(0, 0, 1, 1);
                  var n = i[3] / 255;
                  return [i[0] * n, i[1] * n, i[2] * n, n];
                }
              }
              function n(t, i) {
                return [
                  t,
                  i,
                  function (t) {
                    function i(e) {
                      return Math.max(0, Math.min(255, e));
                    }
                    if (t[3])
                      for (var n = 0; n < 3; n++)
                        t[n] = Math.round(i(t[n] / t[3]));
                    return (
                      (t[3] = e.numberToString(e.clamp(0, 1, t[3]))),
                      "rgba(" + t.join(",") + ")"
                    );
                  },
                ];
              }
              var s = document.createElementNS(
                "http://www.w3.org/1999/xhtml",
                "canvas"
              );
              s.width = s.height = 1;
              var r = s.getContext("2d");
              e.addPropertiesHandler(i, n, [
                "background-color",
                "border-bottom-color",
                "border-left-color",
                "border-right-color",
                "border-top-color",
                "color",
                "fill",
                "flood-color",
                "lighting-color",
                "outline-color",
                "stop-color",
                "stroke",
                "text-decoration-color",
              ]),
                (e.consumeColor = e.consumeParenthesised.bind(null, i)),
                (e.mergeColors = n);
            })(n),
            (function (e, t) {
              function i(e) {
                function t() {
                  var t = a.exec(e);
                  r = t ? t[0] : void 0;
                }
                function i() {
                  if ("(" !== r) {
                    var e;
                    return (e = Number(r)), t(), e;
                  }
                  t();
                  var i = s();
                  return ")" !== r ? NaN : (t(), i);
                }
                function n() {
                  for (var e = i(); "*" === r || "/" === r; ) {
                    var n = r;
                    t();
                    var s = i();
                    "*" === n ? (e *= s) : (e /= s);
                  }
                  return e;
                }
                function s() {
                  for (var e = n(); "+" === r || "-" === r; ) {
                    var i = r;
                    t();
                    var s = n();
                    "+" === i ? (e += s) : (e -= s);
                  }
                  return e;
                }
                var r,
                  a = /([\+\-\w\.]+|[\(\)\*\/])/g;
                return t(), s();
              }
              function n(e, t) {
                if ("0" == (t = t.trim().toLowerCase()) && "px".search(e) >= 0)
                  return { px: 0 };
                if (/^[^(]*$|^calc/.test(t)) {
                  t = t.replace(/calc\(/g, "(");
                  var n = {};
                  t = t.replace(e, function (e) {
                    return (n[e] = null), "U" + e;
                  });
                  for (
                    var s = "U(" + e.source + ")",
                      r = t
                        .replace(/[-+]?(\d*\.)?\d+([Ee][-+]?\d+)?/g, "N")
                        .replace(RegExp("N" + s, "g"), "D")
                        .replace(/\s[+-]\s/g, "O")
                        .replace(/\s/g, ""),
                      a = [
                        /N\*(D)/g,
                        /(N|D)[*\/]N/g,
                        /(N|D)O\1/g,
                        /\((N|D)\)/g,
                      ],
                      o = 0;
                    o < a.length;

                  )
                    a[o].test(r) ? ((r = r.replace(a[o], "$1")), (o = 0)) : o++;
                  if ("D" == r) {
                    for (var l in n) {
                      var c = i(
                        t
                          .replace(RegExp("U" + l, "g"), "")
                          .replace(RegExp(s, "g"), "*0")
                      );
                      if (!isFinite(c)) return;
                      n[l] = c;
                    }
                    return n;
                  }
                }
              }
              function s(e, t) {
                return r(e, t, !0);
              }
              function r(t, i, n) {
                var s,
                  r = [];
                for (s in t) r.push(s);
                for (s in i) 0 > r.indexOf(s) && r.push(s);
                return [
                  (t = r.map(function (e) {
                    return t[e] || 0;
                  })),
                  (i = r.map(function (e) {
                    return i[e] || 0;
                  })),
                  function (t) {
                    var i = t
                      .map(function (i, s) {
                        return (
                          1 == t.length && n && (i = Math.max(i, 0)),
                          e.numberToString(i) + r[s]
                        );
                      })
                      .join(" + ");
                    return t.length > 1 ? "calc(" + i + ")" : i;
                  },
                ];
              }
              var a = "px|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc",
                o = n.bind(null, RegExp(a, "g")),
                l = n.bind(null, RegExp(a + "|%", "g")),
                c = n.bind(null, /deg|rad|grad|turn/g);
              (e.parseLength = o),
                (e.parseLengthOrPercent = l),
                (e.consumeLengthOrPercent = e.consumeParenthesised.bind(
                  null,
                  l
                )),
                (e.parseAngle = c),
                (e.mergeDimensions = r);
              var h = e.consumeParenthesised.bind(null, o),
                d = e.consumeRepeated.bind(void 0, h, /^/),
                u = e.consumeRepeated.bind(void 0, d, /^,/);
              e.consumeSizePairList = u;
              var p = function (e) {
                  var t = u(e);
                  if (t && "" == t[1]) return t[0];
                },
                m = e.mergeNestedRepeated.bind(void 0, s, " "),
                f = e.mergeNestedRepeated.bind(void 0, m, ",");
              (e.mergeNonNegativeSizePair = m),
                e.addPropertiesHandler(p, f, ["background-size"]),
                e.addPropertiesHandler(l, s, [
                  "border-bottom-width",
                  "border-image-width",
                  "border-left-width",
                  "border-right-width",
                  "border-top-width",
                  "flex-basis",
                  "font-size",
                  "height",
                  "line-height",
                  "max-height",
                  "max-width",
                  "outline-width",
                  "width",
                ]),
                e.addPropertiesHandler(l, r, [
                  "border-bottom-left-radius",
                  "border-bottom-right-radius",
                  "border-top-left-radius",
                  "border-top-right-radius",
                  "bottom",
                  "left",
                  "letter-spacing",
                  "margin-bottom",
                  "margin-left",
                  "margin-right",
                  "margin-top",
                  "min-height",
                  "min-width",
                  "outline-offset",
                  "padding-bottom",
                  "padding-left",
                  "padding-right",
                  "padding-top",
                  "perspective",
                  "right",
                  "shape-margin",
                  "stroke-dashoffset",
                  "text-indent",
                  "top",
                  "vertical-align",
                  "word-spacing",
                ]);
            })(n),
            (function (e, t) {
              function i(t) {
                return (
                  e.consumeLengthOrPercent(t) || e.consumeToken(/^auto/, t)
                );
              }
              function n(t) {
                var n = e.consumeList(
                  [
                    e.ignore(e.consumeToken.bind(null, /^rect/)),
                    e.ignore(e.consumeToken.bind(null, /^\(/)),
                    e.consumeRepeated.bind(null, i, /^,/),
                    e.ignore(e.consumeToken.bind(null, /^\)/)),
                  ],
                  t
                );
                if (n && 4 == n[0].length) return n[0];
              }
              var s = e.mergeWrappedNestedRepeated.bind(
                null,
                function e(t) {
                  return "rect(" + t + ")";
                },
                function t(i, n) {
                  return "auto" == i || "auto" == n
                    ? [
                        !0,
                        !1,
                        function (t) {
                          var s = t ? i : n;
                          if ("auto" == s) return "auto";
                          var r = e.mergeDimensions(s, s);
                          return r[2](r[0]);
                        },
                      ]
                    : e.mergeDimensions(i, n);
                },
                ", "
              );
              (e.parseBox = n),
                (e.mergeBoxes = s),
                e.addPropertiesHandler(n, s, ["clip"]);
            })(n),
            (function (e, t) {
              function i(e) {
                return function (t) {
                  var i = 0;
                  return e.map(function (e) {
                    return e === c ? t[i++] : e;
                  });
                };
              }
              function n(e) {
                return e;
              }
              function s(t) {
                if ("none" == (t = t.toLowerCase().trim())) return [];
                for (
                  var i, n = /\s*(\w+)\(([^)]*)\)/g, s = [], r = 0;
                  (i = n.exec(t));

                ) {
                  if (i.index != r) return;
                  r = i.index + i[0].length;
                  var a = i[1],
                    o = u[a];
                  if (!o) return;
                  var l = i[2].split(","),
                    c = o[0];
                  if (c.length < l.length) return;
                  for (var p = [], m = 0; m < c.length; m++) {
                    var f,
                      $ = l[m],
                      g = c[m];
                    if (
                      void 0 ===
                      (f = $
                        ? {
                            A: function (t) {
                              return "0" == t.trim() ? d : e.parseAngle(t);
                            },
                            N: e.parseNumber,
                            T: e.parseLengthOrPercent,
                            L: e.parseLength,
                          }[g.toUpperCase()]($)
                        : { a: d, n: p[0], t: h }[g])
                    )
                      return;
                    p.push(f);
                  }
                  if ((s.push({ t: a, d: p }), n.lastIndex == t.length))
                    return s;
                }
              }
              function r(e) {
                return e.toFixed(6).replace(".000000", "");
              }
              function a(t, i) {
                if (t.decompositionPair !== i) {
                  t.decompositionPair = i;
                  var n = e.makeMatrixDecomposition(t);
                }
                if (i.decompositionPair !== t) {
                  i.decompositionPair = t;
                  var s = e.makeMatrixDecomposition(i);
                }
                return null == n[0] || null == s[0]
                  ? [
                      [!1],
                      [!0],
                      function (e) {
                        return e ? i[0].d : t[0].d;
                      },
                    ]
                  : (n[0].push(0),
                    s[0].push(1),
                    [
                      n,
                      s,
                      function (t) {
                        var i = e.quat(n[0][3], s[0][3], t[5]);
                        return e
                          .composeMatrix(t[0], t[1], t[2], i, t[4])
                          .map(r)
                          .join(",");
                      },
                    ]);
              }
              function o(e) {
                return e.replace(/[xy]/, "");
              }
              function l(e) {
                return e.replace(/(x|y|z|3d)?$/, "3d");
              }
              var c = null,
                h = { px: 0 },
                d = { deg: 0 },
                u = {
                  matrix: [
                    "NNNNNN",
                    [c, c, 0, 0, c, c, 0, 0, 0, 0, 1, 0, c, c, 0, 1],
                    n,
                  ],
                  matrix3d: ["NNNNNNNNNNNNNNNN", n],
                  rotate: ["A"],
                  rotatex: ["A"],
                  rotatey: ["A"],
                  rotatez: ["A"],
                  rotate3d: ["NNNA"],
                  perspective: ["L"],
                  scale: ["Nn", i([c, c, 1]), n],
                  scalex: ["N", i([c, 1, 1]), i([c, 1])],
                  scaley: ["N", i([1, c, 1]), i([1, c])],
                  scalez: ["N", i([1, 1, c])],
                  scale3d: ["NNN", n],
                  skew: ["Aa", null, n],
                  skewx: ["A", null, i([c, d])],
                  skewy: ["A", null, i([d, c])],
                  translate: ["Tt", i([c, c, h]), n],
                  translatex: ["T", i([c, h, h]), i([c, h])],
                  translatey: ["T", i([h, c, h]), i([h, c])],
                  translatez: ["L", i([h, h, c])],
                  translate3d: ["TTL", n],
                };
              e.addPropertiesHandler(
                s,
                function t(i, n) {
                  var s = e.makeMatrixDecomposition && !0,
                    r = !1;
                  if (!i.length || !n.length) {
                    i.length || ((r = !0), (i = n), (n = []));
                    for (var c = 0; c < i.length; c++) {
                      var h = i[c].t,
                        d = i[c].d,
                        p = "scale" == h.substr(0, 5) ? 1 : 0;
                      n.push({
                        t: h,
                        d: d.map(function (e) {
                          if ("number" == typeof e) return p;
                          var t = {};
                          for (var i in e) t[i] = p;
                          return t;
                        }),
                      });
                    }
                  }
                  var m = [],
                    f = [],
                    $ = [];
                  if (i.length != n.length) {
                    if (!s) return;
                    var g = a(i, n);
                    (m = [g[0]]), (f = [g[1]]), ($ = [["matrix", [g[2]]]]);
                  } else
                    for (var c = 0; c < i.length; c++) {
                      var h,
                        b,
                        v,
                        y = i[c].t,
                        _ = n[c].t,
                        w = i[c].d,
                        E = n[c].d,
                        x = u[y],
                        k = u[_];
                      if (
                        ((b = y),
                        (v = _),
                        ("perspective" == b && "perspective" == v) ||
                          (("matrix" == b || "matrix3d" == b) &&
                            ("matrix" == v || "matrix3d" == v)))
                      ) {
                        if (!s) return;
                        var g = a([i[c]], [n[c]]);
                        m.push(g[0]), f.push(g[1]), $.push(["matrix", [g[2]]]);
                      } else {
                        if (y == _) h = y;
                        else if (x[2] && k[2] && o(y) == o(_))
                          (h = o(y)), (w = x[2](w)), (E = k[2](E));
                        else {
                          if (!x[1] || !k[1] || l(y) != l(_)) {
                            if (!s) return;
                            var g = a(i, n);
                            (m = [g[0]]),
                              (f = [g[1]]),
                              ($ = [["matrix", [g[2]]]]);
                            break;
                          }
                          (h = l(y)), (w = x[1](w)), (E = k[1](E));
                        }
                        for (
                          var S = [], L = [], T = [], A = 0;
                          A < w.length;
                          A++
                        ) {
                          var g = (
                            "number" == typeof w[A]
                              ? e.mergeNumbers
                              : e.mergeDimensions
                          )(w[A], E[A]);
                          (S[A] = g[0]), (L[A] = g[1]), T.push(g[2]);
                        }
                        m.push(S), f.push(L), $.push([h, T]);
                      }
                    }
                  if (r) {
                    var C = m;
                    (m = f), (f = C);
                  }
                  return [
                    m,
                    f,
                    function (e) {
                      return e
                        .map(function (e, t) {
                          var i = e
                            .map(function (e, i) {
                              return $[t][1][i](e);
                            })
                            .join(",");
                          return (
                            "matrix" == $[t][0] &&
                              16 == i.split(",").length &&
                              ($[t][0] = "matrix3d"),
                            $[t][0] + "(" + i + ")"
                          );
                        })
                        .join(" ");
                    },
                  ];
                },
                ["transform"]
              ),
                (e.transformToSvgMatrix = function (t) {
                  var i = e.transformListToMatrix(s(t));
                  return (
                    "matrix(" +
                    r(i[0]) +
                    " " +
                    r(i[1]) +
                    " " +
                    r(i[4]) +
                    " " +
                    r(i[5]) +
                    " " +
                    r(i[12]) +
                    " " +
                    r(i[13]) +
                    ")"
                  );
                });
            })(n),
            (function (e) {
              function t(t) {
                return (
                  (t = 100 * Math.round(t / 100)),
                  400 === (t = e.clamp(100, 900, t))
                    ? "normal"
                    : 700 === t
                    ? "bold"
                    : String(t)
                );
              }
              e.addPropertiesHandler(
                function e(t) {
                  var i = Number(t);
                  if (!(isNaN(i) || i < 100 || i > 900 || i % 100 != 0))
                    return i;
                },
                function e(i, n) {
                  return [i, n, t];
                },
                ["font-weight"]
              );
            })(n),
            (function (e) {
              function t(e) {
                var t = {};
                for (var i in e) t[i] = -e[i];
                return t;
              }
              function i(t) {
                return (
                  e.consumeToken(/^(left|center|right|top|bottom)\b/i, t) ||
                  e.consumeLengthOrPercent(t)
                );
              }
              function n(t, n) {
                var s = e.consumeRepeated(i, /^/, n);
                if (s && "" == s[1]) {
                  var a = s[0];
                  if (
                    ((a[0] = a[0] || "center"),
                    (a[1] = a[1] || "center"),
                    3 == t && (a[2] = a[2] || { px: 0 }),
                    a.length == t)
                  ) {
                    if (/top|bottom/.test(a[0]) || /left|right/.test(a[1])) {
                      var o = a[0];
                      (a[0] = a[1]), (a[1] = o);
                    }
                    if (
                      /left|right|center|Object/.test(a[0]) &&
                      /top|bottom|center|Object/.test(a[1])
                    )
                      return a.map(function (e) {
                        return "object" == typeof e ? e : r[e];
                      });
                  }
                }
              }
              function s(n) {
                var s = e.consumeRepeated(i, /^/, n);
                if (s) {
                  for (
                    var a = s[0],
                      o = [{ "%": 50 }, { "%": 50 }],
                      l = 0,
                      c = !1,
                      h = 0;
                    h < a.length;
                    h++
                  ) {
                    var d = a[h];
                    "string" == typeof d
                      ? ((c = /bottom|right/.test(d)),
                        (o[
                          (l = {
                            left: 0,
                            right: 0,
                            center: l,
                            top: 1,
                            bottom: 1,
                          }[d])
                        ] = r[d]),
                        "center" == d && l++)
                      : (c && ((d = t(d))["%"] = (d["%"] || 0) + 100),
                        (o[l] = d),
                        l++,
                        (c = !1));
                  }
                  return [o, s[1]];
                }
              }
              var r = {
                  left: { "%": 0 },
                  center: { "%": 50 },
                  right: { "%": 100 },
                  top: { "%": 0 },
                  bottom: { "%": 100 },
                },
                a = e.mergeNestedRepeated.bind(null, e.mergeDimensions, " ");
              e.addPropertiesHandler(n.bind(null, 3), a, ["transform-origin"]),
                e.addPropertiesHandler(n.bind(null, 2), a, [
                  "perspective-origin",
                ]),
                (e.consumePosition = s),
                (e.mergeOffsetList = a);
              var o = e.mergeNestedRepeated.bind(null, a, ", ");
              e.addPropertiesHandler(
                function t(i) {
                  var n = e.consumeRepeated(s, /^,/, i);
                  if (n && "" == n[1]) return n[0];
                },
                o,
                ["background-position", "object-position"]
              );
            })(n),
            (function (e) {
              var t = e.consumeParenthesised.bind(null, e.parseLengthOrPercent),
                i = e.consumeRepeated.bind(void 0, t, /^/),
                n = e.mergeNestedRepeated.bind(void 0, e.mergeDimensions, " "),
                s = e.mergeNestedRepeated.bind(void 0, n, ",");
              e.addPropertiesHandler(
                function n(s) {
                  var r = e.consumeToken(/^circle/, s);
                  if (r && r[0])
                    return ["circle"].concat(
                      e.consumeList(
                        [
                          e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                          t,
                          e.ignore(e.consumeToken.bind(void 0, /^at/)),
                          e.consumePosition,
                          e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                        ],
                        r[1]
                      )
                    );
                  var a = e.consumeToken(/^ellipse/, s);
                  if (a && a[0])
                    return ["ellipse"].concat(
                      e.consumeList(
                        [
                          e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                          i,
                          e.ignore(e.consumeToken.bind(void 0, /^at/)),
                          e.consumePosition,
                          e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                        ],
                        a[1]
                      )
                    );
                  var o = e.consumeToken(/^polygon/, s);
                  return o && o[0]
                    ? ["polygon"].concat(
                        e.consumeList(
                          [
                            e.ignore(e.consumeToken.bind(void 0, /^\(/)),
                            e.optional(
                              e.consumeToken.bind(
                                void 0,
                                /^nonzero\s*,|^evenodd\s*,/
                              ),
                              "nonzero,"
                            ),
                            e.consumeSizePairList,
                            e.ignore(e.consumeToken.bind(void 0, /^\)/)),
                          ],
                          o[1]
                        )
                      )
                    : void 0;
                },
                function t(i, n) {
                  if (i[0] === n[0])
                    return "circle" == i[0]
                      ? e.mergeList(i.slice(1), n.slice(1), [
                          "circle(",
                          e.mergeDimensions,
                          " at ",
                          e.mergeOffsetList,
                          ")",
                        ])
                      : "ellipse" == i[0]
                      ? e.mergeList(i.slice(1), n.slice(1), [
                          "ellipse(",
                          e.mergeNonNegativeSizePair,
                          " at ",
                          e.mergeOffsetList,
                          ")",
                        ])
                      : "polygon" == i[0] && i[1] == n[1]
                      ? e.mergeList(i.slice(2), n.slice(2), [
                          "polygon(",
                          i[1],
                          s,
                          ")",
                        ])
                      : void 0;
                },
                ["shape-outside"]
              );
            })(n),
            (function (e, t) {
              function i(e, t) {
                t.concat([e]).forEach(function (t) {
                  t in document.documentElement.style && (n[e] = t), (s[t] = e);
                });
              }
              var n = {},
                s = {};
              i("transform", ["webkitTransform", "msTransform"]),
                i("transformOrigin", ["webkitTransformOrigin"]),
                i("perspective", ["webkitPerspective"]),
                i("perspectiveOrigin", ["webkitPerspectiveOrigin"]),
                (e.propertyName = function (e) {
                  return n[e] || e;
                }),
                (e.unprefixedPropertyName = function (e) {
                  return s[e] || e;
                });
            })(n);
        })(),
        (function () {
          if (void 0 === document.createElement("div").animate([]).oncancel) {
            if (window.performance && performance.now)
              var e,
                e = function () {
                  return performance.now();
                };
            else
              var e = function () {
                return Date.now();
              };
            var t = function (e, t, i) {
                (this.target = e),
                  (this.currentTime = t),
                  (this.timelineTime = i),
                  (this.type = "cancel"),
                  (this.bubbles = !1),
                  (this.cancelable = !1),
                  (this.currentTarget = e),
                  (this.defaultPrevented = !1),
                  (this.eventPhase = Event.AT_TARGET),
                  (this.timeStamp = Date.now());
              },
              i = window.Element.prototype.animate;
            window.Element.prototype.animate = function (n, s) {
              var r = i.call(this, n, s);
              (r._cancelHandlers = []), (r.oncancel = null);
              var a = r.cancel;
              r.cancel = function () {
                a.call(this);
                var i = new t(this, null, e()),
                  n = this._cancelHandlers.concat(
                    this.oncancel ? [this.oncancel] : []
                  );
                setTimeout(function () {
                  n.forEach(function (e) {
                    e.call(i.target, i);
                  });
                }, 0);
              };
              var o = r.addEventListener;
              r.addEventListener = function (e, t) {
                "function" == typeof t && "cancel" == e
                  ? this._cancelHandlers.push(t)
                  : o.call(this, e, t);
              };
              var l = r.removeEventListener;
              return (
                (r.removeEventListener = function (e, t) {
                  if ("cancel" == e) {
                    var i = this._cancelHandlers.indexOf(t);
                    i >= 0 && this._cancelHandlers.splice(i, 1);
                  } else l.call(this, e, t);
                }),
                r
              );
            };
          }
        })(),
        (function (e) {
          var t = document.documentElement,
            i = null,
            n = !1;
          try {
            var s = getComputedStyle(t).getPropertyValue("opacity"),
              r = "0" == s ? "1" : "0";
            ((i = t.animate(
              { opacity: [r, r] },
              { duration: 1 }
            )).currentTime = 0),
              (n = getComputedStyle(t).getPropertyValue("opacity") == r);
          } catch (a) {
          } finally {
            i && i.cancel();
          }
          if (!n) {
            var o = window.Element.prototype.animate;
            window.Element.prototype.animate = function (t, i) {
              return (
                window.Symbol &&
                  Symbol.iterator &&
                  Array.prototype.from &&
                  t[Symbol.iterator] &&
                  (t = Array.from(t)),
                Array.isArray(t) || null === t || (t = e.convertToArrayForm(t)),
                o.call(this, t, i)
              );
            };
          }
        })(i);
    })(),
    (function (e, t) {
      if ("function" != typeof e.createEvent) return !1;
      var i,
        n,
        s,
        r,
        a,
        o,
        l,
        c,
        h,
        d = function (e) {
          var t = e.toLowerCase();
          return navigator.msPointerEnabled
            ? "MS" + e
            : !!window.PointerEvent && t;
        },
        u = function (e) {
          return "on" + e in window && e;
        },
        p = {
          useJquery: !t.IGNORE_JQUERY && "undefined" != typeof jQuery,
          swipeThreshold: t.SWIPE_THRESHOLD || 100,
          tapThreshold: t.TAP_THRESHOLD || 150,
          dbltapThreshold: t.DBL_TAP_THRESHOLD || 200,
          longtapThreshold: t.LONG_TAP_THRESHOLD || 1e3,
          tapPrecision: t.TAP_PRECISION / 2 || 30,
          justTouchEvents: t.JUST_ON_TOUCH_DEVICES,
        },
        m = !1,
        f = {
          touchstart: u("touchstart") || d("PointerDown"),
          touchend: u("touchend") || d("PointerUp"),
          touchmove: u("touchmove") || d("PointerMove"),
        },
        $ = function (e) {
          return !e.pointerId || void 0 === i || e.pointerId === i;
        },
        g = function (e, t, i) {
          for (var n = t.split(" "), s = n.length; s--; )
            e.addEventListener(n[s], i, !1);
        },
        b = function (e) {
          var t = Boolean(e.targetTouches && e.targetTouches.length);
          switch (!0) {
            case Boolean(e.target.touches):
              return e.target.touches[0];
            case t && void 0 !== e.targetTouches[0].pageX:
              return e.targetTouches[0];
            case t && Boolean(e.targetTouches[0].touches):
              return e.targetTouches[0].touches[0];
            default:
              return e;
          }
        },
        v = function (e) {
          return (e.targetTouches || e.target.touches || []).length > 1;
        },
        y = function () {
          return new Date().getTime();
        },
        _ = function (t, i, r, a) {
          var o = e.createEvent("Event");
          if (
            ((o.originalEvent = r),
            ((a = a || {}).x = n),
            (a.y = s),
            p.useJquery &&
              ((o = jQuery.Event(i, { originalEvent: r })),
              jQuery(t).trigger(o, a)),
            o.initEvent)
          ) {
            for (var l in a) o[l] = a[l];
            o.initEvent(i, !0, !0), t.dispatchEvent(o);
          }
          for (; t; ) t["on" + i] && t["on" + i](o), (t = t.parentNode);
        },
        w = function (e) {
          if (
            !(!$(e) || v(e)) &&
            ((i = e.pointerId),
            "mousedown" !== e.type && (m = !0),
            "mousedown" !== e.type || !m)
          ) {
            var t = b(e);
            (r = n = t.pageX),
              (a = s = t.pageY),
              (h = setTimeout(function () {
                _(e.target, "longtap", e), (l = e.target);
              }, p.longtapThreshold)),
              (o = y()),
              k++;
          }
        },
        E = function (e) {
          if (!(!$(e) || v(e))) {
            if (((i = void 0), "mouseup" === e.type && m)) {
              m = !1;
              return;
            }
            var t = [],
              d = y(),
              u = a - s,
              f = r - n;
            if (
              (clearTimeout(c),
              clearTimeout(h),
              f <= -p.swipeThreshold && t.push("swiperight"),
              f >= p.swipeThreshold && t.push("swipeleft"),
              u <= -p.swipeThreshold && t.push("swipedown"),
              u >= p.swipeThreshold && t.push("swipeup"),
              t.length)
            ) {
              for (var g = 0; g < t.length; g++) {
                var b = t[g];
                _(e.target, b, e, {
                  distance: { x: Math.abs(f), y: Math.abs(u) },
                });
              }
              k = 0;
            } else
              r >= n - p.tapPrecision &&
                r <= n + p.tapPrecision &&
                a >= s - p.tapPrecision &&
                a <= s + p.tapPrecision &&
                o + p.tapThreshold - d >= 0 &&
                (_(e.target, k >= 2 && l === e.target ? "dbltap" : "tap", e),
                (l = e.target)),
                (c = setTimeout(function () {
                  k = 0;
                }, p.dbltapThreshold));
          }
        },
        x = function (e) {
          if ($(e) && ("mousemove" !== e.type || !m)) {
            var t = b(e);
            (n = t.pageX), (s = t.pageY);
          }
        },
        k = 0;
      g(e, f.touchstart + (p.justTouchEvents ? "" : " mousedown"), w),
        g(e, f.touchend + (p.justTouchEvents ? "" : " mouseup"), E),
        g(e, f.touchmove + (p.justTouchEvents ? "" : " mousemove"), x),
        (t.tocca = function (e) {
          for (var t in e) p[t] = e[t];
          return p;
        });
    })(document, window);
  var e,
    t,
    i,
    n = new Set(),
    s = document.createElement("link"),
    r =
      s.relList &&
      s.relList.supports &&
      s.relList.supports("prefetch") &&
      window.IntersectionObserver &&
      "isIntersecting" in IntersectionObserverEntry.prototype,
    a = "instantAllowQueryString" in document.body.dataset,
    o = "instantAllowExternalLinks" in document.body.dataset,
    l = "instantWhitelist" in document.body.dataset,
    c = "instantMousedownShortcut" in document.body.dataset,
    h = 1111,
    d = 65,
    u = !1,
    p = !1,
    m = !1;
  if ("instantIntensity" in document.body.dataset) {
    let f = document.body.dataset.instantIntensity;
    if ("mousedown" == f.substr(0, 9))
      (u = !0), "mousedown-only" == f && (p = !0);
    else if ("viewport" == f.substr(0, 8))
      !(
        navigator.connection &&
        (navigator.connection.saveData ||
          (navigator.connection.effectiveType &&
            navigator.connection.effectiveType.includes("2g")))
      ) &&
        ("viewport" == f
          ? document.documentElement.clientWidth *
              document.documentElement.clientHeight <
              45e4 && (m = !0)
          : "viewport-all" == f && (m = !0));
    else {
      let $ = parseInt(f);
      isNaN($) || (d = $);
    }
  }
  if (r) {
    let g = { capture: !0, passive: !0 };
    if (
      (p || document.addEventListener("touchstart", v, g),
      u
        ? c || document.addEventListener("mousedown", _, g)
        : document.addEventListener("mouseover", y, g),
      c && document.addEventListener("mousedown", E, g),
      m)
    ) {
      let b;
      (b = window.requestIdleCallback
        ? (e) => {
            requestIdleCallback(e, { timeout: 1500 });
          }
        : (e) => {
            e();
          })(() => {
        let e = new IntersectionObserver((t) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              let i = t.target;
              e.unobserve(i), k(i.href);
            }
          });
        });
        document.querySelectorAll("a").forEach((t) => {
          x(t) && e.observe(t);
        });
      });
    }
  }
  function v(e) {
    i = performance.now();
    let t = e.target.closest("a");
    x(t) && k(t.href);
  }
  function y(e) {
    if (performance.now() - i < h) return;
    let n = e.target.closest("a");
    x(n) &&
      (n.addEventListener("mouseout", w, { passive: !0 }),
      (t = setTimeout(() => {
        k(n.href), (t = void 0);
      }, d)));
  }
  function _(e) {
    let t = e.target.closest("a");
    x(t) && k(t.href);
  }
  function w(e) {
    (!e.relatedTarget ||
      e.target.closest("a") != e.relatedTarget.closest("a")) &&
      t &&
      (clearTimeout(t), (t = void 0));
  }
  function E(e) {
    if (performance.now() - i < h) return;
    let t = e.target.closest("a");
    if (e.which > 1 || e.metaKey || e.ctrlKey || !t) return;
    t.addEventListener(
      "click",
      function (e) {
        1337 != e.detail && e.preventDefault();
      },
      { capture: !0, passive: !1, once: !0 }
    );
    let n = new MouseEvent("click", {
      view: window,
      bubbles: !0,
      cancelable: !1,
      detail: 1337,
    });
    t.dispatchEvent(n);
  }
  function x(e) {
    if (
      e &&
      e.href &&
      (!l || "instant" in e.dataset) &&
      (o || e.origin == location.origin || "instant" in e.dataset) &&
      ["http:", "https:"].includes(e.protocol) &&
      ("http:" != e.protocol || "https:" != location.protocol) &&
      (a || !e.search || "instant" in e.dataset) &&
      (!e.hash ||
        e.pathname + e.search != location.pathname + location.search) &&
      !("noInstant" in e.dataset)
    )
      return !0;
  }
  function k(e) {
    if (n.has(e)) return;
    let t = document.createElement("link");
    (t.rel = "prefetch"), (t.href = e), document.head.appendChild(t), n.add(e);
  }
  var S = (e) =>
    void 0 === e || "auto" === e || "instant" === e || "smooth" === e;
  function L(e, t) {
    (this.scrollLeft = e), (this.scrollTop = t);
  }
  var T,
    A = (e, t, i = "cannot convert to dictionary.") =>
      `Failed to execute '${e}' on '${t}': ${i}`,
    C = (e, t, i) =>
      A(
        e,
        t,
        `The provided value '${i}' is not a valid enum value of type ScrollBehavior.`
      ),
    P = (e, t, i) => {
      var n;
      let s = `__SEAMLESS.BACKUP$${t}`;
      return (
        e[s] ||
          !e[t] ||
          (null == (n = e[t]) ? void 0 : n.__isPolyfill) ||
          (e[s] = e[t]),
        e[s] || i
      );
    },
    I = (e) => {
      let t = typeof e;
      return null !== e && ("object" === t || "function" === t);
    },
    q = () => "scrollBehavior" in window.document.documentElement.style,
    V = (e) => {
      Object.defineProperty(e, "__isPolyfill", { value: !0 });
    },
    M = (e, t) => {
      V(t),
        [
          HTMLElement.prototype,
          SVGElement.prototype,
          Element.prototype,
        ].forEach((i) => {
          P(i, e), (i[e] = t);
        });
    },
    D = (e) =>
      e.ownerDocument.scrollingElement || e.ownerDocument.documentElement,
    O = (e) => 0.5 * (1 - Math.cos(Math.PI * e)),
    B = () => {
      var e, t, i;
      return null !=
        (i =
          null == (t = null == (e = window.performance) ? void 0 : e.now)
            ? void 0
            : t.call(e))
        ? i
        : window.Date.now();
    },
    R = 500,
    N = (e) => {
      let t = B(),
        i = (t - e.timeStamp) / (e.duration || R);
      if (i > 1) {
        e.method(e.targetX, e.targetY), e.callback();
        return;
      }
      let n = (e.timingFunc || O)(i),
        s = e.startX + (e.targetX - e.startX) * n,
        r = e.startY + (e.targetY - e.startY) * n;
      e.method(s, r),
        (e.rafId = window.requestAnimationFrame(() => {
          N(e);
        }));
    },
    H = (e) => (isFinite(e) ? Number(e) : 0),
    F = (e) => {
      var t;
      return null != (t = e.isConnected)
        ? t
        : !e.ownerDocument || !(1 & e.ownerDocument.compareDocumentPosition(e));
    },
    z = (e, t, i) => {
      var n, s;
      if (!F(e)) return;
      let r = e.scrollLeft,
        a = e.scrollTop,
        o = H(null != (n = t.left) ? n : r),
        l = H(null != (s = t.top) ? s : a);
      if (o === r && l === a) return;
      let c = P(HTMLElement.prototype, "scroll", L),
        h = P(Object.getPrototypeOf(e), "scroll", c).bind(e);
      if ("smooth" !== t.behavior) {
        h(o, l);
        return;
      }
      let d = () => {
          window.removeEventListener("wheel", p),
            window.removeEventListener("touchmove", p);
        },
        u = {
          ...i,
          timeStamp: B(),
          startX: r,
          startY: a,
          targetX: o,
          targetY: l,
          rafId: 0,
          method: h,
          callback: d,
        },
        p = () => {
          window.cancelAnimationFrame(u.rafId), d();
        };
      window.addEventListener("wheel", p, { passive: !0, once: !0 }),
        window.addEventListener("touchmove", p, { passive: !0, once: !0 }),
        N(u);
    },
    W = (e) => e.window === e,
    U = (e) => (t, i, n) => {
      let [s, r] = W(t)
          ? [D(t.document.documentElement), "Window"]
          : [t, "Element"],
        a = null != i ? i : {};
      if (!I(a)) throw TypeError(A(e, r));
      if (!S(a.behavior)) throw TypeError(C(e, r, a.behavior));
      "scrollBy" === e &&
        ((a.left = H(a.left) + s.scrollLeft), (a.top = H(a.top) + s.scrollTop)),
        z(s, a, n);
    },
    Y = U("scroll"),
    j = U("scrollTo"),
    X = U("scrollBy"),
    G = Y,
    K = (e) => {
      switch (e) {
        case "horizontal-tb":
        case "lr":
        case "lr-tb":
        case "rl":
        case "rl-tb":
          break;
        case "vertical-rl":
        case "tb":
        case "tb-rl":
          return 1;
        case "vertical-lr":
        case "tb-lr":
          return 2;
        case "sideways-rl":
          return 3;
        case "sideways-lr":
          return 4;
      }
      return 0;
    },
    Z = (e, t, i, n) => {
      let s = 0;
      switch ((t || (s ^= 2), e)) {
        case 0:
          (s = (s >> 1) | ((1 & s) << 1)), ([i, n] = [n, i]);
          break;
        case 1:
        case 3:
          s ^= 1;
          break;
        case 4:
          s ^= 2;
      }
      return [s, i, n];
    },
    Q = (e) => {
      let t = Z(K(e.writingMode), "rtl" !== e.direction, void 0, void 0)[0];
      return (1 & t) == 1;
    },
    J = (e, t, i) => {
      let [n, s, r] = Z(t, i, e.block || "start", e.inline || "nearest");
      return [s, r].map((e, t) => {
        switch (e) {
          case "center":
            return 1;
          case "nearest":
            return 0;
          default: {
            let i = (n >> t) & 1;
            return ("start" === e) == !i ? 2 : 3;
          }
        }
      });
    },
    ee = (e, t, i, n, s, r, a) =>
      0 !== e
        ? e
        : (s < t && r > i) || (s > t && r < i)
        ? null
        : (s <= t && a <= n) || (r >= i && a >= n)
        ? 2
        : (r > i && a < n) || (s < t && a > n)
        ? 3
        : null,
    et = (e) => "visible" !== e && "clip" !== e,
    ei = (e) => {
      var t;
      try {
        return (
          (null == (t = e.ownerDocument.defaultView)
            ? void 0
            : t.frameElement) || null
        );
      } catch {
        return null;
      }
    },
    en = (e, t) =>
      (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) &&
      (et(t.overflowY) || et(t.overflowX) || e === D(e)),
    es = (e) => {
      let t = e.parentNode,
        i = e.parentElement;
      if (null === i && null !== t) {
        if (11 === t.nodeType) return t.host;
        if (9 === t.nodeType) return ei(e);
      }
      return i;
    },
    er = (e, t, i) => (e < t ? t : e > i ? i : e),
    ea = (e) =>
      ["scroll-margin", "scroll-snap-margin"].filter(
        (t) => t in e.documentElement.style
      )[0],
    eo = (e, t, i) => {
      let { top: n, right: s, bottom: r, left: a } = t,
        o = ea(e.ownerDocument);
      if (!o) return [n, s, r, a];
      let l = (e) => {
        let t = i.getPropertyValue(`${o}-${e}`);
        return parseInt(t, 10) || 0;
      };
      return [n - l("top"), s + l("right"), r + l("bottom"), a - l("left")];
    },
    el = (e, t, i) => {
      switch (e) {
        case 1:
          return (t + i) / 2;
        case 3:
          return i;
        case 2:
        case 0:
          return t;
      }
    },
    ec = (e, t) => {
      var i, n, s;
      let r =
          null == (i = e.ownerDocument.defaultView) ? void 0 : i.visualViewport,
        [a, o, l, c] =
          e === D(e)
            ? [
                0,
                0,
                null != (n = null == r ? void 0 : r.width) ? n : e.clientWidth,
                null != (s = null == r ? void 0 : r.height)
                  ? s
                  : e.clientHeight,
              ]
            : [t.left, t.top, e.clientWidth, e.clientHeight],
        h = a + e.clientLeft,
        d = o + e.clientTop,
        u = h + l,
        p = d + c;
      return [d, u, p, h];
    },
    eh = (e, t) => {
      let i = [],
        n = e.ownerDocument,
        s = n.defaultView;
      if (!s) return i;
      let r = window.getComputedStyle(e),
        a = "rtl" !== r.direction,
        o = K(
          r.writingMode ||
            r.getPropertyValue("-webkit-writing-mode") ||
            r.getPropertyValue("-ms-writing-mode")
        ),
        [l, c] = J(t, o, a),
        [h, d, u, p] = eo(e, e.getBoundingClientRect(), r);
      for (let m = es(e); null !== m; m = es(m)) {
        if (n !== m.ownerDocument) {
          if (!(s = (n = m.ownerDocument).defaultView)) break;
          let { left: f, top: $ } = m.getBoundingClientRect();
          (h += $), (d += f), (u += $), (p += f);
        }
        let g = s.getComputedStyle(m);
        if ("fixed" === g.position) break;
        if (!en(m, g)) continue;
        let b = m.getBoundingClientRect(),
          [v, y, _, w] = ec(m, b),
          E = ee(l, w, y, m.clientWidth, p, d, d - p),
          x = ee(c, v, _, m.clientHeight, h, u, u - h),
          k = null === E ? 0 : el(E, p, d) - el(E, w, y),
          S = null === x ? 0 : el(x, h, u) - el(x, v, _),
          L = Q(g)
            ? er(
                k,
                -m.scrollWidth + m.clientWidth - m.scrollLeft,
                -m.scrollLeft
              )
            : er(
                k,
                -m.scrollLeft,
                m.scrollWidth - m.clientWidth - m.scrollLeft
              ),
          T = er(
            S,
            -m.scrollTop,
            m.scrollHeight - m.clientHeight - m.scrollTop
          );
        i.push([
          m,
          {
            left: m.scrollLeft + L,
            top: m.scrollTop + T,
            behavior: t.behavior,
          },
        ]),
          (h = Math.max(h - T, v)),
          (d = Math.min(d - L, y)),
          (u = Math.min(u - T, _)),
          (p = Math.max(p - L, w));
      }
      return i;
    },
    ed = (e, t, i) => {
      let n = t || {};
      if (!S(n.behavior))
        throw TypeError(C("scrollIntoView", "Element", n.behavior));
      let s = eh(e, n);
      s.forEach(([e, t]) => {
        G(e, t, i);
      });
    },
    eu = (e, t) => (i) => {
      if (q()) return;
      let n = { scroll: Y, scrollTo: j, scrollBy: X }[e];
      t(e, function () {
        let e = arguments;
        if (1 === arguments.length) {
          n(this, e[0], i);
          return;
        }
        let t = e[0],
          s = e[1];
        n(this, { left: t, top: s });
      });
    },
    ep = eu("scroll", M),
    em = eu("scrollTo", M),
    ef = eu("scrollBy", M),
    e$ = (e, t) => {
      V(t), P(window, e), (window[e] = t);
    },
    eg = eu("scroll", e$),
    eb = eu("scrollTo", e$),
    ev = eu("scrollBy", e$);
  function ey(e) {
    ed(this, { block: null == e || e ? "start" : "end", inline: "nearest" });
  }
  ((e) => {
    if (q()) return;
    let t = P(window.HTMLElement.prototype, "scrollIntoView", ey);
    M("scrollIntoView", function e() {
      let i = arguments,
        n = i[0];
      if (1 === i.length && I(n)) {
        ed(this, n, void 0);
        return;
      }
      t.apply(this, i);
    });
  })(),
    em(),
    ef();
})(),
  /*! (c) Andrea Giammarchi @webreflection ISC */ /*! instant.page v5.1.0 - (C) 2019-2020 Alexandre Dieulot - https://instant.page/license */ (() => {
    var e = Object.defineProperty,
      t = (t, i, n) =>
        i in t
          ? e(t, i, {
              enumerable: !0,
              configurable: !0,
              writable: !0,
              value: n,
            })
          : (t[i] = n),
      i = (e, i, n) => (t(e, "symbol" != typeof i ? i + "" : i, n), n);
    function n(e) {
      (this.listenerMap = [{}, {}]),
        e && this.root(e),
        (this.handle = n.prototype.handle.bind(this)),
        (this._removedListeners = []);
    }
    function s(e, t) {
      return e.toLowerCase() === t.tagName.toLowerCase();
    }
    function r(e, t) {
      return this.rootElement === window
        ? t === document || t === document.documentElement || t === window
        : this.rootElement === t;
    }
    function a(e, t) {
      return e === t.id;
    }
    (n.prototype.root = function (e) {
      let t = this.listenerMap,
        i;
      if (this.rootElement) {
        for (i in t[1])
          t[1].hasOwnProperty(i) &&
            this.rootElement.removeEventListener(i, this.handle, !0);
        for (i in t[0])
          t[0].hasOwnProperty(i) &&
            this.rootElement.removeEventListener(i, this.handle, !1);
      }
      if (!e || !e.addEventListener)
        return this.rootElement && delete this.rootElement, this;
      for (i in ((this.rootElement = e), t[1]))
        t[1].hasOwnProperty(i) &&
          this.rootElement.addEventListener(i, this.handle, !0);
      for (i in t[0])
        t[0].hasOwnProperty(i) &&
          this.rootElement.addEventListener(i, this.handle, !1);
      return this;
    }),
      (n.prototype.captureForType = function (e) {
        return (
          -1 !==
          ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e)
        );
      }),
      (n.prototype.on = function (e, t, i, n) {
        let o, l, c, h;
        if (!e) throw TypeError("Invalid event type: " + e);
        if (
          ("function" == typeof t && ((n = i), (i = t), (t = null)),
          void 0 === n && (n = this.captureForType(e)),
          "function" != typeof i)
        )
          throw TypeError("Handler must be a type of Function");
        return (
          (o = this.rootElement),
          (l = this.listenerMap[n ? 1 : 0])[e] ||
            (o && o.addEventListener(e, this.handle, n), (l[e] = [])),
          t
            ? /^[a-z]+$/i.test(t)
              ? ((h = t), (c = s))
              : /^#[a-z0-9\-_]+$/i.test(t)
              ? ((h = t.slice(1)), (c = a))
              : ((h = t), (c = Element.prototype.matches))
            : ((h = null), (c = r.bind(this))),
          l[e].push({ selector: t, handler: i, matcher: c, matcherParam: h }),
          this
        );
      }),
      (n.prototype.off = function (e, t, i, n) {
        let s, r, a, o, l;
        if (
          ("function" == typeof t && ((n = i), (i = t), (t = null)),
          void 0 === n)
        )
          return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
        if (((a = this.listenerMap[n ? 1 : 0]), !e)) {
          for (l in a) a.hasOwnProperty(l) && this.off(l, t, i);
          return this;
        }
        if (!(o = a[e]) || !o.length) return this;
        for (s = o.length - 1; s >= 0; s--)
          (r = o[s]),
            (t && t !== r.selector) ||
              (i && i !== r.handler) ||
              (this._removedListeners.push(r), o.splice(s, 1));
        return (
          !o.length &&
            (delete a[e],
            this.rootElement &&
              this.rootElement.removeEventListener(e, this.handle, n)),
          this
        );
      }),
      (n.prototype.handle = function (e) {
        let t,
          i,
          n = e.type,
          s,
          r,
          a,
          o,
          l = [],
          c,
          h = "ftLabsDelegateIgnore";
        if (!0 === e[h]) return;
        switch (
          (3 === (c = e.target).nodeType && (c = c.parentNode),
          c.correspondingUseElement && (c = c.correspondingUseElement),
          (s = this.rootElement),
          (r = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)))
        ) {
          case 1:
            l = this.listenerMap[1][n];
            break;
          case 2:
            this.listenerMap[0] &&
              this.listenerMap[0][n] &&
              (l = l.concat(this.listenerMap[0][n])),
              this.listenerMap[1] &&
                this.listenerMap[1][n] &&
                (l = l.concat(this.listenerMap[1][n]));
            break;
          case 3:
            l = this.listenerMap[0][n];
        }
        let d = [];
        for (i = l.length; c && i; ) {
          for (t = 0; t < i && (a = l[t]); t++)
            c.tagName &&
            ["button", "input", "select", "textarea"].indexOf(
              c.tagName.toLowerCase()
            ) > -1 &&
            c.hasAttribute("disabled")
              ? (d = [])
              : a.matcher.call(c, a.matcherParam, c) && d.push([e, c, a]);
          if (
            c === s ||
            ((i = l.length),
            (c = c.parentElement || c.parentNode) instanceof HTMLDocument)
          )
            break;
        }
        let u;
        for (t = 0; t < d.length; t++)
          if (
            !(this._removedListeners.indexOf(d[t][2]) > -1) &&
            !1 === (o = this.fire.apply(this, d[t]))
          ) {
            (d[t][0][h] = !0), d[t][0].preventDefault(), (u = !1);
            break;
          }
        return u;
      }),
      (n.prototype.fire = function (e, t, i) {
        return i.handler.call(t, e, t);
      }),
      (n.prototype.destroy = function () {
        this.off(), this.root();
      });
    var o = n,
      l = class {
        constructor() {
          (this.delegateElement = new o(document.body)),
            this.delegateElement.on(
              "change",
              "[data-bind-value]",
              this._onValueChanged.bind(this)
            );
        }
        _onValueChanged(e, t) {
          let i = document.getElementById(t.getAttribute("data-bind-value"));
          i &&
            ("SELECT" === t.tagName && (t = t.options[t.selectedIndex]),
            (i.innerHTML = t.hasAttribute("title")
              ? t.getAttribute("title")
              : t.value));
        }
      };
    function c(e, t, i = {}) {
      e.dispatchEvent(new CustomEvent(t, { bubbles: !0, detail: i }));
    }
    function h(e, t, i = {}) {
      e.dispatchEvent(new CustomEvent(t, { bubbles: !1, detail: i }));
    }
    var d = class extends HTMLElement {
        constructor() {
          super(),
            (this._hasSectionReloaded = !1),
            Shopify.designMode &&
              this.rootDelegate.on("shopify:section:select", (e) => {
                let t = this.closest(".shopify-section");
                e.target === t &&
                  e.detail.load &&
                  (this._hasSectionReloaded = !0);
              });
        }
        get rootDelegate() {
          return (this._rootDelegate =
            this._rootDelegate || new o(document.documentElement));
        }
        get delegate() {
          return (this._delegate = this._delegate || new o(this));
        }
        showLoadingBar() {
          c(document.documentElement, "theme:loading:start");
        }
        hideLoadingBar() {
          c(document.documentElement, "theme:loading:end");
        }
        untilVisible(e = { rootMargin: "30px 0px", threshold: 0 }) {
          let t = () => {
            this.classList.add("became-visible"), (this.style.opacity = "1");
          };
          return new Promise((i) => {
            window.IntersectionObserver
              ? ((this.intersectionObserver = new IntersectionObserver((e) => {
                  e[0].isIntersecting &&
                    (this.intersectionObserver.disconnect(),
                    requestAnimationFrame(() => {
                      i(), t();
                    }));
                }, e)),
                this.intersectionObserver.observe(this))
              : (i(), t());
          });
        }
        disconnectedCallback() {
          var e;
          this.delegate.destroy(),
            this.rootDelegate.destroy(),
            null == (e = this.intersectionObserver) || e.disconnect(),
            delete this._delegate,
            delete this._rootDelegate;
        }
      },
      u = [
        "input",
        "select",
        "textarea",
        "a[href]",
        "button",
        "[tabindex]",
        "audio[controls]",
        "video[controls]",
        '[contenteditable]:not([contenteditable="false"])',
        "details>summary:first-of-type",
        "details",
      ],
      p = u.join(","),
      m =
        "undefined" == typeof Element
          ? function () {}
          : Element.prototype.matches ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector,
      f = function e(t, i, n) {
        var s = Array.prototype.slice.apply(t.querySelectorAll(p));
        return i && m.call(t, p) && s.unshift(t), (s = s.filter(n));
      },
      $ = function e(t) {
        return "true" === t.contentEditable;
      },
      g = function e(t) {
        var i = parseInt(t.getAttribute("tabindex"), 10);
        return isNaN(i)
          ? $(t) ||
            (("AUDIO" === t.nodeName ||
              "VIDEO" === t.nodeName ||
              "DETAILS" === t.nodeName) &&
              null === t.getAttribute("tabindex"))
            ? 0
            : t.tabIndex
          : i;
      },
      b = function e(t, i) {
        return t.tabIndex === i.tabIndex
          ? t.documentOrder - i.documentOrder
          : t.tabIndex - i.tabIndex;
      },
      v = function e(t) {
        return "INPUT" === t.tagName;
      },
      y = function e(t) {
        return v(t) && "hidden" === t.type;
      },
      _ = function e(t) {
        return (
          "DETAILS" === t.tagName &&
          Array.prototype.slice.apply(t.children).some(function (e) {
            return "SUMMARY" === e.tagName;
          })
        );
      },
      w = function e(t, i) {
        for (var n = 0; n < t.length; n++)
          if (t[n].checked && t[n].form === i) return t[n];
      },
      E = function e(t) {
        if (!t.name) return !0;
        var i,
          n = t.form || t.ownerDocument,
          s = function e(t) {
            return n.querySelectorAll('input[type="radio"][name="' + t + '"]');
          };
        if (
          "undefined" != typeof window &&
          void 0 !== window.CSS &&
          "function" == typeof window.CSS.escape
        )
          i = s(window.CSS.escape(t.name));
        else
          try {
            i = s(t.name);
          } catch (r) {
            return (
              console.error(
                "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
                r.message
              ),
              !1
            );
          }
        var a = w(i, t.form);
        return !a || a === t;
      },
      x = function e(t) {
        return v(t) && "radio" === t.type;
      },
      k = function e(t) {
        return x(t) && !E(t);
      },
      S = function e(t, i) {
        if ("hidden" === getComputedStyle(t).visibility) return !0;
        var n = m.call(t, "details>summary:first-of-type")
          ? t.parentElement
          : t;
        if (m.call(n, "details:not([open]) *")) return !0;
        if (i && "full" !== i) {
          if ("non-zero-area" === i) {
            var s = t.getBoundingClientRect(),
              r = s.width,
              a = s.height;
            return 0 === r && 0 === a;
          }
        } else
          for (; t; ) {
            if ("none" === getComputedStyle(t).display) return !0;
            t = t.parentElement;
          }
        return !1;
      },
      L = function e(t) {
        if (
          v(t) ||
          "SELECT" === t.tagName ||
          "TEXTAREA" === t.tagName ||
          "BUTTON" === t.tagName
        )
          for (var i = t.parentElement; i; ) {
            if ("FIELDSET" === i.tagName && i.disabled) {
              for (var n = 0; n < i.children.length; n++) {
                var s = i.children.item(n);
                if ("LEGEND" === s.tagName) {
                  if (s.contains(t)) return !1;
                  break;
                }
              }
              return !0;
            }
            i = i.parentElement;
          }
        return !1;
      },
      T = function e(t, i) {
        return !(i.disabled || y(i) || S(i, t.displayCheck) || _(i) || L(i));
      },
      A = function e(t, i) {
        return !(!T(t, i) || k(i) || 0 > g(i));
      },
      C = function e(t, i) {
        var n = [],
          s = [];
        return (
          f(t, (i = i || {}).includeContainer, A.bind(null, i)).forEach(
            function (e, t) {
              var i = g(e);
              0 === i
                ? n.push(e)
                : s.push({ documentOrder: t, tabIndex: i, node: e });
            }
          ),
          s
            .sort(b)
            .map(function (e) {
              return e.node;
            })
            .concat(n)
        );
      },
      P = u.concat("iframe").join(","),
      I = function e(t, i) {
        if (((i = i || {}), !t)) throw Error("No node provided");
        return !1 !== m.call(t, P) && T(i, t);
      };
    function q(e, t) {
      var i = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t &&
          (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })),
          i.push.apply(i, n);
      }
      return i;
    }
    function V(e) {
      for (var t = 1; t < arguments.length; t++) {
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2
          ? q(Object(i), !0).forEach(function (t) {
              M(e, t, i[t]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
          : q(Object(i)).forEach(function (t) {
              Object.defineProperty(
                e,
                t,
                Object.getOwnPropertyDescriptor(i, t)
              );
            });
      }
      return e;
    }
    function M(e, t, i) {
      return (
        t in e
          ? Object.defineProperty(e, t, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (e[t] = i),
        e
      );
    }
    var D = (function () {
        var e = [];
        return {
          activateTrap: function t(i) {
            if (e.length > 0) {
              var n = e[e.length - 1];
              n !== i && n.pause();
            }
            var s = e.indexOf(i);
            -1 === s || e.splice(s, 1), e.push(i);
          },
          deactivateTrap: function t(i) {
            var n = e.indexOf(i);
            -1 !== n && e.splice(n, 1),
              e.length > 0 && e[e.length - 1].unpause();
          },
        };
      })(),
      O = function e(t) {
        return (
          t.tagName &&
          "input" === t.tagName.toLowerCase() &&
          "function" == typeof t.select
        );
      },
      B = function e(t) {
        return "Escape" === t.key || "Esc" === t.key || 27 === t.keyCode;
      },
      R = function e(t) {
        return "Tab" === t.key || 9 === t.keyCode;
      },
      N = function e(t) {
        return setTimeout(t, 0);
      },
      H = function e(t, i) {
        var n = -1;
        return (
          t.every(function (e, t) {
            return !i(e) || ((n = t), !1);
          }),
          n
        );
      },
      F = function e(t) {
        for (
          var i = arguments.length, n = Array(i > 1 ? i - 1 : 0), s = 1;
          s < i;
          s++
        )
          n[s - 1] = arguments[s];
        return "function" == typeof t ? t.apply(void 0, n) : t;
      },
      z = function e(t) {
        return t.target.shadowRoot && "function" == typeof t.composedPath
          ? t.composedPath()[0]
          : t.target;
      },
      W = function e(t, i) {
        var n,
          s = (null == i ? void 0 : i.document) || document,
          r = V(
            {
              returnFocusOnDeactivate: !0,
              escapeDeactivates: !0,
              delayInitialFocus: !0,
            },
            i
          ),
          a = {
            containers: [],
            tabbableGroups: [],
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: !1,
            paused: !1,
            delayInitialFocusTimer: void 0,
          },
          o = function e(t, i, n) {
            return t && void 0 !== t[i] ? t[i] : r[n || i];
          },
          l = function e(t) {
            return !!(
              t &&
              a.containers.some(function (e) {
                return e.contains(t);
              })
            );
          },
          c = function e(t) {
            var i = r[t];
            if ("function" == typeof i) {
              for (
                var n = arguments.length, a = Array(n > 1 ? n - 1 : 0), o = 1;
                o < n;
                o++
              )
                a[o - 1] = arguments[o];
              i = i.apply(void 0, a);
            }
            if (!i) {
              if (void 0 === i || !1 === i) return i;
              throw Error(
                "`".concat(
                  t,
                  "` was specified but was not a node, or did not return a node"
                )
              );
            }
            var l = i;
            if ("string" == typeof i && !(l = s.querySelector(i)))
              throw Error(
                "`".concat(t, "` as selector refers to no known node")
              );
            return l;
          },
          h = function e() {
            var t = c("initialFocus");
            if (!1 === t) return !1;
            if (void 0 === t) {
              if (l(s.activeElement)) t = s.activeElement;
              else {
                var i = a.tabbableGroups[0];
                t = (i && i.firstTabbableNode) || c("fallbackFocus");
              }
            }
            if (!t)
              throw Error(
                "Your focus-trap needs to have at least one focusable element"
              );
            return t;
          },
          d = function e() {
            if (
              ((a.tabbableGroups = a.containers
                .map(function (e) {
                  var t = C(e);
                  if (t.length > 0)
                    return {
                      container: e,
                      firstTabbableNode: t[0],
                      lastTabbableNode: t[t.length - 1],
                    };
                })
                .filter(function (e) {
                  return !!e;
                })),
              a.tabbableGroups.length <= 0 && !c("fallbackFocus"))
            )
              throw Error(
                "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
              );
          },
          u = function e(t) {
            if (!1 !== t && t !== s.activeElement) {
              if (!t || !t.focus) {
                e(h());
                return;
              }
              t.focus({ preventScroll: !!r.preventScroll }),
                (a.mostRecentlyFocusedNode = t),
                O(t) && t.select();
            }
          },
          p = function e(t) {
            var i = c("setReturnFocus", t);
            return i || (!1 !== i && t);
          },
          m = function e(t) {
            var i = z(t);
            if (!l(i)) {
              if (F(r.clickOutsideDeactivates, t)) {
                n.deactivate({
                  returnFocus: r.returnFocusOnDeactivate && !I(i),
                });
                return;
              }
              !F(r.allowOutsideClick, t) && t.preventDefault();
            }
          },
          f = function e(t) {
            var i = z(t),
              n = l(i);
            n || i instanceof Document
              ? n && (a.mostRecentlyFocusedNode = i)
              : (t.stopImmediatePropagation(),
                u(a.mostRecentlyFocusedNode || h()));
          },
          $ = function e(t) {
            var i = z(t);
            d();
            var n = null;
            if (a.tabbableGroups.length > 0) {
              var s = H(a.tabbableGroups, function (e) {
                return e.container.contains(i);
              });
              if (s < 0)
                n = t.shiftKey
                  ? a.tabbableGroups[a.tabbableGroups.length - 1]
                      .lastTabbableNode
                  : a.tabbableGroups[0].firstTabbableNode;
              else if (t.shiftKey) {
                var r = H(a.tabbableGroups, function (e) {
                  return i === e.firstTabbableNode;
                });
                if (
                  (r < 0 && a.tabbableGroups[s].container === i && (r = s),
                  r >= 0)
                ) {
                  var o = 0 === r ? a.tabbableGroups.length - 1 : r - 1;
                  n = a.tabbableGroups[o].lastTabbableNode;
                }
              } else {
                var l = H(a.tabbableGroups, function (e) {
                  return i === e.lastTabbableNode;
                });
                if (
                  (l < 0 && a.tabbableGroups[s].container === i && (l = s),
                  l >= 0)
                ) {
                  var h = l === a.tabbableGroups.length - 1 ? 0 : l + 1;
                  n = a.tabbableGroups[h].firstTabbableNode;
                }
              }
            } else n = c("fallbackFocus");
            n && (t.preventDefault(), u(n));
          },
          g = function e(t) {
            if (B(t) && !1 !== F(r.escapeDeactivates, t)) {
              t.preventDefault(), n.deactivate();
              return;
            }
            if (R(t)) {
              $(t);
              return;
            }
          },
          b = function e(t) {
            if (!F(r.clickOutsideDeactivates, t)) {
              var i = z(t);
              !(l(i) || F(r.allowOutsideClick, t)) &&
                (t.preventDefault(), t.stopImmediatePropagation());
            }
          },
          v = function e() {
            if (a.active)
              return (
                D.activateTrap(n),
                (a.delayInitialFocusTimer = r.delayInitialFocus
                  ? N(function () {
                      u(h());
                    })
                  : u(h())),
                s.addEventListener("focusin", f, !0),
                s.addEventListener("mousedown", m, {
                  capture: !0,
                  passive: !1,
                }),
                s.addEventListener("touchstart", m, {
                  capture: !0,
                  passive: !1,
                }),
                s.addEventListener("click", b, { capture: !0, passive: !1 }),
                s.addEventListener("keydown", g, { capture: !0, passive: !1 }),
                n
              );
          },
          y = function e() {
            if (a.active)
              return (
                s.removeEventListener("focusin", f, !0),
                s.removeEventListener("mousedown", m, !0),
                s.removeEventListener("touchstart", m, !0),
                s.removeEventListener("click", b, !0),
                s.removeEventListener("keydown", g, !0),
                n
              );
          };
        return (
          (n = {
            activate: function e(t) {
              if (a.active) return this;
              var i = o(t, "onActivate"),
                n = o(t, "onPostActivate"),
                r = o(t, "checkCanFocusTrap");
              r || d(),
                (a.active = !0),
                (a.paused = !1),
                (a.nodeFocusedBeforeActivation = s.activeElement),
                i && i();
              var l = function e() {
                r && d(), v(), n && n();
              };
              return r
                ? (r(a.containers.concat()).then(l, l), this)
                : (l(), this);
            },
            deactivate: function e(t) {
              if (!a.active) return this;
              clearTimeout(a.delayInitialFocusTimer),
                (a.delayInitialFocusTimer = void 0),
                y(),
                (a.active = !1),
                (a.paused = !1),
                D.deactivateTrap(n);
              var i = o(t, "onDeactivate"),
                s = o(t, "onPostDeactivate"),
                r = o(t, "checkCanReturnFocus");
              i && i();
              var l = o(t, "returnFocus", "returnFocusOnDeactivate"),
                c = function e() {
                  N(function () {
                    l && u(p(a.nodeFocusedBeforeActivation)), s && s();
                  });
                };
              return l && r
                ? (r(p(a.nodeFocusedBeforeActivation)).then(c, c), this)
                : (c(), this);
            },
            pause: function e() {
              return a.paused || !a.active || ((a.paused = !0), y()), this;
            },
            unpause: function e() {
              return a.paused && a.active && ((a.paused = !1), d(), v()), this;
            },
            updateContainerElements: function e(t) {
              var i = [].concat(t).filter(Boolean);
              return (
                (a.containers = i.map(function (e) {
                  return "string" == typeof e ? s.querySelector(e) : e;
                })),
                a.active && d(),
                this
              );
            },
          }).updateContainerElements(t),
          n
        );
      };
    function U(e, t, i) {
      let n = !1;
      e.type.includes("shopify:section")
        ? t.hasAttribute("section") &&
          t.getAttribute("section") === e.detail.sectionId &&
          (n = !0)
        : e.type.includes("shopify:block") && e.target === t && (n = !0),
        n && i(e);
    }
    var Y = class extends d {
      static get observedAttributes() {
        return ["open"];
      }
      constructor() {
        if (
          (super(),
          Shopify.designMode &&
            (this.rootDelegate.on("shopify:section:select", (e) =>
              U(e, this, () => (this.open = !0))
            ),
            this.rootDelegate.on("shopify:section:deselect", (e) =>
              U(e, this, () => (this.open = !1))
            )),
          this.hasAttribute("append-body"))
        ) {
          let e = document.getElementById(this.id);
          this.removeAttribute("append-body"),
            e && e !== this
              ? (e.replaceWith(this.cloneNode(!0)), this.remove())
              : document.body.appendChild(this);
        }
      }
      connectedCallback() {
        this.delegate.on("click", ".openable__overlay", () => (this.open = !1)),
          this.delegate.on("click", '[data-action="close"]', (e) => {
            e.stopPropagation(), (this.open = !1);
          });
      }
      get requiresLoading() {
        return this.hasAttribute("href");
      }
      get open() {
        return this.hasAttribute("open");
      }
      set open(e) {
        e
          ? (async () => {
              await this._load(),
                this.clientWidth,
                this.setAttribute("open", "");
            })()
          : this.removeAttribute("open");
      }
      get shouldTrapFocus() {
        return !0;
      }
      get returnFocusOnDeactivate() {
        return (
          !this.hasAttribute("return-focus") ||
          "true" === this.getAttribute("return-focus")
        );
      }
      get focusTrap() {
        return (this._focusTrap =
          this._focusTrap ||
          W(this, {
            fallbackFocus: this,
            initialFocus: this.hasAttribute("initial-focus-selector")
              ? this.getAttribute("initial-focus-selector")
              : void 0,
            clickOutsideDeactivates: (e) =>
              !(
                e.target.hasAttribute("aria-controls") &&
                e.target.getAttribute("aria-controls") === this.id
              ),
            allowOutsideClick: (e) =>
              e.target.hasAttribute("aria-controls") &&
              e.target.getAttribute("aria-controls") === this.id,
            returnFocusOnDeactivate: this.returnFocusOnDeactivate,
            onDeactivate: () => (this.open = !1),
            preventScroll: !0,
          }));
      }
      attributeChangedCallback(e, t, i) {
        "open" === e &&
          (null === t && "" === i
            ? (this.shouldTrapFocus &&
                setTimeout(() => this.focusTrap.activate(), 150),
              c(this, "openable-element:open"))
            : null === i &&
              (this.shouldTrapFocus && this.focusTrap.deactivate(),
              c(this, "openable-element:close")));
      }
      async _load() {
        if (!this.requiresLoading) return;
        h(this, "openable-element:load:start");
        let e = await fetch(this.getAttribute("href")),
          t = document.createElement("div");
        (t.innerHTML = await e.text()),
          (this.innerHTML = t.querySelector(
            this.tagName.toLowerCase()
          ).innerHTML),
          this.removeAttribute("href"),
          h(this, "openable-element:load:end");
      }
    };
    window.customElements.define("openable-element", Y);
    var j = class extends Y {
      constructor() {
        super(),
          (this.ignoreNextTransition = this.open),
          this.addEventListener("shopify:block:select", () => (this.open = !0)),
          this.addEventListener(
            "shopify:block:deselect",
            () => (this.open = !1)
          );
      }
      get animateItems() {
        return this.hasAttribute("animate-items");
      }
      attributeChangedCallback(e) {
        if (this.ignoreNextTransition) return (this.ignoreNextTransition = !1);
        if ("open" === e) {
          this.style.overflow = "hidden";
          let t = {
            height: ["0px", `${this.scrollHeight}px`],
            visibility: ["hidden", "visible"],
          };
          this.animateItems && (t.opacity = this.open ? [0, 0] : [0, 1]),
            (this.animate(t, {
              duration: 500,
              direction: this.open ? "normal" : "reverse",
              easing: "cubic-bezier(0.75, 0, 0.175, 1)",
            }).onfinish = () => {
              this.style.overflow = this.open ? "visible" : "hidden";
            }),
            this.animateItems &&
              this.open &&
              this.animate(
                {
                  opacity: [0, 1],
                  transform: ["translateY(10px)", "translateY(0)"],
                },
                {
                  duration: 250,
                  delay: 250,
                  easing: "cubic-bezier(0.75, 0, 0.175, 1)",
                }
              ),
            c(
              this,
              this.open ? "openable-element:open" : "openable-element:close"
            );
        }
      }
    };
    window.customElements.define("collapsible-content", j);
    var X = class extends HTMLButtonElement {
      connectedCallback() {
        this.addEventListener("click", (e) => {
          window.confirm(
            this.getAttribute("data-message") ||
              "Are you sure you wish to do this?"
          ) || e.preventDefault();
        });
      }
    };
    window.customElements.define("confirm-button", X, { extends: "button" });
    var G = {
        _prepareButton() {
          (this.originalContent = this.innerHTML),
            (this._startTransitionPromise = null),
            (this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `),
            (this.textElement = this.firstElementChild),
            (this.spinnerElement = this.lastElementChild),
            window.addEventListener("pagehide", () =>
              this.removeAttribute("aria-busy")
            );
        },
        _startTransition() {
          let e = this.textElement.animate(
            {
              opacity: [1, 0],
              transform: ["translateY(0)", "translateY(-10px)"],
            },
            { duration: 75, easing: "ease", fill: "forwards" }
          );
          this.spinnerElement.hidden = !1;
          let t = this.spinnerElement.animate(
            {
              opacity: [0, 1],
              transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"],
            },
            { duration: 75, delay: 75, easing: "ease", fill: "forwards" }
          );
          this._startTransitionPromise = Promise.all([
            new Promise((t) => (e.onfinish = () => t())),
            new Promise((e) => (t.onfinish = () => e())),
          ]);
        },
        async _endTransition() {
          this._startTransitionPromise &&
            (await this._startTransitionPromise,
            (this.spinnerElement.animate(
              {
                opacity: [1, 0],
                transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"],
              },
              { duration: 75, delay: 100, easing: "ease", fill: "forwards" }
            ).onfinish = () => (this.spinnerElement.hidden = !0)),
            this.textElement.animate(
              {
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0)"],
              },
              { duration: 75, delay: 175, easing: "ease", fill: "forwards" }
            ),
            (this._startTransitionPromise = null));
        },
      },
      K = class extends HTMLButtonElement {
        static get observedAttributes() {
          return ["aria-busy"];
        }
        constructor() {
          super(),
            this.addEventListener("click", (e) => {
              "submit" === this.type &&
                this.form &&
                this.form.checkValidity() &&
                !this.form.hasAttribute("is") &&
                (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
                  ? (e.preventDefault(),
                    this.setAttribute("aria-busy", "true"),
                    setTimeout(() => this.form.submit(), 250))
                  : this.setAttribute("aria-busy", "true"));
            });
        }
        connectedCallback() {
          this._prepareButton();
        }
        disconnectedCallback() {
          this.innerHTML = this.originalContent;
        }
        attributeChangedCallback(e, t, i) {
          "aria-busy" === e &&
            ("true" === i ? this._startTransition() : this._endTransition());
        }
      };
    Object.assign(K.prototype, G),
      window.customElements.define("loader-button", K, { extends: "button" });
    var Z = class extends d {
      connectedCallback() {
        this.hasAttribute("ajax") &&
          this.delegate.on("click", "a", this._onLinkClicked.bind(this));
      }
      _onLinkClicked(e, t) {
        e.preventDefault();
        let i = new URL(window.location.href);
        i.searchParams.set("page", t.getAttribute("data-page")),
          c(this, "pagination:page-changed", { url: i.toString() });
      }
    };
    window.customElements.define("page-pagination", Z);
    var Q = class extends HTMLButtonElement {
      static get observedAttributes() {
        return ["aria-expanded", "aria-busy"];
      }
      constructor() {
        super(),
          this.hasAttribute("loader") && this._prepareButton(),
          this.addEventListener("click", this._onButtonClick.bind(this)),
          (this.rootDelegate = new o(document.documentElement));
      }
      _onButtonClick() {
        this.isExpanded = !this.isExpanded;
      }
      connectedCallback() {
        document.addEventListener("openable-element:close", (e) => {
          this.controlledElement === e.target &&
            ((this.isExpanded = !1), e.stopPropagation());
        }),
          document.addEventListener("openable-element:open", (e) => {
            this.controlledElement === e.target &&
              ((this.isExpanded = !0), e.stopPropagation());
          }),
          this.rootDelegate.on(
            "openable-element:load:start",
            `#${this.getAttribute("aria-controls")}`,
            () => {
              this.classList.contains("button")
                ? this.setAttribute("aria-busy", "true")
                : null !== this.offsetParent &&
                  c(document.documentElement, "theme:loading:start");
            },
            !0
          ),
          this.rootDelegate.on(
            "openable-element:load:end",
            `#${this.getAttribute("aria-controls")}`,
            () => {
              this.classList.contains("button")
                ? this.removeAttribute("aria-busy")
                : null !== this.offsetParent &&
                  c(document.documentElement, "theme:loading:end");
            },
            !0
          );
      }
      disconnectedCallback() {
        this.rootDelegate.destroy();
      }
      get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
      }
      set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
      }
      get controlledElement() {
        return document.getElementById(this.getAttribute("aria-controls"));
      }
      attributeChangedCallback(e, t, i) {
        switch (e) {
          case "aria-expanded":
            "false" === t && "true" === i
              ? (this.controlledElement.open = !0)
              : "true" === t &&
                "false" === i &&
                (this.controlledElement.open = !1);
            break;
          case "aria-busy":
            this.hasAttribute("loader") &&
              ("true" === i ? this._startTransition() : this._endTransition());
        }
      }
    };
    Object.assign(Q.prototype, G),
      window.customElements.define("toggle-button", Q, { extends: "button" });
    var J = class extends HTMLAnchorElement {
      static get observedAttributes() {
        return ["aria-expanded"];
      }
      constructor() {
        super(),
          this.addEventListener("click", (e) => {
            e.preventDefault(), (this.isExpanded = !this.isExpanded);
          }),
          (this.rootDelegate = new o(document.documentElement));
      }
      connectedCallback() {
        this.rootDelegate.on(
          "openable-element:close",
          `#${this.getAttribute("aria-controls")}`,
          (e) => {
            this.controlledElement === e.target && (this.isExpanded = !1);
          },
          !0
        ),
          this.rootDelegate.on(
            "openable-element:open",
            `#${this.getAttribute("aria-controls")}`,
            (e) => {
              this.controlledElement === e.target && (this.isExpanded = !0);
            },
            !0
          );
      }
      disconnectedCallback() {
        this.rootDelegate.destroy();
      }
      get isExpanded() {
        return "true" === this.getAttribute("aria-expanded");
      }
      set isExpanded(e) {
        this.setAttribute("aria-expanded", e ? "true" : "false");
      }
      get controlledElement() {
        return document.querySelector(`#${this.getAttribute("aria-controls")}`);
      }
      attributeChangedCallback(e, t, i) {
        "aria-expanded" === e &&
          ("false" === t && "true" === i
            ? (this.controlledElement.open = !0)
            : "true" === t &&
              "false" === i &&
              (this.controlledElement.open = !1));
      }
    };
    window.customElements.define("toggle-link", J, { extends: "a" });
    var ee = class extends d {
      connectedCallback() {
        (this.buttons = Array.from(this.querySelectorAll("button"))),
          this.delegate.on("click", "button", (e, t) => {
            this._dispatchEvent(this.buttons.indexOf(t));
          }),
          this.hasAttribute("animation-timer") &&
            this.delegate.on("animationend", (e) => {
              e.elapsedTime > 0 &&
                this._dispatchEvent(
                  (this.selectedIndex + 1 + this.buttons.length) %
                    this.buttons.length
                );
            });
      }
      get selectedIndex() {
        return this.buttons.findIndex(
          (e) => "true" === e.getAttribute("aria-current")
        );
      }
      set selectedIndex(e) {
        if (
          (this.buttons.forEach((t, i) =>
            t.setAttribute("aria-current", e === i ? "true" : "false")
          ),
          this.hasAttribute("align-selected"))
        ) {
          let t = this.buttons[e],
            i = window.innerWidth / 2,
            n = t.getBoundingClientRect(),
            s = this._findFirstScrollableElement(this.parentElement);
          s &&
            s.scrollTo({
              behavior: "smooth",
              left: s.scrollLeft + (n.left - i) + n.width / 2,
            });
        }
      }
      _dispatchEvent(e) {
        e !== this.selectedIndex &&
          this.dispatchEvent(
            new CustomEvent("page-dots:changed", {
              bubbles: !0,
              detail: { index: e },
            })
          );
      }
      _findFirstScrollableElement(e, t = 0) {
        return null === e || t > 3
          ? null
          : e.scrollWidth > e.clientWidth
          ? e
          : this._findFirstScrollableElement(e.parentElement, t + 1);
      }
    };
    window.customElements.define("page-dots", ee);
    var et = class extends HTMLElement {
        connectedCallback() {
          (this.prevButton = this.querySelector("button:first-of-type")),
            (this.nextButton = this.querySelector("button:last-of-type")),
            this.prevButton.addEventListener("click", () =>
              this.prevButton.dispatchEvent(
                new CustomEvent("prev-next:prev", { bubbles: !0 })
              )
            ),
            this.nextButton.addEventListener("click", () =>
              this.nextButton.dispatchEvent(
                new CustomEvent("prev-next:next", { bubbles: !0 })
              )
            );
        }
        set isPrevDisabled(e) {
          this.prevButton.disabled = e;
        }
        set isNextDisabled(e) {
          this.nextButton.disabled = e;
        }
      },
      ei = class extends HTMLButtonElement {
        connectedCallback() {
          this.addEventListener("click", () =>
            this.dispatchEvent(
              new CustomEvent("prev-next:prev", { bubbles: !0 })
            )
          );
        }
      },
      en = class extends HTMLButtonElement {
        connectedCallback() {
          this.addEventListener("click", () =>
            this.dispatchEvent(
              new CustomEvent("prev-next:next", { bubbles: !0 })
            )
          );
        }
      };
    function es() {
      let e = getComputedStyle(document.documentElement);
      return (
        parseInt(e.getPropertyValue("--header-height") || 0) *
          parseInt(e.getPropertyValue("--enable-sticky-header") || 0) +
        parseInt(e.getPropertyValue("--announcement-bar-height") || 0) *
          parseInt(e.getPropertyValue("--enable-sticky-announcement-bar") || 0)
      );
    }
    window.customElements.define("prev-next-buttons", et),
      window.customElements.define("prev-button", ei, { extends: "button" }),
      window.customElements.define("next-button", en, { extends: "button" });
    var er = class extends HTMLElement {
      connectedCallback() {
        (this.lastKnownY = window.scrollY),
          (this.currentTop = 0),
          (this.hasPendingRaf = !1),
          window.addEventListener("scroll", this._checkPosition.bind(this));
      }
      get initialTopOffset() {
        return es() + (parseInt(this.getAttribute("offset")) || 0);
      }
      _checkPosition() {
        !this.hasPendingRaf &&
          ((this.hasPendingRaf = !0),
          requestAnimationFrame(() => {
            let e =
                this.getBoundingClientRect().top +
                window.scrollY -
                this.offsetTop +
                this.initialTopOffset,
              t = this.clientHeight - window.innerHeight;
            window.scrollY < this.lastKnownY
              ? (this.currentTop -= window.scrollY - this.lastKnownY)
              : (this.currentTop += this.lastKnownY - window.scrollY),
              (this.currentTop = Math.min(
                Math.max(this.currentTop, -t),
                e,
                this.initialTopOffset
              )),
              (this.lastKnownY = window.scrollY),
              (this.style.top = `${this.currentTop}px`),
              (this.hasPendingRaf = !1);
          }));
      }
    };
    function ea(e, t = 15) {
      let i = null,
        n = null,
        s = (r) => {
          n = r;
          let a = !i;
          a &&
            (e(n),
            (n = null),
            (i = setTimeout(() => {
              (i = null), n && s(n);
            }, t)));
        };
      return s;
    }
    window.customElements.define("safe-sticky", er);
    var eo,
      el,
      ec = class extends HTMLElement {
        connectedCallback() {
          this._createSvg(),
            (this.elementsToObserve = Array.from(
              this.querySelectorAll("a")
            ).map((e) => document.querySelector(e.getAttribute("href")))),
            (this.navListItems = Array.from(this.querySelectorAll("li"))),
            (this.navItems = this.navListItems
              .map((e) => {
                let t = e.firstElementChild,
                  i = t && t.getAttribute("href").slice(1),
                  n = document.getElementById(i);
                return { listItem: e, anchor: t, target: n };
              })
              .filter((e) => e.target)),
            this.drawPath(),
            window.addEventListener(
              "scroll",
              ea(this.markVisibleSection.bind(this), 25)
            ),
            window.addEventListener("orientationchange", () => {
              window.addEventListener(
                "resize",
                () => {
                  this.drawPath(), this.markVisibleSection();
                },
                { once: !0 }
              );
            }),
            this.markVisibleSection();
        }
        _createSvg() {
          this.navPath = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "path"
          );
          let e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          e.insertAdjacentElement("beforeend", this.navPath),
            this.insertAdjacentElement("beforeend", e),
            (this.lastPathStart = this.lastPathEnd = null);
        }
        drawPath() {
          let e = [],
            t;
          this.navItems.forEach((i, n) => {
            let s = i.anchor.offsetLeft - 5,
              r = i.anchor.offsetTop,
              a = i.anchor.offsetHeight;
            0 === n
              ? (e.push("M", s, r, "L", s, r + a), (i.pathStart = 0))
              : (t !== s && e.push("L", t, r),
                e.push("L", s, r),
                this.navPath.setAttribute("d", e.join(" ")),
                (i.pathStart = this.navPath.getTotalLength() || 0),
                e.push("L", s, r + a)),
              (t = s),
              this.navPath.setAttribute("d", e.join(" ")),
              (i.pathEnd = this.navPath.getTotalLength());
          });
        }
        syncPath() {
          let e = (e) => e.classList.contains("is-visible"),
            t = this.navPath.getTotalLength(),
            i = t,
            n = 0;
          if (
            (this.navItems.forEach((t) => {
              e(t.listItem) &&
                ((i = Math.min(t.pathStart, i)), (n = Math.max(t.pathEnd, n)));
            }),
            this.querySelectorAll(".is-visible").length > 0 && i < n)
          ) {
            if (i !== this.lastPathStart || n !== this.lastPathEnd) {
              let s = `1 ${i} ${n - i} ${t}`;
              this.navPath.style.setProperty("stroke-dashoffset", "1"),
                this.navPath.style.setProperty("stroke-dasharray", s),
                this.navPath.style.setProperty("opacity", "1");
            }
          } else this.navPath.style.setProperty("opacity", "0");
          (this.lastPathStart = i), (this.lastPathEnd = n);
        }
        markVisibleSection() {
          for (let [e, t] of (this.navListItems.forEach((e) =>
            e.classList.remove("is-visible")
          ),
          this.elementsToObserve.entries())) {
            let i = t.getBoundingClientRect();
            if (i.top > es() || e === this.elementsToObserve.length - 1) {
              this.querySelector(
                `a[href="#${t.id}"]`
              ).parentElement.classList.add("is-visible");
              break;
            }
          }
          this.syncPath();
        }
      };
    window.customElements.define("scroll-spy", ec);
    var eh = class extends HTMLElement {
      constructor() {
        super(),
          (this.attachShadow({ mode: "open" }).innerHTML = `
  <style>
    :host {
      display: inline-block;
      contain: layout;
      position: relative;
    }
    
    :host([hidden]) {
      display: none;
    }
    
    s {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      pointer-events: none;
      background-image:
        var(--scroll-shadow-top, radial-gradient(farthest-side at 50% 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-bottom, radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-left, radial-gradient(farthest-side at 0%, rgba(0,0,0,.2), rgba(0,0,0,0))),
        var(--scroll-shadow-right, radial-gradient(farthest-side at 100%, rgba(0,0,0,.2), rgba(0,0,0,0)));
      background-position: top, bottom, left, right;
      background-repeat: no-repeat;
      background-size: 100% var(--top, 0), 100% var(--bottom, 0), var(--left, 0) 100%, var(--right, 0) 100%;
    }
  </style>
  <slot></slot>
  <s></s>
`),
          (this.updater = new (class {
            constructor(e) {
              (this.scheduleUpdate = ea(() =>
                this.update(e, getComputedStyle(e))
              )),
                (this.resizeObserver = new ResizeObserver(
                  this.scheduleUpdate.bind(this)
                ));
            }
            start(e) {
              this.element && this.stop(),
                e &&
                  (e.addEventListener("scroll", this.scheduleUpdate),
                  this.resizeObserver.observe(e),
                  (this.element = e));
            }
            stop() {
              this.element &&
                (this.element.removeEventListener(
                  "scroll",
                  this.scheduleUpdate
                ),
                this.resizeObserver.unobserve(this.element),
                (this.element = null));
            }
            update(e, t) {
              if (!this.element) return;
              let i = t.getPropertyValue("--scroll-shadow-size")
                  ? parseInt(t.getPropertyValue("--scroll-shadow-size"))
                  : 0,
                n = {
                  top: Math.max(this.element.scrollTop, 0),
                  bottom: Math.max(
                    this.element.scrollHeight -
                      this.element.offsetHeight -
                      this.element.scrollTop,
                    0
                  ),
                  left: Math.max(this.element.scrollLeft, 0),
                  right: Math.max(
                    this.element.scrollWidth -
                      this.element.offsetWidth -
                      this.element.scrollLeft,
                    0
                  ),
                };
              requestAnimationFrame(() => {
                for (let t of ["top", "bottom", "left", "right"])
                  e.style.setProperty(`--${t}`, `${n[t] > i ? i : n[t]}px`);
              });
            }
          })(this.shadowRoot.lastElementChild));
      }
      connectedCallback() {
        this.shadowRoot
          .querySelector("slot")
          .addEventListener("slotchange", () => this.start()),
          this.start();
      }
      disconnectedCallback() {
        this.updater.stop();
      }
      start() {
        this.updater.start(this.firstElementChild);
      }
    };
    "ResizeObserver" in window &&
      window.customElements.define("scroll-shadow", eh);
    var ed = class extends Q {
      _onButtonClick() {
        window.matchMedia(window.themeVariables.breakpoints.phone).matches &&
        navigator.share
          ? navigator.share({
              title: this.hasAttribute("share-title")
                ? this.getAttribute("share-title")
                : document.title,
              url: this.hasAttribute("share-url")
                ? this.getAttribute("share-url")
                : window.location.href,
            })
          : super._onButtonClick();
      }
    };
    window.customElements.define("share-toggle-button", ed, {
      extends: "button",
    });
    var eu = class extends d {
        connectedCallback() {
          (this.items = Array.from(
            this.querySelectorAll("native-carousel-item")
          )),
            (this.pageDotsElements = Array.from(
              this.querySelectorAll("page-dots")
            )),
            (this.prevNextButtonsElements = Array.from(
              this.querySelectorAll("prev-next-buttons")
            )),
            this.items.length > 1 &&
              (this.addEventListener("prev-next:prev", this.prev.bind(this)),
              this.addEventListener("prev-next:next", this.next.bind(this)),
              this.addEventListener("page-dots:changed", (e) =>
                this.select(e.detail.index, !0)
              ),
              Shopify.designMode &&
                this.addEventListener("shopify:block:select", (e) =>
                  this.select(e.target.index, !e.detail.load)
                ));
          let e = this.items[0].parentElement;
          (this.intersectionObserver = new IntersectionObserver(
            this._onVisibilityChanged.bind(this),
            { root: e, rootMargin: `${e.clientHeight}px 0px`, threshold: 0.8 }
          )),
            this.items.forEach((e) => this.intersectionObserver.observe(e));
        }
        disconnectedCallback() {
          super.disconnectedCallback(), this.intersectionObserver.disconnect();
        }
        get selectedIndex() {
          return this.items.findIndex((e) => e.selected);
        }
        prev(e = !0) {
          this.select(Math.max(this.selectedIndex - 1, 0), e);
        }
        next(e = !0) {
          this.select(
            Math.min(this.selectedIndex + 1, this.items.length - 1),
            e
          );
        }
        select(e, t = !0) {
          let i = Math.max(0, Math.min(e, this.items.length)),
            n = this.items[i];
          this._adjustNavigationForElement(n),
            t &&
              (this.items.forEach((e) =>
                this.intersectionObserver.unobserve(e)
              ),
              setInterval(() => {
                this.items.forEach((e) => this.intersectionObserver.observe(e));
              }, 800)),
            this.items.forEach((e, t) => (e.selected = t === i));
          let s = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
          n.parentElement.scrollTo({
            left: s * (n.clientWidth * i),
            behavior: t ? "smooth" : "auto",
          });
        }
        _adjustNavigationForElement(e) {
          this.items.forEach((t) => (t.selected = e === t)),
            this.pageDotsElements.forEach((t) => (t.selectedIndex = e.index)),
            this.prevNextButtonsElements.forEach((t) => {
              (t.isPrevDisabled = 0 === e.index),
                (t.isNextDisabled = e.index === this.items.length - 1);
            });
        }
        _onVisibilityChanged(e) {
          for (let t of e)
            if (t.isIntersecting) {
              this._adjustNavigationForElement(t.target);
              break;
            }
        }
      },
      ep = class extends d {
        static get observedAttributes() {
          return ["hidden"];
        }
        get index() {
          return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
          return !this.hasAttribute("hidden");
        }
        set selected(e) {
          this.hidden = !e;
        }
      };
    window.customElements.define("native-carousel-item", ep),
      window.customElements.define("native-carousel", eu);
    var em = class extends HTMLElement {
      connectedCallback() {
        (this.scrollableElement = this.parentElement),
          this.scrollableElement.addEventListener(
            "mouseenter",
            this._onMouseEnter.bind(this)
          ),
          this.scrollableElement.addEventListener(
            "mousemove",
            this._onMouseMove.bind(this)
          ),
          this.scrollableElement.addEventListener(
            "mouseleave",
            this._onMouseLeave.bind(this)
          ),
          (this.innerHTML = `
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
        <path d="M0 60C0 26.863 26.863 0 60 0s60 26.863 60 60-26.863 60-60 60S0 93.137 0 60z" fill="rgb(var(--text-color))"/>
        <path d="M46 50L36 60l10 10M74 50l10 10-10 10" stroke="rgb(var(--section-background))" stroke-width="4"/>
      </svg>
    `);
      }
      _onMouseEnter(e) {
        this.removeAttribute("hidden"), this._positionCursor(e);
      }
      _onMouseLeave() {
        this.setAttribute("hidden", "");
      }
      _onMouseMove(e) {
        this.toggleAttribute(
          "hidden",
          "BUTTON" === e.target.tagName || "A" === e.target.tagName
        ),
          this._positionCursor(e);
      }
      _positionCursor(e) {
        let t = this.scrollableElement.getBoundingClientRect(),
          i = e.clientX - t.x,
          n = e.clientY - t.y;
        this.style.transform = `translate(${i - this.clientWidth / 2}px, ${
          n - this.clientHeight / 2
        }px)`;
      }
    };
    window.customElements.define("drag-cursor", em);
    var ef = class extends d {
      connectedCallback() {
        this.draggable && this._setupDraggability(),
          this._checkScrollability(),
          window.addEventListener(
            "resize",
            this._checkScrollability.bind(this)
          ),
          this.addEventListener(
            "scroll",
            ea(this._calculateProgress.bind(this), 15)
          );
      }
      get draggable() {
        return this.hasAttribute("draggable");
      }
      _setupDraggability() {
        this.insertAdjacentHTML(
          "afterend",
          '<drag-cursor hidden class="custom-drag-cursor"></drag-cursor>'
        );
        let e = matchMedia("(hover: none)");
        e.addListener(this._onMediaChanges.bind(this)),
          e.matches || this._attachDraggableListeners();
      }
      _attachDraggableListeners() {
        this.delegate.on("mousedown", this._onMouseDown.bind(this)),
          this.delegate.on("mousemove", this._onMouseMove.bind(this)),
          this.delegate.on("mouseup", this._onMouseUp.bind(this));
      }
      _removeDraggableListeners() {
        this.delegate.off("mousedown"),
          this.delegate.off("mousemove"),
          this.delegate.off("mouseup");
      }
      _checkScrollability() {
        this.classList.toggle(
          "is-scrollable",
          this.scrollWidth > this.offsetWidth
        );
      }
      _calculateProgress() {
        let e =
            this.scrollLeft *
            ("ltr" === window.themeVariables.settings.direction ? 1 : -1),
          t =
            100 *
            Math.max(0, Math.min(1, e / (this.scrollWidth - this.clientWidth)));
        c(this, "scrollable-content:progress", { progress: t });
      }
      _onMediaChanges(e) {
        e.matches
          ? this._removeDraggableListeners()
          : this._attachDraggableListeners();
      }
      _onMouseDown(e) {
        e.target && "IMG" === e.target.nodeName && e.preventDefault(),
          (this.startX = e.clientX + this.scrollLeft),
          (this.diffX = 0),
          (this.drag = !0);
      }
      _onMouseMove(e) {
        this.drag &&
          ((this.diffX = this.startX - (e.clientX + this.scrollLeft)),
          (this.scrollLeft += this.diffX));
      }
      _onMouseUp() {
        this.drag = !1;
        let e = 1,
          t = () => {
            let i = Math.sinh(e);
            i <= 0
              ? window.cancelAnimationFrame(t)
              : ((this.scrollLeft += this.diffX * i),
                (e -= 0.03),
                window.requestAnimationFrame(t));
          };
        t();
      }
    };
    window.customElements.define("scrollable-content", ef);
    var e$ = class extends d {
      constructor() {
        super(),
          this.rootDelegate.on("theme:loading:start", this.show.bind(this)),
          this.rootDelegate.on("theme:loading:end", this.hide.bind(this)),
          this.delegate.on("transitionend", this._onTransitionEnd.bind(this));
      }
      show() {
        this.classList.add("is-visible"),
          (this.style.transform = "scaleX(0.4)");
      }
      hide() {
        (this.style.transform = "scaleX(1)"), this.classList.add("is-finished");
      }
      _onTransitionEnd(e) {
        "transform" === e.propertyName &&
          this.classList.contains("is-finished") &&
          (this.classList.remove("is-visible"),
          this.classList.remove("is-finished"),
          (this.style.transform = "scaleX(0)"));
      }
    };
    window.customElements.define("loading-bar", e$);
    var eg = class extends HTMLElement {
      connectedCallback() {
        (this.originalContent = this.textContent),
          (this.lastWidth = window.innerWidth),
          (this.hasBeenSplitted = !1),
          window.addEventListener("resize", this._onResize.bind(this));
      }
      [Symbol.asyncIterator]() {
        return {
          splitPromise: this.split.bind(this),
          index: 0,
          async next() {
            let e = await this.splitPromise();
            return this.index !== e.length
              ? { done: !1, value: e[this.index++] }
              : { done: !0 };
          },
        };
      }
      split(e = !1) {
        return this.childElementCount > 0 && !e
          ? Promise.resolve(Array.from(this.children))
          : ((this.hasBeenSplitted = !0),
            new Promise((t) => {
              requestAnimationFrame(() => {
                this.innerHTML = this.originalContent
                  .replace(/./g, "<span>$&</span>")
                  .replace(/\s/g, " ");
                let i = {};
                Array.from(this.children).forEach((e) => {
                  let t = parseInt(e.getBoundingClientRect().top);
                  i[t] = (i[t] || "") + e.textContent;
                }),
                  (this.innerHTML = Object.values(i)
                    .map(
                      (t) =>
                        `<span ${
                          this.hasAttribute("reveal") && !e ? "reveal" : ""
                        } ${
                          this.hasAttribute("reveal-visibility") && !e
                            ? "reveal-visibility"
                            : ""
                        } style="display: block">${t.trim()}</span>`
                    )
                    .join("")),
                  (this.style.opacity = this.hasAttribute("reveal") ? 1 : null),
                  (this.style.visibility = this.hasAttribute(
                    "reveal-visibility"
                  )
                    ? "visible"
                    : null),
                  t(Array.from(this.children));
              });
            }));
      }
      async _onResize() {
        this.lastWidth !== window.innerWidth &&
          this.hasBeenSplitted &&
          (await this.split(!0),
          this.dispatchEvent(
            new CustomEvent("split-lines:re-split", { bubbles: !0 })
          ),
          (this.lastWidth = window.innerWidth));
      }
    };
    window.customElements.define("split-lines", eg);
    var eb = class extends Y {
      connectedCallback() {
        super.connectedCallback(),
          this.delegate.on(
            "click",
            ".popover__overlay",
            () => (this.open = !1)
          );
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
          "open" === e &&
            document.documentElement.classList.toggle("lock-mobile", this.open);
      }
    };
    window.customElements.define("popover-content", eb);
    var ev = class extends HTMLElement {
      connectedCallback() {
        (this.buttons = Array.from(
          this.querySelectorAll("button[aria-controls]")
        )),
          (this.scrollerElement = this.querySelector(".tabs-nav__scroller")),
          this.buttons.forEach((e) =>
            e.addEventListener("click", () => this.selectButton(e))
          ),
          this.addEventListener("shopify:block:select", (e) =>
            this.selectButton(e.target, !e.detail.load)
          ),
          (this.positionElement = document.createElement("span")),
          this.positionElement.classList.add("tabs-nav__position"),
          this.buttons[0].parentElement.insertAdjacentElement(
            "afterend",
            this.positionElement
          ),
          window.addEventListener("resize", this._onWindowResized.bind(this)),
          this._adjustNavigationPosition(),
          this.hasArrows && this._handleArrows();
      }
      get hasArrows() {
        return this.hasAttribute("arrows");
      }
      get selectedTabIndex() {
        return this.buttons.findIndex(
          (e) => "true" === e.getAttribute("aria-expanded")
        );
      }
      get selectedButton() {
        return this.buttons.find(
          (e) => "true" === e.getAttribute("aria-expanded")
        );
      }
      selectButton(e, t = !0) {
        if (!this.buttons.includes(e) || this.selectedButton === e) return;
        let i = document.getElementById(
            this.selectedButton.getAttribute("aria-controls")
          ),
          n = document.getElementById(e.getAttribute("aria-controls"));
        t ? this._transitionContent(i, n) : ((i.hidden = !0), (n.hidden = !1)),
          this.selectedButton.setAttribute("aria-expanded", "false"),
          e.setAttribute("aria-expanded", "true"),
          c(this, "tabs-nav:changed", { button: e }),
          this._adjustNavigationPosition();
      }
      addButton(e) {
        e.addEventListener("click", () => this.selectButton(e)),
          e.setAttribute("aria-expanded", "false"),
          this.buttons[this.buttons.length - 1].insertAdjacentElement(
            "afterend",
            e
          ),
          this.buttons.push(e),
          this._adjustNavigationPosition(!1);
      }
      _transitionContent(e, t) {
        e.animate(
          { opacity: [1, 0] },
          { duration: 250, easing: "ease" }
        ).onfinish = () => {
          (e.hidden = !0),
            (t.hidden = !1),
            t.animate({ opacity: [0, 1] }, { duration: 250, easing: "ease" });
        };
      }
      _onWindowResized() {
        this._adjustNavigationPosition();
      }
      _adjustNavigationPosition(e = !0) {
        let t =
            this.selectedButton.clientWidth /
            this.positionElement.parentElement.clientWidth,
          i =
            this.selectedButton.offsetLeft /
            this.positionElement.parentElement.clientWidth /
            t,
          n = this.scrollerElement.clientWidth / 2;
        this.scrollerElement.scrollTo({
          behavior: e ? "smooth" : "auto",
          left:
            this.selectedButton.offsetLeft -
            n +
            this.selectedButton.clientWidth / 2,
        }),
          e || (this.positionElement.style.transition = "none"),
          this.positionElement.style.setProperty("--scale", t),
          this.positionElement.style.setProperty("--translate", `${100 * i}%`),
          this.positionElement.clientWidth,
          requestAnimationFrame(() => {
            this.positionElement.classList.add("is-initialized"),
              (this.positionElement.style.transition = null);
          });
      }
      _handleArrows() {
        let e = this.querySelector(".tabs-nav__arrows");
        e.firstElementChild.addEventListener("click", () => {
          this.selectButton(
            this.buttons[Math.max(this.selectedTabIndex - 1, 0)]
          );
        }),
          e.lastElementChild.addEventListener("click", () => {
            this.selectButton(
              this.buttons[
                Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)
              ]
            );
          });
      }
    };
    window.customElements.define("tabs-nav", ev);
    var ey = class {
      static load(e) {
        let t = "requested",
          i = "loaded",
          n = this.libraries[e];
        if (!n) return;
        if (n.status === t) return n.promise;
        if (n.status === i) return Promise.resolve();
        let s;
        return (
          (s = new Promise(
            "script" === n.type
              ? (e, t) => {
                  let s = document.createElement("script");
                  (s.id = n.tagId),
                    (s.src = n.src),
                    (s.onerror = t),
                    (s.onload = () => {
                      (n.status = i), e();
                    }),
                    document.body.appendChild(s);
                }
              : (e, t) => {
                  let s = document.createElement("link");
                  (s.id = n.tagId),
                    (s.href = n.src),
                    (s.rel = "stylesheet"),
                    (s.type = "text/css"),
                    (s.onerror = t),
                    (s.onload = () => {
                      (n.status = i), e();
                    }),
                    document.body.appendChild(s);
                }
          )),
          (n.promise = s),
          (n.status = t),
          s
        );
      }
    };
    i(ey, "libraries", {
      flickity: {
        tagId: "flickity",
        src: window.themeVariables.libs.flickity,
        type: "script",
      },
      photoswipe: {
        tagId: "photoswipe",
        src: window.themeVariables.libs.photoswipe,
        type: "script",
      },
      qrCode: {
        tagId: "qrCode",
        src: window.themeVariables.libs.qrCode,
        type: "script",
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: "link",
      },
    });
    var e_ = class extends HTMLElement {
      async connectedCallback() {
        await ey.load("qrCode"),
          new window.QRCode(this, {
            text: this.getAttribute("identifier"),
            width: 200,
            height: 200,
          });
      }
    };
    window.customElements.define("qr-code", e_);
    var e8 = class extends HTMLSelectElement {
      connectedCallback() {
        if (
          ((this.provinceElement = document.getElementById(
            this.getAttribute("aria-owns")
          )),
          this.addEventListener(
            "change",
            this._updateProvinceVisibility.bind(this)
          ),
          this.hasAttribute("data-default"))
        ) {
          for (let e = 0; e !== this.options.length; ++e)
            if (this.options[e].text === this.getAttribute("data-default")) {
              this.selectedIndex = e;
              break;
            }
        }
        this._updateProvinceVisibility();
        let t =
          "SELECT" === this.provinceElement.tagName
            ? this.provinceElement
            : this.provinceElement.querySelector("select");
        if (t.hasAttribute("data-default")) {
          for (let i = 0; i !== t.options.length; ++i)
            if (t.options[i].text === t.getAttribute("data-default")) {
              t.selectedIndex = i;
              break;
            }
        }
      }
      _updateProvinceVisibility() {
        let e = this.options[this.selectedIndex];
        if (!e) return;
        let t = JSON.parse(e.getAttribute("data-provinces") || "[]"),
          i =
            "SELECT" === this.provinceElement.tagName
              ? this.provinceElement
              : this.provinceElement.querySelector("select");
        if (((i.innerHTML = ""), 0 === t.length)) {
          this.provinceElement.hidden = !0;
          return;
        }
        t.forEach((e) => {
          i.options.add(new Option(e[1], e[0]));
        }),
          (this.provinceElement.hidden = !1);
      }
    };
    window.customElements.define("country-selector", e8, { extends: "select" });
    var ew = class extends Y {
      connectedCallback() {
        super.connectedCallback(),
          this.appearAfterDelay &&
            !(this.onlyOnce && this.hasAppearedOnce) &&
            setTimeout(() => (this.open = !0), this.apparitionDelay),
          this.delegate.on("click", ".modal__overlay", () => (this.open = !1));
      }
      get appearAfterDelay() {
        return this.hasAttribute("apparition-delay");
      }
      get apparitionDelay() {
        return 1e3 * parseInt(this.getAttribute("apparition-delay") || 0);
      }
      get onlyOnce() {
        return this.hasAttribute("only-once");
      }
      get hasAppearedOnce() {
        return null !== localStorage.getItem("theme:popup-appeared");
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
          "open" === e &&
            (document.documentElement.classList.toggle("lock-all", this.open),
            this.open && localStorage.setItem("theme:popup-appeared", !0));
      }
    };
    window.customElements.define("modal-content", ew);
    var eE = class extends HTMLElement {
      connectedCallback() {
        (this.rangeLowerBound = this.querySelector(
          ".price-range__range-group input:first-child"
        )),
          (this.rangeHigherBound = this.querySelector(
            ".price-range__range-group input:last-child"
          )),
          (this.textInputLowerBound = this.querySelector(
            ".price-range__input:first-child input"
          )),
          (this.textInputHigherBound = this.querySelector(
            ".price-range__input:last-child input"
          )),
          this.textInputLowerBound.addEventListener("focus", () =>
            this.textInputLowerBound.select()
          ),
          this.textInputHigherBound.addEventListener("focus", () =>
            this.textInputHigherBound.select()
          ),
          this.textInputLowerBound.addEventListener("change", (e) => {
            (e.target.value = Math.max(
              Math.min(
                parseInt(e.target.value),
                parseInt(this.textInputHigherBound.value || e.target.max) - 1
              ),
              e.target.min
            )),
              (this.rangeLowerBound.value = e.target.value),
              this.rangeLowerBound.parentElement.style.setProperty(
                "--range-min",
                `${
                  (parseInt(this.rangeLowerBound.value) /
                    parseInt(this.rangeLowerBound.max)) *
                  100
                }%`
              );
          }),
          this.textInputHigherBound.addEventListener("change", (e) => {
            (e.target.value = Math.min(
              Math.max(
                parseInt(e.target.value),
                parseInt(this.textInputLowerBound.value || e.target.min) + 1
              ),
              e.target.max
            )),
              (this.rangeHigherBound.value = e.target.value),
              this.rangeHigherBound.parentElement.style.setProperty(
                "--range-max",
                `${
                  (parseInt(this.rangeHigherBound.value) /
                    parseInt(this.rangeHigherBound.max)) *
                  100
                }%`
              );
          }),
          this.rangeLowerBound.addEventListener("change", (e) => {
            (this.textInputLowerBound.value = e.target.value),
              this.textInputLowerBound.dispatchEvent(
                new Event("change", { bubbles: !0 })
              );
          }),
          this.rangeHigherBound.addEventListener("change", (e) => {
            (this.textInputHigherBound.value = e.target.value),
              this.textInputHigherBound.dispatchEvent(
                new Event("change", { bubbles: !0 })
              );
          }),
          this.rangeLowerBound.addEventListener("input", (e) => {
            c(this, "facet:abort-loading"),
              (e.target.value = Math.min(
                parseInt(e.target.value),
                parseInt(this.textInputHigherBound.value || e.target.max) - 1
              )),
              e.target.parentElement.style.setProperty(
                "--range-min",
                `${(parseInt(e.target.value) / parseInt(e.target.max)) * 100}%`
              ),
              (this.textInputLowerBound.value = e.target.value);
          }),
          this.rangeHigherBound.addEventListener("input", (e) => {
            c(this, "facet:abort-loading"),
              (e.target.value = Math.max(
                parseInt(e.target.value),
                parseInt(this.textInputLowerBound.value || e.target.min) + 1
              )),
              e.target.parentElement.style.setProperty(
                "--range-max",
                `${(parseInt(e.target.value) / parseInt(e.target.max)) * 100}%`
              ),
              (this.textInputHigherBound.value = e.target.value);
          });
      }
    };
    window.customElements.define("price-range", eE);
    var ex = class extends HTMLElement {
      connectedCallback() {
        let e = this.querySelector(".link-bar__link-item--selected");
        e &&
          requestAnimationFrame(() => {
            e.style.scrollSnapAlign = "none";
          });
      }
    };
    window.customElements.define("link-bar", ex);
    var ek = class {
        static prefersReducedMotion() {
          return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        static supportsHover() {
          return window.matchMedia("(pointer: fine)").matches;
        }
      },
      eS = class extends d {
        constructor() {
          if ((super(), 1 === this.childElementCount)) return;
          this.addEventListener(
            "flickity:ready",
            this._preloadNextImage.bind(this)
          ),
            this.addEventListener(
              "flickity:slide-changed",
              this._preloadNextImage.bind(this)
            ),
            this._createFlickity();
        }
        async disconnectedCallback() {
          if (this.flickity) {
            let e = await this.flickity;
            e.destroy();
          }
        }
        get flickityConfig() {
          return JSON.parse(this.getAttribute("flickity-config"));
        }
        get flickityInstance() {
          return this.flickity;
        }
        async next() {
          (await this.flickityInstance).next();
        }
        async previous() {
          (await this.flickityInstance).previous();
        }
        async select(e) {
          (await this.flickityInstance).selectCell(e);
        }
        async setDraggable(e) {
          let t = await this.flickity;
          (t.options.draggable = e), t.updateDraggable();
        }
        async reload() {
          let e = await this.flickity;
          e.destroy(),
            this.flickityConfig.cellSelector &&
              Array.from(this.children)
                .sort((e, t) =>
                  parseInt(e.getAttribute("data-original-position")) >
                  parseInt(t.getAttribute("data-original-position"))
                    ? 1
                    : -1
                )
                .forEach((e) => this.appendChild(e)),
            this._createFlickity();
        }
        async _createFlickity() {
          if (
            ((this.flickity = new Promise(async (e) => {
              await ey.load("flickity"),
                await this.untilVisible({ rootMargin: "400px", threshold: 0 });
              let t = new window.ThemeFlickity(this, {
                ...this.flickityConfig,
                rightToLeft: "rtl" === window.themeVariables.settings.direction,
                accessibility: ek.supportsHover(),
                on: {
                  ready: (e) => c(this, "flickity:ready", e),
                  change: (e) => c(this, "flickity:slide-changed", e),
                  settle: (e) => c(this, "flickity:slide-settled", e),
                },
              });
              e(t);
            })),
            this.hasAttribute("click-nav"))
          ) {
            let e = await this.flickityInstance;
            e.on("staticClick", this._onStaticClick.bind(this)),
              this.addEventListener("mousemove", this._onMouseMove.bind(this));
          }
        }
        async _onStaticClick(e, t, i) {
          let n = await this.flickityInstance,
            s =
              n.selectedElement.hasAttribute("data-media-type") &&
              ["video", "external_video", "model"].includes(
                n.selectedElement.getAttribute("data-media-type")
              );
          if (
            !i ||
            s ||
            window.matchMedia(window.themeVariables.breakpoints.phone).matches
          )
            return;
          let r = n.viewport,
            a = r.getBoundingClientRect(),
            o = Math.floor(a.right - a.width / 2);
          t.clientX > o ? n.next() : n.previous();
        }
        async _onMouseMove(e) {
          let t = await this.flickityInstance,
            i =
              t.selectedElement.hasAttribute("data-media-type") &&
              ["video", "external_video", "model"].includes(
                t.selectedElement.getAttribute("data-media-type")
              );
          this.classList.toggle(
            "is-hovering-right",
            e.offsetX > this.clientWidth / 2 && !i
          ),
            this.classList.toggle(
              "is-hovering-left",
              e.offsetX <= this.clientWidth / 2 && !i
            );
        }
        async _preloadNextImage() {
          var e;
          let t = await this.flickity;
          t.selectedElement.nextElementSibling &&
            (null ==
              (e = t.selectedElement.nextElementSibling.querySelector("img")) ||
              e.setAttribute("loading", "eager"));
        }
      };
    function eL(e, t, i = !1) {
      let n = [],
        s = e;
      for (; (s = s.previousElementSibling); )
        (!t || s.matches(t)) && n.push(s);
      for (i && n.push(e), s = e; (s = s.nextElementSibling); )
        (!t || s.matches(t)) && n.push(s);
      return n;
    }
    async function eT(e) {
      let t = [];
      for (let i of ((null != e && "function" == typeof e[Symbol.iterator]) ||
        (e = [e]),
      e))
        if ("function" == typeof i[Symbol.asyncIterator])
          for await (let n of i) t.push(n);
        else t.push(i);
      return t;
    }
    window.customElements.define("flickity-carousel", eS);
    var eA = class extends d {
      async connectedCallback() {
        this.flickityCarousel.addEventListener(
          "flickity:ready",
          this._onSlideChanged.bind(this, !1)
        ),
          this.flickityCarousel.addEventListener(
            "flickity:slide-changed",
            this._onSlideChanged.bind(this, !0)
          ),
          this.delegate.on("click", '[data-action="prev"]', () =>
            this.flickityCarousel.previous()
          ),
          this.delegate.on("click", '[data-action="next"]', () =>
            this.flickityCarousel.next()
          ),
          this.delegate.on("click", '[data-action="select"]', (e, t) =>
            this.flickityCarousel.select(`#${t.getAttribute("aria-controls")}`)
          );
      }
      get flickityCarousel() {
        return (this._flickityCarousel =
          this._flickityCarousel ||
          document.getElementById(this.getAttribute("controls")));
      }
      async _onSlideChanged(e = !0) {
        let t = await this.flickityCarousel.flickityInstance;
        Array.from(
          this.querySelectorAll(`[aria-controls="${t.selectedElement.id}"]`)
        ).forEach((t) => {
          t.setAttribute("aria-current", "true"),
            eL(t).forEach((e) => e.removeAttribute("aria-current")),
            requestAnimationFrame(() => {
              if (t.offsetParent && t.offsetParent !== this) {
                let i = t.offsetParent.clientHeight / 2,
                  n = t.offsetParent.clientWidth / 2;
                t.offsetParent.scrollTo({
                  behavior: e ? "smooth" : "auto",
                  top: t.offsetTop - i + t.clientHeight / 2,
                  left: t.offsetLeft - n + t.clientWidth / 2,
                });
              }
            });
        });
      }
    };
    window.customElements.define("flickity-controls", eA);
    var eC = class extends d {
      constructor() {
        super(),
          (this.hasLoaded = !1),
          (async () => {
            this.autoPlay
              ? (await this.untilVisible({ rootMargin: "300px", threshold: 0 }),
                this.play())
              : this.addEventListener("click", this.play.bind(this), {
                  once: !0,
                });
          })();
      }
      get autoPlay() {
        return this.hasAttribute("autoplay");
      }
      get provider() {
        return this.getAttribute("provider");
      }
      async play() {
        this.hasLoaded || (await this._setupPlayer()),
          "youtube" === this.provider
            ? this.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({
                  event: "command",
                  func: "playVideo",
                  args: "",
                }),
                "*"
              )
            : "vimeo" === this.provider &&
              this.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({ method: "play" }),
                "*"
              );
      }
      pause() {
        this.hasLoaded &&
          ("youtube" === this.provider
            ? this.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({
                  event: "command",
                  func: "pauseVideo",
                  args: "",
                }),
                "*"
              )
            : "vimeo" === this.provider &&
              this.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({ method: "pause" }),
                "*"
              ));
      }
      _setupPlayer() {
        return this._setupPromise
          ? this._setupPromise
          : (this._setupPromise = new Promise((e) => {
              let t = this.querySelector("template"),
                i = t.content.firstElementChild.cloneNode(!0);
              (i.onload = () => {
                (this.hasLoaded = !0), e();
              }),
                this.autoPlay
                  ? t.replaceWith(i)
                  : ((this.innerHTML = ""), this.appendChild(i));
            }));
      }
    };
    window.customElements.define("external-video", eC);
    var eP = class {
      static load(e) {
        return e
          ? (this.loadedProducts[e] ||
              (this.loadedProducts[e] = new Promise(async (t) => {
                let i = await fetch(
                    `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${e}.js`
                  ),
                  n = await i.json();
                t(n);
              })),
            this.loadedProducts[e])
          : void 0;
      }
    };
    i(eP, "loadedProducts", {});
    var eI = class extends HTMLElement {
      constructor() {
        super(),
          ey.load("modelViewerUiStyles"),
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: this._setupShopifyXr.bind(this),
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: () => {
                this.modelUi = new window.Shopify.ModelViewerUI(
                  this.firstElementChild,
                  { focusOnPlay: !1 }
                );
                let e = this.querySelector("model-viewer");
                e.addEventListener(
                  "shopify_model_viewer_ui_toggle_play",
                  () => {
                    e.dispatchEvent(
                      new CustomEvent("model:played", { bubbles: !0 })
                    );
                  }
                ),
                  e.addEventListener(
                    "shopify_model_viewer_ui_toggle_pause",
                    () => {
                      e.dispatchEvent(
                        new CustomEvent("model:paused", { bubbles: !0 })
                      );
                    }
                  );
              },
            },
          ]);
      }
      disconnectedCallback() {
        var e;
        null == (e = this.modelUi) || e.destroy();
      }
      play() {
        this.modelUi && this.modelUi.play();
      }
      pause() {
        this.modelUi && this.modelUi.pause();
      }
      async _setupShopifyXr() {
        if (window.ShopifyXR) {
          let e = await eP.load(this.getAttribute("product-handle")),
            t = e.media.filter((e) => "model" === e.media_type);
          window.ShopifyXR.addModels(t), window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener(
            "shopify_xr_initialized",
            this._setupShopifyXr.bind(this)
          );
      }
    };
    window.customElements.define("model-media", eI);
    var e0 = class extends HTMLElement {
      constructor() {
        super(),
          (this.hasLoaded = !1),
          this.autoPlay
            ? this.play()
            : this.addEventListener("click", this.play.bind(this), {
                once: !0,
              });
      }
      get autoPlay() {
        return this.hasAttribute("autoplay");
      }
      play() {
        this.hasLoaded || this._replaceContent(),
          this.querySelector("video").play();
      }
      pause() {
        this.hasLoaded && this.querySelector("video").pause();
      }
      _replaceContent() {
        let e = this.querySelector(
          "template"
        ).content.firstElementChild.cloneNode(!0);
        (this.innerHTML = ""),
          this.appendChild(e),
          this.firstElementChild.addEventListener("play", () => {
            this.dispatchEvent(
              new CustomEvent("video:played", { bubbles: !0 })
            );
          }),
          this.firstElementChild.addEventListener("pause", () => {
            this.dispatchEvent(
              new CustomEvent("video:paused", { bubbles: !0 })
            );
          }),
          (this.hasLoaded = !0);
      }
    };
    window.customElements.define("native-video", e0);
    var eq = class extends Y {
      connectedCallback() {
        if (
          (super.connectedCallback(),
          (this.options = Array.from(this.querySelectorAll('[role="option"]'))),
          this.delegate.on(
            "click",
            '[role="option"]',
            this._onValueClicked.bind(this)
          ),
          this.delegate.on(
            "keydown",
            '[role="listbox"]',
            this._onKeyDown.bind(this)
          ),
          this.delegate.on("change", "select", this._onValueChanged.bind(this)),
          this.delegate.on(
            "click",
            ".combo-box__overlay",
            () => (this.open = !1)
          ),
          this.hasAttribute("fit-toggle"))
        ) {
          let e = Math.max(...this.options.map((e) => e.clientWidth)),
            t = document.querySelector(`[aria-controls="${this.id}"]`);
          t && t.style.setProperty("--largest-option-width", `${e + 2}px`);
        }
      }
      get nativeSelect() {
        return this.querySelector("select");
      }
      set selectedValue(e) {
        this.options.forEach((t) => {
          t.setAttribute(
            "aria-selected",
            t.getAttribute("value") === e ? "true" : "false"
          );
        });
      }
      attributeChangedCallback(e, t, i) {
        if ((super.attributeChangedCallback(e, t, i), "open" === e)) {
          if (this.open) {
            let n = this.getBoundingClientRect();
            this.classList.toggle(
              "combo-box--top",
              n.top >= (window.innerHeight / 2) * 1.5
            ),
              setTimeout(() => this.focusTrap.activate(), 150);
          } else
            this.focusTrap.deactivate(),
              setTimeout(() => this.classList.remove("combo-box--top"), 200);
          document.documentElement.classList.toggle("lock-mobile", this.open);
        }
      }
      _onValueClicked(e, t) {
        (this.selectedValue = t.value),
          (this.nativeSelect.value = t.value),
          this.nativeSelect.dispatchEvent(new Event("change", { bubbles: !0 })),
          (this.open = !1);
      }
      _onValueChanged(e, t) {
        Array.from(this.nativeSelect.options).forEach((e) =>
          e.toggleAttribute("selected", t.value === e.value)
        ),
          (this.selectedValue = t.value);
      }
      _onKeyDown(e) {
        var t, i;
        ("ArrowDown" === e.key || "ArrowUp" === e.key) &&
          (e.preventDefault(),
          "ArrowDown" === e.key
            ? null == (t = document.activeElement.nextElementSibling) ||
              t.focus()
            : null == (i = document.activeElement.previousElementSibling) ||
              i.focus());
      }
    };
    window.customElements.define("combo-box", eq);
    var eV = class extends d {
      connectedCallback() {
        (this.inputElement = this.querySelector("input")),
          this.delegate.on(
            "click",
            "button:first-child",
            () => (this.inputElement.quantity = this.inputElement.quantity - 1)
          ),
          this.delegate.on(
            "click",
            "button:last-child",
            () => (this.inputElement.quantity = this.inputElement.quantity + 1)
          );
      }
    };
    window.customElements.define("quantity-selector", eV);
    var eM = class extends HTMLInputElement {
      connectedCallback() {
        this.addEventListener("input", this._onValueInput.bind(this)),
          this.addEventListener("change", this._onValueChanged.bind(this)),
          this.addEventListener("keydown", this._onKeyDown.bind(this));
      }
      get quantity() {
        return parseInt(this.value);
      }
      set quantity(e) {
        let t =
          ("number" == typeof e || ("string" == typeof e && "" !== e.trim())) &&
          !isNaN(e);
        "" !== e &&
          ((!t || e < 0) && (e = parseInt(e) || 1),
          (this.value = Math.max(
            this.min || 1,
            Math.min(e, this.max || Number.MAX_VALUE)
          ).toString()),
          (this.size = Math.max(this.value.length + 1, 2)));
      }
      _onValueInput() {
        this.quantity = this.value;
      }
      _onValueChanged() {
        "" === this.value && (this.quantity = 1);
      }
      _onKeyDown(e) {
        e.stopPropagation(),
          "ArrowUp" === e.key
            ? (this.quantity = this.quantity + 1)
            : "ArrowDown" === e.key && (this.quantity = this.quantity - 1);
      }
    };
    window.customElements.define("input-number", eM, { extends: "input" });
    var eD = class extends d {
      async connectedCallback() {
        await customElements.whenDefined("announcement-bar-item"),
          (this.items = Array.from(
            this.querySelectorAll("announcement-bar-item")
          )),
          (this.hasPendingTransition = !1),
          this.delegate.on(
            "click",
            '[data-action="prev"]',
            this.previous.bind(this)
          ),
          this.delegate.on(
            "click",
            '[data-action="next"]',
            this.next.bind(this)
          ),
          this.autoPlay &&
            (this.delegate.on(
              "announcement-bar:content:open",
              this._pausePlayer.bind(this)
            ),
            this.delegate.on(
              "announcement-bar:content:close",
              this._startPlayer.bind(this)
            )),
          window.ResizeObserver &&
            ((this.resizeObserver = new ResizeObserver(
              this._updateCustomProperties.bind(this)
            )),
            this.resizeObserver.observe(this)),
          this.autoPlay && this._startPlayer(),
          Shopify.designMode &&
            this.delegate.on("shopify:block:select", (e) =>
              this.select(e.target.index, !1)
            );
      }
      get autoPlay() {
        return this.hasAttribute("auto-play");
      }
      get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
      }
      previous() {
        this.select(
          (this.selectedIndex - 1 + this.items.length) % this.items.length
        );
      }
      next() {
        this.select(
          (this.selectedIndex + 1 + this.items.length) % this.items.length
        );
      }
      async select(e, t = !0) {
        this.selectedIndex !== e &&
          !this.hasPendingTransition &&
          (this.autoPlay && this._pausePlayer(),
          (this.hasPendingTransition = !0),
          await this.items[this.selectedIndex].deselect(t),
          await this.items[e].select(t),
          (this.hasPendingTransition = !1),
          this.autoPlay && this._startPlayer());
      }
      _pausePlayer() {
        clearInterval(this._interval);
      }
      _startPlayer() {
        this._interval = setInterval(
          this.next.bind(this),
          1e3 * parseInt(this.getAttribute("cycle-speed"))
        );
      }
      _updateCustomProperties(e) {
        e.forEach((e) => {
          if (e.target === this) {
            let t = e.borderBoxSize
              ? e.borderBoxSize.length > 0
                ? e.borderBoxSize[0].blockSize
                : e.borderBoxSize.blockSize
              : e.target.clientHeight;
            document.documentElement.style.setProperty(
              "--announcement-bar-height",
              `${t}px`
            );
          }
        });
      }
    };
    window.customElements.define("announcement-bar", eD);
    var e1 = class extends d {
      connectedCallback() {
        this.hasContent &&
          ((this.contentElement = this.querySelector(
            ".announcement-bar__content"
          )),
          this.delegate.on(
            "click",
            '[data-action="open-content"]',
            this.openContent.bind(this)
          ),
          this.delegate.on(
            "click",
            '[data-action="close-content"]',
            this.closeContent.bind(this)
          ),
          Shopify.designMode &&
            (this.addEventListener(
              "shopify:block:select",
              this.openContent.bind(this)
            ),
            this.addEventListener(
              "shopify:block:deselect",
              this.closeContent.bind(this)
            )));
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get hasContent() {
        return this.hasAttribute("has-content");
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      get focusTrap() {
        return (this._trapFocus =
          this._trapFocus ||
          W(
            this.contentElement.querySelector(
              ".announcement-bar__content-inner"
            ),
            {
              fallbackFocus: this,
              clickOutsideDeactivates: (e) => "BUTTON" !== e.target.tagName,
              allowOutsideClick: (e) => "BUTTON" === e.target.tagName,
              onDeactivate: this.closeContent.bind(this),
              preventScroll: !0,
            }
          ));
      }
      async select(e = !0) {
        this.removeAttribute("hidden"),
          await new Promise((t) => {
            this.animate(
              {
                transform: ["translateY(8px)", "translateY(0)"],
                opacity: [0, 1],
              },
              { duration: e ? 150 : 0, easing: "ease-in-out" }
            ).onfinish = t;
          });
      }
      async deselect(e = !0) {
        await this.closeContent(),
          await new Promise((t) => {
            this.animate(
              {
                transform: ["translateY(0)", "translateY(-8px)"],
                opacity: [1, 0],
              },
              { duration: e ? 150 : 0, easing: "ease-in-out" }
            ).onfinish = t;
          }),
          this.setAttribute("hidden", "");
      }
      async openContent() {
        this.hasContent &&
          (this.contentElement.addEventListener(
            "transitionend",
            () => this.focusTrap.activate(),
            { once: !0 }
          ),
          this.contentElement.removeAttribute("hidden"),
          document.documentElement.classList.add("lock-all"),
          this.dispatchEvent(
            new CustomEvent("announcement-bar:content:open", { bubbles: !0 })
          ));
      }
      async closeContent() {
        if (!this.hasContent || this.contentElement.hasAttribute("hidden"))
          return Promise.resolve();
        await new Promise((e) => {
          this.contentElement.addEventListener("transitionend", () => e(), {
            once: !0,
          }),
            this.contentElement.setAttribute("hidden", ""),
            this.focusTrap.deactivate(),
            document.documentElement.classList.remove("lock-all"),
            this.dispatchEvent(
              new CustomEvent("announcement-bar:content:close", { bubbles: !0 })
            );
        });
      }
    };
    window.customElements.define("announcement-bar-item", e1);
    var eO = class extends HTMLElement {
      connectedCallback() {
        (this.facetToolbar = document.getElementById("mobile-facet-toolbar")),
          (this.tabsNav = document.getElementById("search-tabs-nav")),
          this.tabsNav.addEventListener(
            "tabs-nav:changed",
            this._onCategoryChanged.bind(this)
          ),
          this._completeSearch();
      }
      get terms() {
        return this.getAttribute("terms");
      }
      get completeFor() {
        return JSON.parse(this.getAttribute("complete-for")).filter(
          (e) => "" !== e
        );
      }
      async _completeSearch() {
        let e = [];
        this.completeFor.forEach((t) => {
          e.push(
            fetch(
              `${
                window.themeVariables.routes.searchUrl
              }?section_id=${this.getAttribute("section-id")}&q=${
                this.terms
              }&type=${t}&options[prefix]=last&options[unavailable_products]=${
                window.themeVariables.settings.searchUnavailableProducts
              }`
            )
          );
        });
        let t = await Promise.all(e);
        await Promise.all(
          t.map(async (e) => {
            let t = document.createElement("div");
            t.innerHTML = await e.text();
            let i = t.querySelector(".main-search__category-result"),
              n = t.querySelector("#search-tabs-nav .tabs-nav__item");
            i &&
              (i.setAttribute("hidden", ""),
              this.insertAdjacentElement("beforeend", i),
              this.tabsNav.addButton(n));
          })
        );
      }
      _onCategoryChanged(e) {
        let t = e.detail.button;
        this.facetToolbar.classList.toggle(
          "is-collapsed",
          "product" !== t.getAttribute("data-type")
        );
      }
    };
    window.customElements.define("search-page", eO);
    var eB = class extends d {
      connectedCallback() {
        window.Shopify &&
          window.Shopify.designMode &&
          (this.rootDelegate.on("shopify:section:select", (e) =>
            U(e, this, () => (this.open = !0))
          ),
          this.rootDelegate.on("shopify:section:deselect", (e) =>
            U(e, this, () => (this.open = !1))
          )),
          this.delegate.on(
            "click",
            '[data-action~="accept-policy"]',
            this._acceptPolicy.bind(this)
          ),
          this.delegate.on(
            "click",
            '[data-action~="decline-policy"]',
            this._declinePolicy.bind(this)
          ),
          window.Shopify.loadFeatures([
            {
              name: "consent-tracking-api",
              version: "0.1",
              onLoad: this._onCookieBarSetup.bind(this),
            },
          ]);
      }
      set open(e) {
        this.toggleAttribute("hidden", !e);
      }
      _onCookieBarSetup() {
        window.Shopify.customerPrivacy.shouldShowGDPRBanner() &&
          (this.open = !0);
      }
      _acceptPolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(
          !0,
          () => (this.open = !1)
        );
      }
      _declinePolicy() {
        window.Shopify.customerPrivacy.setTrackingConsent(
          !1,
          () => (this.open = !1)
        );
      }
    };
    window.customElements.define("cookie-bar", eB);
    var eR = class extends HTMLElement {
      async connectedCallback() {
        if (!this.hasAttribute("use-automatic-recommendations")) return;
        let e = await fetch(
            `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=${this.recommendationsCount}&section_id=${this.sectionId}`
          ),
          t = document.createElement("div");
        t.innerHTML = await e.text();
        let i = t.querySelector("product-recommendations");
        i.hasChildNodes() && (this.innerHTML = i.innerHTML);
      }
      get productId() {
        return this.getAttribute("product-id");
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
      get recommendationsCount() {
        return parseInt(this.getAttribute("recommendations-count") || 4);
      }
    };
    window.customElements.define("product-recommendations", eR);
    var e3 = class extends HTMLElement {
      async connectedCallback() {
        if ("" === this.searchQueryString) return;
        let e = await fetch(
            `${window.themeVariables.routes.searchUrl}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`
          ),
          t = document.createElement("div");
        t.innerHTML = await e.text();
        let i = t.querySelector("recently-viewed-products");
        i.hasChildNodes() && (this.innerHTML = i.innerHTML);
      }
      get searchQueryString() {
        let e = JSON.parse(
          localStorage.getItem("theme:recently-viewed-products") || "[]"
        );
        return (
          this.hasAttribute("exclude-product-id") &&
            e.includes(parseInt(this.getAttribute("exclude-product-id"))) &&
            e.splice(
              e.indexOf(parseInt(this.getAttribute("exclude-product-id"))),
              1
            ),
          e
            .map((e) => "id:" + e)
            .slice(0, this.productsCount)
            .join(" OR ")
        );
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
      get productsCount() {
        return this.getAttribute("products-count") || 4;
      }
    };
    function eN(e, t) {
      let i =
        "string" == typeof e
          ? e
          : e.preview_image
          ? e.preview_image.src
          : e.url;
      if (null === t) return i;
      if ("master" === t) return i.replace(/http(s)?:/, "");
      let n = i.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i
      );
      if (!n) return null;
      {
        let s = i.split(n[0]),
          r = n[0];
        return (s[0] + "_" + t + r).replace(/http(s)?:/, "");
      }
    }
    function eH(e, t) {
      let i = [];
      return (
        ("string" == typeof e ? t : e9(e, t)).forEach((t) => {
          i.push(`${eN(e, t + "x")} ${t}w`);
        }),
        i.join(",")
      );
    }
    function e9(e, t) {
      let i = [],
        n = e.preview_image.width;
      return (
        t.forEach((e) => {
          n >= e && i.push(e);
        }),
        i
      );
    }
    function eF(e) {
      return new Promise((t) => {
        !e || "IMG" !== e.tagName || e.complete ? t() : (e.onload = () => t());
      });
    }
    window.customElements.define("recently-viewed-products", e3);
    var ez = class {
        constructor(e) {
          (this._effect = e),
            (this._playState = "idle"),
            (this._finished = Promise.resolve());
        }
        get finished() {
          return this._finished;
        }
        get animationEffects() {
          return this._effect instanceof eW
            ? [this._effect]
            : this._effect.animationEffects;
        }
        cancel() {
          this.animationEffects.forEach((e) => e.cancel());
        }
        finish() {
          this.animationEffects.forEach((e) => e.finish());
        }
        play() {
          (this._playState = "running"),
            this._effect.play(),
            (this._finished = this._effect.finished),
            this._finished.then(
              () => {
                this._playState = "finished";
              },
              (e) => {
                this._playState = "idle";
              }
            );
        }
      },
      eW = class {
        constructor(e, t, i = {}) {
          if (!e) return;
          "Animation" in window
            ? (this._animation = new Animation(new KeyframeEffect(e, t, i)))
            : ((i.fill = "forwards"),
              (this._animation = e.animate(t, i)),
              this._animation.pause()),
            this._animation.addEventListener("finish", () => {
              (e.style.opacity = t.hasOwnProperty("opacity")
                ? t.opacity[t.opacity.length - 1]
                : null),
                (e.style.visibility = t.hasOwnProperty("visibility")
                  ? t.visibility[t.visibility.length - 1]
                  : null);
            });
        }
        get finished() {
          return this._animation
            ? this._animation.finished
              ? this._animation.finished
              : new Promise((e) => (this._animation.onfinish = e))
            : Promise.resolve();
        }
        play() {
          this._animation &&
            ((this._animation.startTime = null), this._animation.play());
        }
        cancel() {
          this._animation && this._animation.cancel();
        }
        finish() {
          this._animation && this._animation.finish();
        }
      },
      e2 = class {
        constructor(e) {
          (this._childrenEffects = e), (this._finished = Promise.resolve());
        }
        get finished() {
          return this._finished;
        }
        get animationEffects() {
          return this._childrenEffects.flatMap((e) =>
            e instanceof eW ? e : e.animationEffects
          );
        }
      },
      e4 = class extends e2 {
        play() {
          let e = [];
          for (let t of this._childrenEffects) t.play(), e.push(t.finished);
          this._finished = Promise.all(e);
        }
      },
      eU = class extends e2 {
        play() {
          this._finished = new Promise(async (e, t) => {
            try {
              for (let i of this._childrenEffects) i.play(), await i.finished;
              e();
            } catch (n) {
              t();
            }
          });
        }
      },
      e7 = class extends HTMLElement {
        async connectedCallback() {
          (this._pendingAnimations = []),
            this.addEventListener("split-lines:re-split", (e) => {
              Array.from(e.target.children).forEach(
                (e) =>
                  (e.style.visibility = this.selected ? "visible" : "hidden")
              );
            }),
            ek.prefersReducedMotion() &&
              (this.setAttribute("reveal-visibility", ""),
              Array.from(
                this.querySelectorAll("[reveal], [reveal-visibility]")
              ).forEach((e) => {
                e.removeAttribute("reveal"),
                  e.removeAttribute("reveal-visibility");
              }));
        }
        get index() {
          return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
          return !this.hasAttribute("hidden");
        }
        async transitionToLeave(e, t = !0) {
          "reveal" !== e && this.setAttribute("hidden", ""),
            this._pendingAnimations.forEach((e) => e.cancel()),
            (this._pendingAnimations = []);
          let i = null,
            n = await eT(
              this.querySelectorAll(
                "split-lines, .button-group, .button-wrapper"
              )
            ),
            s = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
          switch (e) {
            case "sweep":
              i = new ez(
                new eU([
                  new eW(
                    this,
                    { visibility: ["visible", "hidden"] },
                    { duration: 500 }
                  ),
                  new e4(
                    n.map(
                      (e) =>
                        new eW(e, {
                          opacity: [1, 0],
                          visibility: ["visible", "hidden"],
                        })
                    )
                  ),
                ])
              );
              break;
            case "fade":
              i = new ez(
                new eW(
                  this,
                  { opacity: [1, 0], visibility: ["visible", "hidden"] },
                  { duration: 250, easing: "ease-in-out" }
                )
              );
              break;
            case "reveal":
              i = new ez(
                new eU([
                  new e4(
                    n.reverse().map(
                      (e) =>
                        new eW(
                          e,
                          {
                            opacity: [1, 0],
                            visibility: ["visible", "hidden"],
                          },
                          { duration: 250, easing: "ease-in-out" }
                        )
                    )
                  ),
                  new e4(
                    s.map((e) =>
                      e.classList.contains(
                        "slideshow__image-wrapper--secondary"
                      )
                        ? new eW(
                            e,
                            {
                              visibility: ["visible", "hidden"],
                              clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"],
                            },
                            {
                              duration: 450,
                              easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)",
                            }
                          )
                        : new eW(
                            e,
                            {
                              visibility: ["visible", "hidden"],
                              clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                            },
                            {
                              duration: 450,
                              easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)",
                            }
                          )
                    )
                  ),
                ])
              );
          }
          await this._executeAnimation(i, t),
            "reveal" === e && this.setAttribute("hidden", "");
        }
        async transitionToEnter(e, t = !0, i = !1) {
          this.removeAttribute("hidden"), await this._untilReady();
          let n = null,
            s = await eT(
              this.querySelectorAll(
                "split-lines, .button-group, .button-wrapper"
              )
            ),
            r = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
          switch (e) {
            case "sweep":
              n = new ez(
                new eU([
                  new eW(
                    this,
                    {
                      visibility: ["hidden", "visible"],
                      clipPath: i
                        ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"]
                        : ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
                    },
                    { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }
                  ),
                  new e4(
                    s.map(
                      (e, t) =>
                        new eW(
                          e,
                          {
                            opacity: [0, 1],
                            visibility: ["hidden", "visible"],
                            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                            transform: ["translateY(100%)", "translateY(0)"],
                          },
                          {
                            duration: 450,
                            delay: 100 * t,
                            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                          }
                        )
                    )
                  ),
                ])
              );
              break;
            case "fade":
              n = new ez(
                new eW(
                  this,
                  { opacity: [0, 1], visibility: ["hidden", "visible"] },
                  { duration: 250, easing: "ease-in-out" }
                )
              );
              break;
            case "reveal":
              n = new ez(
                new eU([
                  new e4(
                    r.map((e) =>
                      e.classList.contains(
                        "slideshow__image-wrapper--secondary"
                      )
                        ? new eW(
                            e,
                            {
                              visibility: ["hidden", "visible"],
                              clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"],
                            },
                            {
                              duration: 450,
                              delay: 100,
                              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                            }
                          )
                        : new eW(
                            e,
                            {
                              visibility: ["hidden", "visible"],
                              clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                            },
                            {
                              duration: 450,
                              delay: 100,
                              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                            }
                          )
                    )
                  ),
                  new e4(
                    s.map(
                      (e, t) =>
                        new eW(
                          e,
                          {
                            opacity: [0, 1],
                            visibility: ["hidden", "visible"],
                            clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                            transform: ["translateY(100%)", "translateY(0)"],
                          },
                          {
                            duration: 450,
                            delay: 100 * t,
                            easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                          }
                        )
                    )
                  ),
                ])
              );
          }
          return this._executeAnimation(n, t);
        }
        async _executeAnimation(e, t) {
          return (
            this._pendingAnimations.push(e),
            t ? e.play() : e.finish(),
            e.finished
          );
        }
        async _untilReady() {
          return Promise.all(this._getVisibleImages().map((e) => eF(e)));
        }
        _preloadImages() {
          this._getVisibleImages().forEach((e) => {
            e.setAttribute("loading", "eager");
          });
        }
        _getVisibleImages() {
          return Array.from(this.querySelectorAll("img")).filter(
            (e) => "none" !== getComputedStyle(e.parentElement).display
          );
        }
      };
    window.customElements.define("slide-show-item", e7);
    var eY = {
        _blockVerticalScroll(e = 18) {
          this.addEventListener("touchstart", (e) => {
            this.firstTouchClientX = e.touches[0].clientX;
          }),
            this.addEventListener(
              "touchmove",
              (t) => {
                let i = t.touches[0].clientX - this.firstTouchClientX;
                Math.abs(i) > e && t.preventDefault();
              },
              { passive: !1 }
            );
        },
      },
      ej = class extends d {
        connectedCallback() {
          (this.items = Array.from(this.querySelectorAll("slide-show-item"))),
            (this.pageDots = this.querySelector("page-dots")),
            (this.isTransitioning = !1),
            this.items.length > 1 &&
              (Shopify.designMode &&
                (this.addEventListener(
                  "shopify:block:deselect",
                  this.startPlayer.bind(this)
                ),
                this.addEventListener("shopify:block:select", (e) => {
                  this.pausePlayer(),
                    this.intersectionObserver.disconnect(),
                    (!e.detail.load && e.target.selected) ||
                      this.select(e.target.index, !e.detail.load);
                })),
              this.addEventListener("swiperight", this.previous.bind(this)),
              this.addEventListener("swipeleft", this.next.bind(this)),
              this.addEventListener("page-dots:changed", (e) =>
                this.select(e.detail.index)
              ),
              this._blockVerticalScroll()),
            this._setupVisibility();
        }
        get selectedIndex() {
          return this.items.findIndex((e) => e.selected);
        }
        get transitionType() {
          return ek.prefersReducedMotion()
            ? "fade"
            : this.getAttribute("transition-type");
        }
        async _setupVisibility() {
          await this.untilVisible(),
            await this.items[this.selectedIndex]
              .transitionToEnter(this.transitionType)
              .catch((e) => {}),
            this.startPlayer();
        }
        previous() {
          this.select(
            (this.selectedIndex - 1 + this.items.length) % this.items.length,
            !0,
            !0
          );
        }
        next() {
          this.select(
            (this.selectedIndex + 1 + this.items.length) % this.items.length,
            !0,
            !1
          );
        }
        async select(e, t = !0, i = !1) {
          if ("reveal" === this.transitionType && this.isTransitioning) return;
          this.isTransitioning = !0;
          let n = this.items[this.selectedIndex],
            s = this.items[e];
          this.items[(s.index + 1) % this.items.length]._preloadImages(),
            n &&
              n !== s &&
              ("reveal" !== this.transitionType
                ? n.transitionToLeave(this.transitionType, t)
                : await n.transitionToLeave(this.transitionType, t)),
            this.pageDots && (this.pageDots.selectedIndex = s.index),
            await s
              .transitionToEnter(this.transitionType, t, i)
              .catch((e) => {}),
            (this.isTransitioning = !1);
        }
        pausePlayer() {
          this.style.setProperty("--section-animation-play-state", "paused");
        }
        startPlayer() {
          this.hasAttribute("auto-play") &&
            this.style.setProperty("--section-animation-play-state", "running");
        }
      };
    Object.assign(ej.prototype, eY),
      window.customElements.define("slide-show", ej);
    var e5 = class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      get hasAttachedImage() {
        return this.hasAttribute("attached-image");
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = this.querySelector(".image-with-text__text-wrapper"),
          i = await eT(
            this.querySelectorAll(".image-with-text__content split-lines")
          ),
          n = new ez(
            new eU([
              new e4(
                i.map(
                  (e, t) =>
                    new eW(
                      e,
                      {
                        opacity: [0, 0.2, 1],
                        transform: ["translateY(100%)", "translateY(0)"],
                        clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                      },
                      {
                        duration: 350,
                        delay: 120 * t,
                        easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                      }
                    )
                )
              ),
              new eW(t, { opacity: [0, 1] }, { duration: 300 }),
            ])
          );
        return e ? n.play() : n.finish(), n.finished;
      }
      async transitionToLeave(e = !0) {
        let t = await eT(
            this.querySelectorAll(
              ".image-with-text__text-wrapper, .image-with-text__content split-lines"
            )
          ),
          i = new ez(
            new e4(
              t.map((e) => new eW(e, { opacity: [1, 0] }, { duration: 200 }))
            )
          );
        e ? i.play() : i.finish(),
          await i.finished,
          this.setAttribute("hidden", "");
      }
    };
    window.customElements.define("image-with-text-item", e5);
    var e6 = class extends d {
      connectedCallback() {
        (this.items = Array.from(
          this.querySelectorAll("image-with-text-item")
        )),
          (this.imageItems = Array.from(
            this.querySelectorAll(".image-with-text__image")
          )),
          (this.pageDots = this.querySelector("page-dots")),
          (this.hasPendingTransition = !1),
          this.items.length > 1 &&
            (this.addEventListener("page-dots:changed", (e) =>
              this.select(e.detail.index)
            ),
            Shopify.designMode &&
              (this.addEventListener(
                "shopify:block:deselect",
                this.startPlayer.bind(this)
              ),
              this.addEventListener("shopify:block:select", (e) => {
                this.intersectionObserver.disconnect(),
                  this.pausePlayer(),
                  this.select(e.target.index, !e.detail.load);
              }))),
          this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible(),
          this.hasAttribute("reveal-on-scroll") &&
            (await this.transitionImage(this.selectedIndex),
            this.select(this.selectedIndex)),
          this.startPlayer();
      }
      get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
      }
      async select(e, t = !0) {
        !this.hasPendingTransition &&
          ((this.hasPendingTransition = !0),
          (this.items[e].hasAttachedImage || !t) &&
            (await this.transitionImage(e, t)),
          this.selectedIndex !== e &&
            (await this.items[this.selectedIndex].transitionToLeave(t)),
          this.pageDots && (this.pageDots.selectedIndex = e),
          await this.items[e].transitionToEnter(t),
          (this.hasPendingTransition = !1));
      }
      async transitionImage(e, t = !0) {
        let i = this.imageItems.find((e) => !e.hasAttribute("hidden")),
          n =
            this.imageItems.find(
              (t) => t.id === this.items[e].getAttribute("attached-image")
            ) || i;
        i.setAttribute("hidden", ""), n.removeAttribute("hidden"), await eF(n);
        let s = new ez(
          new eW(
            n,
            {
              visibility: ["hidden", "visible"],
              clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
            },
            { duration: 600, easing: "cubic-bezier(1, 0, 0, 1)" }
          )
        );
        t ? s.play() : s.finish();
      }
      pausePlayer() {
        this.style.setProperty("--section-animation-play-state", "paused");
      }
      startPlayer() {
        this.style.setProperty("--section-animation-play-state", "running");
      }
    };
    window.customElements.define("image-with-text", e6);
    var eX = class extends d {
      connectedCallback() {
        this.addEventListener("split-lines:re-split", (e) => {
          Array.from(e.target.children).forEach(
            (e) => (e.style.visibility = this.selected ? "visible" : "hidden")
          );
        });
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        let t = await eT(
            this.querySelectorAll("split-lines, .testimonial__author")
          ),
          i = new ez(
            new e4(
              t.reverse().map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      visibility: ["visible", "hidden"],
                      clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                      transform: ["translateY(0)", "translateY(100%)"],
                    },
                    {
                      duration: 350,
                      delay: 60 * t,
                      easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)",
                    }
                  )
              )
            )
          );
        e ? i.play() : i.finish(),
          await i.finished,
          this.setAttribute("hidden", "");
      }
      async transitionToEnter(e = !0) {
        let t = await eT(
            this.querySelectorAll("split-lines, .testimonial__author")
          ),
          i = new ez(
            new e4(
              t.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      visibility: ["hidden", "visible"],
                      clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                      transform: ["translateY(100%)", "translateY(0)"],
                    },
                    {
                      duration: 550,
                      delay: 120 * t,
                      easing: "cubic-bezier(0.23, 1, 0.32, 1)",
                    }
                  )
              )
            )
          );
        return (
          this.removeAttribute("hidden"), e ? i.play() : i.finish(), i.finished
        );
      }
    };
    window.customElements.define("testimonial-item", eX);
    var eG = class extends d {
      connectedCallback() {
        (this.items = Array.from(this.querySelectorAll("testimonial-item"))),
          (this.pageDots = this.querySelector("page-dots")),
          (this.hasPendingTransition = !1),
          this.items.length > 1 &&
            (this.addEventListener("swiperight", this.previous.bind(this)),
            this.addEventListener("swipeleft", this.next.bind(this)),
            this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            this.addEventListener("page-dots:changed", (e) =>
              this.select(e.detail.index)
            ),
            Shopify.designMode &&
              this.addEventListener("shopify:block:select", (e) => {
                var t;
                null == (t = this.intersectionObserver) || t.disconnect(),
                  (e.detail.load || !e.target.selected) &&
                    this.select(e.target.index, !e.detail.load);
              }),
            this._blockVerticalScroll()),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      get selectedIndex() {
        return this.items.findIndex((e) => e.selected);
      }
      async _setupVisibility() {
        await this.untilVisible(),
          this.items[this.selectedIndex].transitionToEnter();
      }
      previous() {
        this.select(
          (this.selectedIndex - 1 + this.items.length) % this.items.length
        );
      }
      next() {
        this.select(
          (this.selectedIndex + 1 + this.items.length) % this.items.length
        );
      }
      async select(e, t = !0) {
        !this.hasPendingTransition &&
          ((this.hasPendingTransition = !0),
          await this.items[this.selectedIndex].transitionToLeave(t),
          this.pageDots && (this.pageDots.selectedIndex = e),
          await this.items[e].transitionToEnter(t),
          (this.hasPendingTransition = !1));
      }
    };
    Object.assign(eG.prototype, eY),
      window.customElements.define("testimonial-list", eG);
    var eK = class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        this.setAttribute("hidden", "");
        let t = new ez(
          new eW(this, { visibility: ["visible", "hidden"] }, { duration: 500 })
        );
        return e ? t.play() : t.finish(), t.finished;
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = Array.from(this.querySelectorAll(".shop-the-look__dot"));
        t.forEach((e) => (e.style.opacity = 0));
        let i = new ez(
          new eU([
            new e4(
              Array.from(this.querySelectorAll(".shop-the-look__image")).map(
                (e) => new eW(e, { opacity: [1, 1] }, { duration: 0 })
              )
            ),
            new eW(
              this,
              {
                visibility: ["hidden", "visible"],
                zIndex: [0, 1],
                clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"],
              },
              { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }
            ),
            new e4(
              t.map(
                (e, t) =>
                  new eW(
                    e,
                    { opacity: [0, 1], transform: ["scale(0)", "scale(1)"] },
                    { duration: 120, delay: 75 * t, easing: "ease-in-out" }
                  )
              )
            ),
          ])
        );
        if (
          (e ? i.play() : i.finish(),
          await i.finished,
          window.matchMedia(window.themeVariables.breakpoints.tabletAndUp)
            .matches)
        ) {
          let n = this.querySelector(
            ".shop-the-look__product-wrapper .shop-the-look__dot"
          );
          null == n || n.setAttribute("aria-expanded", "true");
        }
      }
    };
    window.customElements.define("shop-the-look-item", eK);
    var eZ = class extends d {
      connectedCallback() {
        (this.shopTheLook = this.closest("shop-the-look")),
          (this.inTransition = !1),
          (this.pendingTransition = !1),
          (this.pendingTransitionTo = null),
          this.delegate.on("click", '[data-action="prev"]', () =>
            this.shopTheLook.previous()
          ),
          this.delegate.on("click", '[data-action="next"]', () =>
            this.shopTheLook.next()
          );
      }
      transitionToIndex(e, t, i = !0) {
        let n = Array.from(
            this.querySelectorAll(".shop-the-look__counter-page-transition")
          ),
          s = n[e],
          r = n[t];
        if (this.inTransition) {
          (this.pendingTransition = !0), (this.pendingTransitionTo = t);
          return;
        }
        (this.inTransition = !0),
          (s.animate(
            { transform: ["translateY(0)", "translateY(-100%)"] },
            { duration: i ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" }
          ).onfinish = () => {
            s.setAttribute("hidden", ""),
              (this.inTransition = !1),
              this.pendingTransition &&
                this.pendingTransitionTo !== t &&
                ((this.pendingTransition = !1),
                this.transitionToIndex(t, this.pendingTransitionTo, i),
                (this.pendingTransitionTo = null));
          }),
          r.removeAttribute("hidden"),
          r.animate(
            { transform: ["translateY(100%)", "translateY(0)"] },
            { duration: i ? 1e3 : 0, easing: "cubic-bezier(1, 0, 0, 1)" }
          );
      }
    };
    window.customElements.define("shop-the-look-nav", eZ);
    var eQ = class extends d {
      connectedCallback() {
        (this.lookItems = Array.from(
          this.querySelectorAll("shop-the-look-item")
        )),
          (this.nav = this.querySelector("shop-the-look-nav")),
          (this.hasPendingTransition = !1),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility(),
          this.lookItems.length > 1 &&
            Shopify.designMode &&
            this.addEventListener("shopify:block:select", async (e) => {
              this.intersectionObserver.disconnect(),
                await this.select(e.target.index, !e.detail.load),
                this.nav.animate(
                  {
                    opacity: [0, 1],
                    transform: ["translateY(30px)", "translateY(0)"],
                  },
                  { duration: 0, fill: "forwards", easing: "ease-in-out" }
                );
            });
      }
      get selectedIndex() {
        return this.lookItems.findIndex((e) => e.selected);
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = Array.from(
          this.lookItems[this.selectedIndex].querySelectorAll(
            ".shop-the-look__image"
          )
        );
        for (let t of e) null !== t.offsetParent && (await eF(t));
        await this.lookItems[this.selectedIndex].transitionToEnter(),
          this.nav &&
            this.nav.animate(
              {
                opacity: [0, 1],
                transform: ["translateY(30px)", "translateY(0)"],
              },
              { duration: 150, fill: "forwards", easing: "ease-in-out" }
            );
      }
      previous() {
        this.select(
          (this.selectedIndex - 1 + this.lookItems.length) %
            this.lookItems.length
        );
      }
      next() {
        this.select(
          (this.selectedIndex + 1 + this.lookItems.length) %
            this.lookItems.length
        );
      }
      async select(e, t = !0) {
        let i = this.lookItems[this.selectedIndex],
          n = this.lookItems[e];
        !this.hasPendingTransition &&
          ((this.hasPendingTransition = !0),
          i !== n &&
            (this.nav.transitionToIndex(this.selectedIndex, e, t),
            i.transitionToLeave()),
          n.transitionToEnter(t),
          (this.hasPendingTransition = !1));
      }
    };
    window.customElements.define("shop-the-look", eQ);
    var eJ = class extends d {
      async connectedCallback() {
        (this.items = Array.from(
          this.querySelectorAll(".list-collections__item")
        )),
          this.hasAttribute("scrollable") &&
            ((this.scroller = this.querySelector(
              ".list-collections__scroller"
            )),
            this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            this.addEventListener("shopify:block:select", (e) =>
              e.target.scrollIntoView({
                block: "nearest",
                inline: "center",
                behavior: e.detail.load ? "auto" : "smooth",
              })
            )),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = ek.prefersReducedMotion(),
          t = new ez(
            new e4(
              this.items.map(
                (t, i) =>
                  new eU([
                    new eW(
                      t.querySelector(".list-collections__item-image"),
                      {
                        opacity: [0, 1],
                        transform: [`scale(${e ? 1 : 1.1})`, "scale(1)"],
                      },
                      {
                        duration: 250,
                        delay: e ? 0 : 150 * i,
                        easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                      }
                    ),
                    new e4(
                      Array.from(
                        t.querySelectorAll(
                          ".list-collections__item-info [reveal]"
                        )
                      ).map(
                        (t, n) =>
                          new eW(
                            t,
                            {
                              opacity: [0, 1],
                              clipPath: [
                                `inset(${e ? "0 0 0 0" : "0 0 100% 0"})`,
                                "inset(0 0 0 0)",
                              ],
                              transform: [
                                `translateY(${e ? 0 : "100%"})`,
                                "translateY(0)",
                              ],
                            },
                            {
                              duration: 200,
                              delay: e ? 0 : 150 * i + 150 * n,
                              easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                            }
                          )
                      )
                    ),
                  ])
              )
            )
          );
        this._hasSectionReloaded ? t.finish() : t.play();
      }
      previous() {
        let e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({
          left: -this.items[0].clientWidth * e,
          behavior: "smooth",
        });
      }
      next() {
        let e = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        this.scroller.scrollBy({
          left: this.items[0].clientWidth * e,
          behavior: "smooth",
        });
      }
    };
    window.customElements.define("collection-list", eJ);
    var te = class extends d {
      constructor() {
        super(),
          (this.productListInner = this.querySelector(".product-list__inner")),
          (this.productItems = Array.from(
            this.querySelectorAll("product-item")
          ));
      }
      connectedCallback() {
        this.addEventListener("prev-next:prev", this.previous.bind(this)),
          this.addEventListener("prev-next:next", this.next.bind(this)),
          !this.hidden &&
            this.staggerApparition &&
            this._staggerProductsApparition();
      }
      get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
      }
      get apparitionAnimation() {
        return (this._animation =
          this._animation ||
          new ez(
            new e4(
              this.productItems.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 1],
                      transform: [
                        `translateY(${
                          ek.prefersReducedMotion()
                            ? 0
                            : window.innerWidth < 1e3
                            ? 35
                            : 60
                        }px)`,
                        "translateY(0)",
                      ],
                    },
                    {
                      duration: 600,
                      delay: ek.prefersReducedMotion()
                        ? 0
                        : 100 * t - Math.min(3 * t * t, 100 * t),
                      easing: "ease",
                    }
                  )
              )
            )
          ));
      }
      previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(
            getComputedStyle(this).getPropertyValue("--product-list-column-gap")
          );
        e.target.nextElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.productListInner.scrollLeft * t -
              (this.productListInner.clientWidth + i) <=
              0
          ),
          this.productListInner.scrollBy({
            left: -(this.productListInner.clientWidth + i) * t,
            behavior: "smooth",
          });
      }
      next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(
            getComputedStyle(this).getPropertyValue("--product-list-column-gap")
          );
        e.target.previousElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.productListInner.scrollLeft * t +
              (this.productListInner.clientWidth + i) * 2 >=
              this.productListInner.scrollWidth
          ),
          this.productListInner.scrollBy({
            left: (this.productListInner.clientWidth + i) * t,
            behavior: "smooth",
          });
      }
      attributeChangedCallback(e) {
        var t, i;
        this.staggerApparition &&
          "hidden" === e &&
          (this.hidden
            ? this.apparitionAnimation.finish()
            : ((this.productListInner.scrollLeft = 0),
              (this.productListInner.parentElement.scrollLeft = 0),
              null == (t = this.querySelector(".prev-next-button--prev")) ||
                t.setAttribute("disabled", ""),
              null == (i = this.querySelector(".prev-next-button--next")) ||
                i.removeAttribute("disabled"),
              this._staggerProductsApparition()));
      }
      async _staggerProductsApparition() {
        this.productItems.forEach((e) => (e.style.opacity = 0)),
          await this.untilVisible({
            threshold:
              this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
          }),
          this.apparitionAnimation.play();
      }
    };
    i(te, "observedAttributes", ["hidden"]),
      window.customElements.define("product-list", te);
    var tt = class extends d {
      async connectedCallback() {
        (this.items = Array.from(this.querySelectorAll(".logo-list__item"))),
          (this.logoListScrollable = this.querySelector(".logo-list__list")),
          this.items.length > 1 &&
            (this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this))),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible({ rootMargin: "50px 0px", threshold: 0 });
        let e = new ez(
          new e4(
            this.items.map(
              (e, t) =>
                new eW(
                  e,
                  {
                    opacity: [0, 1],
                    transform: [
                      `translateY(${ek.prefersReducedMotion() ? 0 : "30px"})`,
                      "translateY(0)",
                    ],
                  },
                  {
                    duration: 300,
                    delay: ek.prefersReducedMotion() ? 0 : 100 * t,
                    easing: "ease",
                  }
                )
            )
          )
        );
        this._hasSectionReloaded ? e.finish() : e.play();
      }
      previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.nextElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.logoListScrollable.scrollLeft * t -
              (this.logoListScrollable.clientWidth + 24) <=
              0
          ),
          this.logoListScrollable.scrollBy({
            left: -(this.logoListScrollable.clientWidth + 24) * t,
            behavior: "smooth",
          });
      }
      next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1;
        e.target.previousElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.logoListScrollable.scrollLeft * t +
              (this.logoListScrollable.clientWidth + 24) * 2 >=
              this.logoListScrollable.scrollWidth
          ),
          this.logoListScrollable.scrollBy({
            left: (this.logoListScrollable.clientWidth + 24) * t,
            behavior: "smooth",
          });
      }
    };
    window.customElements.define("logo-list", tt);
    var ti = class extends HTMLElement {
      connectedCallback() {
        window.addEventListener(
          "scroll",
          ea(this._updateProgressBar.bind(this), 15)
        );
      }
      get hasNextArticle() {
        return this.hasAttribute("has-next-article");
      }
      _updateProgressBar() {
        let e = es(),
          t = window.matchMedia(window.themeVariables.breakpoints.pocket)
            .matches
            ? 40
            : 80,
          i = this.getBoundingClientRect(),
          n = this.parentElement.getBoundingClientRect(),
          s = n.bottom - (i.bottom - t),
          r = Math.max(-1 * (s / (n.height + t) - 1), 0);
        this.classList.toggle(
          "is-visible",
          n.top < e && n.bottom > e + this.clientHeight - t
        ),
          this.hasNextArticle &&
            (r > 0.8
              ? this.classList.add("article__nav--show-next")
              : this.classList.remove("article__nav--show-next")),
          this.style.setProperty("--transform", `${r}`);
      }
    };
    window.customElements.define("blog-post-navigation", ti);
    var tn = class extends d {
      connectedCallback() {
        !this.hasAttribute("stack") &&
          ((this.multiColumnInner = this.querySelector(".multi-column__inner")),
          this.addEventListener("prev-next:prev", this.previous.bind(this)),
          this.addEventListener("prev-next:next", this.next.bind(this)),
          Shopify.designMode &&
            this.addEventListener("shopify:block:select", (e) => {
              e.target.scrollIntoView({
                inline: "center",
                block: "nearest",
                behavior: e.detail.load ? "auto" : "smooth",
              });
            })),
          this.hasAttribute("stagger-apparition") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible({
          threshold: Math.min(50 / this.clientHeight, 1),
        });
        let e = ek.prefersReducedMotion(),
          t = new ez(
            new e4(
              Array.from(this.querySelectorAll(".multi-column__item")).map(
                (t, i) =>
                  new eW(
                    t,
                    {
                      opacity: [0, 1],
                      transform: [
                        `translateY(${
                          ek.prefersReducedMotion()
                            ? 0
                            : window.innerWidth < 1e3
                            ? 35
                            : 60
                        }px)`,
                        "translateY(0)",
                      ],
                    },
                    { duration: 600, delay: e ? 0 : 100 * i, easing: "ease" }
                  )
              )
            )
          );
        this._hasSectionReloaded ? t.finish() : t.play();
      }
      previous(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(
            getComputedStyle(this).getPropertyValue("--multi-column-column-gap")
          );
        e.target.nextElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.multiColumnInner.scrollLeft * t -
              (this.multiColumnInner.clientWidth + i) <=
              0
          ),
          this.multiColumnInner.scrollBy({
            left: -(this.multiColumnInner.clientWidth + i) * t,
            behavior: "smooth",
          });
      }
      next(e) {
        let t = "ltr" === window.themeVariables.settings.direction ? 1 : -1,
          i = parseInt(
            getComputedStyle(this).getPropertyValue("--multi-column-column-gap")
          );
        e.target.previousElementSibling.removeAttribute("disabled"),
          e.target.toggleAttribute(
            "disabled",
            this.multiColumnInner.scrollLeft * t +
              (this.multiColumnInner.clientWidth + i) * 2 >=
              this.multiColumnInner.scrollWidth
          ),
          this.multiColumnInner.scrollBy({
            left: (this.multiColumnInner.clientWidth + i) * t,
            behavior: "smooth",
          });
      }
    };
    window.customElements.define("multi-column", tn);
    var ts = class extends HTMLElement {
      connectedCallback() {
        (this.listItems = Array.from(this.querySelectorAll("gallery-item"))),
          (this.scrollBarElement = this.querySelector(
            ".gallery__progress-bar"
          )),
          (this.listWrapperElement = this.querySelector(
            ".gallery__list-wrapper"
          )),
          this.listItems.length > 1 &&
            (this.addEventListener(
              "scrollable-content:progress",
              this._updateProgressBar.bind(this)
            ),
            this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            Shopify.designMode &&
              this.addEventListener("shopify:block:select", (e) =>
                this.select(e.target.index, !e.detail.load)
              ));
      }
      previous() {
        this.select(
          [...this.listItems].reverse().find((e) => e.isOnLeftHalfPartOfScreen)
            .index
        );
      }
      next() {
        this.select(
          this.listItems.findIndex((e) => e.isOnRightHalfPartOfScreen)
        );
      }
      select(e, t = !0) {
        let i = this.listItems[e].getBoundingClientRect();
        this.listWrapperElement.scrollBy({
          behavior: t ? "smooth" : "auto",
          left: Math.floor(i.left - window.innerWidth / 2 + i.width / 2),
        });
      }
      _updateProgressBar(e) {
        var t;
        null == (t = this.scrollBarElement) ||
          t.style.setProperty("--transform", `${e.detail.progress}%`);
      }
    };
    window.customElements.define("gallery-list", ts);
    var tr = class extends HTMLElement {
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get isOnRightHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction
          ? this.getBoundingClientRect().left > window.innerWidth / 2
          : this.getBoundingClientRect().right < window.innerWidth / 2;
      }
      get isOnLeftHalfPartOfScreen() {
        return "ltr" === window.themeVariables.settings.direction
          ? this.getBoundingClientRect().right < window.innerWidth / 2
          : this.getBoundingClientRect().left > window.innerWidth / 2;
      }
    };
    window.customElements.define("gallery-item", tr);
    var ta = class extends d {
      connectedCallback() {
        this.hasAttribute("parallax") &&
          !ek.prefersReducedMotion() &&
          ((this._hasPendingRaF = !1),
          (this._onScrollListener = this._onScroll.bind(this)),
          window.addEventListener("scroll", this._onScrollListener)),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      disconnectedCallback() {
        super.disconnectedCallback(),
          this._onScrollListener &&
            window.removeEventListener("scroll", this._onScrollListener);
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = this.querySelector(".image-overlay__image"),
          t = await eT(this.querySelectorAll("split-lines")),
          i = ek.prefersReducedMotion();
        await eF(e);
        let n = [
            new eW(
              e,
              {
                opacity: [0, 1],
                transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
              },
              { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
            ),
            new e4(
              t.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 0.2, 1],
                      transform: [
                        `translateY(${i ? 0 : "100%"})`,
                        "translateY(0)",
                      ],
                      clipPath: [
                        `inset(${i ? "0 0 0 0" : "0 0 100% 0"})`,
                        "inset(0 0 0 0)",
                      ],
                    },
                    {
                      duration: 300,
                      delay: i ? 0 : 120 * t,
                      easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                    }
                  )
              )
            ),
            new eW(
              this.querySelector(".image-overlay__text-container"),
              { opacity: [0, 1] },
              { duration: 300 }
            ),
          ],
          s = new ez(i ? new e4(n) : new eU(n));
        this._hasSectionReloaded ? s.finish() : s.play();
      }
      _onScroll() {
        !this._hasPendingRaF &&
          ((this._hasPendingRaF = !0),
          requestAnimationFrame(() => {
            let e = this.getBoundingClientRect(),
              t = this.querySelector(".image-overlay__content-wrapper"),
              i = this.querySelector(".image-overlay__image"),
              n = e.bottom,
              s = e.height,
              r = es();
            t &&
              (t.style.opacity = Math.max(
                1 - 3 * (1 - Math.min(n / s, 1)),
                0
              ).toString()),
              i &&
                (i.style.transform = `translateY(${
                  100 - 100 * Math.max(1 - (1 - Math.min(n / (s + r), 1)), 0)
                }px)`),
              (this._hasPendingRaF = !1);
          }));
      }
    };
    window.customElements.define("image-with-text-overlay", ta);
    var to = class extends d {
      async connectedCallback() {
        this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = Array.from(
            this.querySelectorAll(".image-with-text-block__image[reveal]")
          ),
          t = await eT(this.querySelectorAll("split-lines")),
          i = ek.prefersReducedMotion();
        for (let n of e) null !== n.offsetParent && (await eF(n));
        let s = [
            new e4(
              e.map(
                (e) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 1],
                      transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
                    },
                    { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
                  )
              )
            ),
            new eW(
              this.querySelector(".image-with-text-block__content"),
              {
                opacity: [0, 1],
                transform: [`translateY(${i ? 0 : "60px"})`, "translateY(0)"],
              },
              { duration: 150, easing: "ease-in-out" }
            ),
            new e4(
              t.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 0.2, 1],
                      transform: [
                        `translateY(${i ? 0 : "100%"})`,
                        "translateY(0)",
                      ],
                      clipPath: [
                        `inset(${i ? "0 0 0 0" : "0 0 100% 0"})`,
                        "inset(0 0 0 0)",
                      ],
                    },
                    {
                      duration: 300,
                      delay: i ? 0 : 120 * t,
                      easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)",
                    }
                  )
              )
            ),
            new eW(
              this.querySelector(".image-with-text-block__text-container"),
              { opacity: [0, 1] },
              { duration: 300 }
            ),
          ],
          r = new ez(i ? new e4(s) : new eU(s));
        this._hasSectionReloaded ? r.finish() : r.play();
      }
    };
    window.customElements.define("image-with-text-block", to);
    var tl = class extends d {
      async connectedCallback() {
        if (
          ((this.articleItems = Array.from(
            this.querySelectorAll(".article-item")
          )),
          this.staggerApparition)
        ) {
          await this.untilVisible({
            threshold:
              this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
          });
          let e = new ez(
            new e4(
              this.articleItems.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 1],
                      transform: [
                        `translateY(${
                          ek.prefersReducedMotion()
                            ? 0
                            : window.innerWidth < 1e3
                            ? 35
                            : 60
                        }px)`,
                        "translateY(0)",
                      ],
                    },
                    {
                      duration: 600,
                      delay: ek.prefersReducedMotion()
                        ? 0
                        : 100 * t - Math.min(3 * t * t, 100 * t),
                      easing: "ease",
                    }
                  )
              )
            )
          );
          this._hasSectionReloaded ? e.finish() : e.play();
        }
      }
      get staggerApparition() {
        return this.hasAttribute("stagger-apparition");
      }
    };
    window.customElements.define("article-list", tl);
    var tc = class extends HTMLElement {
      async connectedCallback() {
        let e = this.querySelector(".article__image");
        ek.prefersReducedMotion()
          ? e.removeAttribute("reveal")
          : (await eF(e),
            e.animate(
              { opacity: [0, 1], transform: ["scale(1.1)", "scale(1)"] },
              {
                duration: 500,
                fill: "forwards",
                easing: "cubic-bezier(0.65, 0, 0.35, 1)",
              }
            ));
      }
    };
    window.customElements.define("blog-post-header", tc);
    var th = class extends HTMLInputElement {
      connectedCallback() {
        this.addEventListener(
          "click",
          () =>
            (document.getElementById(this.getAttribute("aria-controls")).open =
              !0)
        );
      }
    };
    window.customElements.define("predictive-search-input", th, {
      extends: "input",
    });
    var td = class extends Y {
      connectedCallback() {
        if (
          (super.connectedCallback(), this.hasAttribute("reverse-breakpoint"))
        ) {
          this.originalDirection = this.classList.contains("drawer--from-left")
            ? "left"
            : "right";
          let e = window.matchMedia(this.getAttribute("reverse-breakpoint"));
          e.addListener(this._checkReverseOpeningDirection.bind(this)),
            this._checkReverseOpeningDirection(e);
        }
        this.delegate.on("click", ".drawer__overlay", () => (this.open = !1));
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
          "open" === e &&
            document.documentElement.classList.toggle("lock-all", this.open);
      }
      _checkReverseOpeningDirection(e) {
        this.classList.remove("drawer--from-left"),
          (("left" === this.originalDirection && !e.matches) ||
            ("left" !== this.originalDirection && e.matches)) &&
            this.classList.add("drawer--from-left");
      }
    };
    window.customElements.define("drawer-content", td);
    var tu = class extends td {
      connectedCallback() {
        super.connectedCallback(),
          (this.inputElement = this.querySelector('[name="q"]')),
          (this.drawerContentElement = this.querySelector(".drawer__content")),
          (this.drawerFooterElement = this.querySelector(".drawer__footer")),
          (this.loadingStateElement = this.querySelector(
            ".predictive-search__loading-state"
          )),
          (this.resultsElement = this.querySelector(
            ".predictive-search__results"
          )),
          (this.menuListElement = this.querySelector(
            ".predictive-search__menu-list"
          )),
          this.delegate.on(
            "input",
            '[name="q"]',
            this._debounce(this._onSearch.bind(this), 200)
          ),
          this.delegate.on(
            "click",
            '[data-action="reset-search"]',
            this._startNewSearch.bind(this)
          );
      }
      async _onSearch(e, t) {
        if ("Enter" !== e.key) {
          if (
            (this.abortController && this.abortController.abort(),
            this.drawerContentElement.classList.remove(
              "drawer__content--center"
            ),
            (this.drawerFooterElement.hidden = !0),
            "" === t.value)
          )
            (this.loadingStateElement.hidden = !0),
              (this.resultsElement.hidden = !0),
              this.menuListElement && (this.menuListElement.hidden = !1);
          else {
            this.drawerContentElement.classList.add("drawer__content--center"),
              (this.loadingStateElement.hidden = !1),
              (this.resultsElement.hidden = !0),
              this.menuListElement && (this.menuListElement.hidden = !0);
            let i = {};
            try {
              (this.abortController = new AbortController()),
                (i = this._supportPredictiveApi()
                  ? await this._doPredictiveSearch(t.value)
                  : await this._doLiquidSearch(t.value));
            } catch (n) {
              if ("AbortError" === n.name) return;
            }
            (this.loadingStateElement.hidden = !0),
              (this.resultsElement.hidden = !1),
              this.menuListElement && (this.menuListElement.hidden = !0),
              i.hasResults &&
                ((this.drawerFooterElement.hidden = !1),
                this.drawerContentElement.classList.remove(
                  "drawer__content--center"
                )),
              (this.resultsElement.innerHTML = i.html);
          }
        }
      }
      async _doPredictiveSearch(e) {
        let t = await fetch(
            `${
              window.themeVariables.routes.predictiveSearchUrl
            }?q=${encodeURIComponent(e)}&resources[limit]=10&resources[type]=${
              window.themeVariables.settings.searchMode
            }&resources[options[unavailable_products]]=${
              window.themeVariables.settings.searchUnavailableProducts
            }&resources[options[fields]]=title,body,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`,
            { signal: this.abortController.signal }
          ),
          i = document.createElement("div");
        return (
          (i.innerHTML = await t.text()),
          {
            hasResults:
              null !==
              i.querySelector(".predictive-search__results-categories"),
            html: i.firstElementChild.innerHTML,
          }
        );
      }
      async _doLiquidSearch(e) {
        let t = [],
          i = window.themeVariables.settings.searchMode
            .split(",")
            .filter((e) => "collection" !== e);
        i.forEach((i) => {
          t.push(
            fetch(
              `${window.themeVariables.routes.searchUrl}?section_id=predictive-search-compatibility&q=${e}&type=${i}&options[unavailable_products]=${window.themeVariables.settings.searchUnavailableProducts}&options[prefix]=last`,
              { signal: this.abortController.signal }
            )
          );
        });
        let n = await Promise.all(t),
          s = {};
        for (let [r, a] of n.entries()) {
          let o = await a.text(),
            l = document.createElement("div");
          (l.innerHTML = o),
            (l.innerHTML = l.firstElementChild.innerHTML),
            l.childElementCount > 0 && (s[i[r]] = l.innerHTML);
        }
        if (!(Object.keys(s).length > 0))
          return {
            hasResults: !1,
            html: `
        <p class="text--large">${window.themeVariables.strings.searchNoResults}</p>
          <div class="button-wrapper">
            <button type="button" data-action="reset-search" class="button button--primary">${window.themeVariables.strings.searchNewSearch}</button>
          </div>
        `,
          };
        {
          let c = Object.entries(s),
            h = Object.keys(s),
            d = `
        <tabs-nav class="tabs-nav tabs-nav--edge2edge tabs-nav--narrow tabs-nav--no-border">
          <scrollable-content class="tabs-nav__scroller hide-scrollbar">
            <div class="tabs-nav__scroller-inner">
              <div class="tabs-nav__item-list">
      `;
          for (let [u, p] of c)
            d += `
          <button type="button" class="tabs-nav__item heading heading--small" aria-expanded="${
            u === h[0] ? "true" : "false"
          }" aria-controls="predictive-search-${u}">
            ${
              window.themeVariables.strings[
                "search" + u.charAt(0).toUpperCase() + u.slice(1) + "s"
              ]
            }
          </button>
        `;
          for (let [m, f] of ((d += `
              </div>
            </div>
          </scrollable-content>
        </tabs-nav>
      `),
          (d += '<div class="predictive-search__results-categories">'),
          c))
            d += `
          <div class="predictive-search__results-categories-item" ${
            m !== h[0] ? "hidden" : ""
          } id="predictive-search-${m}">
            ${f}
          </div>
        `;
          return (d += "</div>"), { hasResults: !0, html: d };
        }
      }
      _startNewSearch() {
        (this.inputElement.value = ""), this.inputElement.focus();
        let e = new Event("input", { bubbles: !0, cancelable: !0 });
        this.inputElement.dispatchEvent(e);
      }
      _supportPredictiveApi() {
        let e = JSON.parse(
          document.getElementById("shopify-features").innerHTML
        );
        return e.predictiveSearch;
      }
      _debounce(e, t) {
        let i = null;
        return (...n) => {
          clearTimeout(i),
            (i = setTimeout(() => {
              e.apply(this, n);
            }, t));
        };
      }
    };
    window.customElements.define("predictive-search-drawer", tu);
    var tp = class extends HTMLElement {
      connectedCallback() {
        if (
          ((this.prevNextButtons = this.querySelector("prev-next-buttons")),
          (this.pageDots = this.querySelector("page-dots")),
          (this.scrollBarElement = this.querySelector(
            ".timeline__progress-bar"
          )),
          (this.listWrapperElement = this.querySelector(
            ".timeline__list-wrapper"
          )),
          (this.listItemElements = Array.from(
            this.querySelectorAll(".timeline__item")
          )),
          (this.isScrolling = !1),
          this.listItemElements.length > 1)
        ) {
          this.addEventListener("prev-next:prev", this.previous.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            this.addEventListener("page-dots:changed", (e) =>
              this.select(e.detail.index)
            ),
            Shopify.designMode &&
              this.addEventListener("shopify:block:select", (e) => {
                this.select(
                  [...e.target.parentNode.children].indexOf(e.target),
                  !e.detail.load
                );
              }),
            (this.itemIntersectionObserver = new IntersectionObserver(
              this._onItemObserved.bind(this),
              { threshold: 0.4 }
            ));
          let e = window.matchMedia(window.themeVariables.breakpoints.pocket);
          e.addListener(this._onMediaChanged.bind(this)),
            this._onMediaChanged(e);
        }
      }
      get selectedIndex() {
        return this.listItemElements.findIndex(
          (e) => !e.hasAttribute("hidden")
        );
      }
      previous() {
        this.select(Math.max(0, this.selectedIndex - 1));
      }
      next() {
        this.select(
          Math.min(this.selectedIndex + 1, this.listItemElements.length - 1)
        );
      }
      select(e, t = !0) {
        let i = this.listItemElements[e],
          n = i.getBoundingClientRect();
        t &&
          ((this.isScrolling = !0),
          setTimeout(() => (this.isScrolling = !1), 800)),
          window.matchMedia(window.themeVariables.breakpoints.pocket).matches
            ? this.listWrapperElement.scrollTo({
                behavior: t ? "smooth" : "auto",
                left: this.listItemElements[0].clientWidth * e,
              })
            : this.listWrapperElement.scrollBy({
                behavior: t ? "smooth" : "auto",
                left: Math.floor(n.left - window.innerWidth / 2 + n.width / 2),
              }),
          this._onItemSelected(e);
      }
      _onItemSelected(e) {
        var t;
        let i = this.listItemElements[e];
        i.removeAttribute("hidden", "false"),
          eL(i).forEach((e) => e.setAttribute("hidden", "")),
          (this.prevNextButtons.isPrevDisabled = 0 === e),
          (this.prevNextButtons.isNextDisabled =
            e === this.listItemElements.length - 1),
          (this.pageDots.selectedIndex = e),
          null == (t = this.scrollBarElement) ||
            t.style.setProperty(
              "--transform",
              `${(100 / (this.listItemElements.length - 1)) * e}%`
            );
      }
      _onItemObserved(e) {
        !this.isScrolling &&
          e.forEach((e) => {
            e.isIntersecting &&
              this._onItemSelected(
                [...e.target.parentNode.children].indexOf(e.target)
              );
          });
      }
      _onMediaChanged(e) {
        e.matches
          ? this.listItemElements.forEach((e) =>
              this.itemIntersectionObserver.observe(e)
            )
          : this.listItemElements.forEach((e) =>
              this.itemIntersectionObserver.unobserve(e)
            );
      }
    };
    window.customElements.define("time-line", tp);
    var tm = class extends d {
      connectedCallback() {
        (this.pressItemsWrapper = this.querySelector(".press-list__wrapper")),
          (this.pressItems = Array.from(this.querySelectorAll("press-item"))),
          (this.pageDots = this.querySelector("page-dots")),
          this.pressItems.length > 1 &&
            (Shopify.designMode &&
              this.addEventListener("shopify:block:select", (e) => {
                var t;
                null == (t = this.intersectionObserver) || t.disconnect(),
                  (e.detail.load || !e.target.selected) &&
                    this.select(e.target.index, !e.detail.load);
              }),
            this.pressItemsWrapper.addEventListener(
              "swiperight",
              this.previous.bind(this)
            ),
            this.pressItemsWrapper.addEventListener(
              "swipeleft",
              this.next.bind(this)
            ),
            this.addEventListener("page-dots:changed", (e) =>
              this.select(e.detail.index)
            ),
            this._blockVerticalScroll()),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility();
      }
      async _setupVisibility() {
        await this.untilVisible(),
          this.pressItems[this.selectedIndex].transitionToEnter();
      }
      get selectedIndex() {
        return this.pressItems.findIndex((e) => e.selected);
      }
      previous() {
        this.select(
          (this.selectedIndex - 1 + this.pressItems.length) %
            this.pressItems.length
        );
      }
      next() {
        this.select(
          (this.selectedIndex + 1 + this.pressItems.length) %
            this.pressItems.length
        );
      }
      async select(e, t = !0) {
        let i = this.pressItems[this.selectedIndex],
          n = this.pressItems[e];
        await i.transitionToLeave(t),
          (this.pageDots.selectedIndex = e),
          await n.transitionToEnter(t);
      }
    };
    Object.assign(tm.prototype, eY),
      window.customElements.define("press-list", tm);
    var tf = class extends HTMLElement {
      connectedCallback() {
        this.addEventListener("split-lines:re-split", (e) => {
          Array.from(e.target.children).forEach(
            (e) => (e.style.visibility = this.selected ? "visible" : "hidden")
          );
        });
      }
      get index() {
        return [...this.parentNode.children].indexOf(this);
      }
      get selected() {
        return !this.hasAttribute("hidden");
      }
      async transitionToLeave(e = !0) {
        let t = await eT(this.querySelectorAll("split-lines")),
          i = new ez(
            new e4(
              t.reverse().map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      visibility: ["visible", "hidden"],
                      clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"],
                      transform: ["translateY(0)", "translateY(100%)"],
                    },
                    {
                      duration: 350,
                      delay: 60 * t,
                      easing: "cubic-bezier(0.68, 0.00, 0.77, 0.00)",
                    }
                  )
              )
            )
          );
        e ? i.play() : i.finish(),
          await i.finished,
          this.setAttribute("hidden", "");
      }
      async transitionToEnter(e = !0) {
        this.removeAttribute("hidden");
        let t = await eT(
            this.querySelectorAll("split-lines, .testimonial__author")
          ),
          i = new ez(
            new e4(
              t.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      visibility: ["hidden", "visible"],
                      clipPath: ["inset(0 0 100% 0)", "inset(0 0 0px 0)"],
                      transform: ["translateY(100%)", "translateY(0)"],
                    },
                    {
                      duration: 550,
                      delay: 120 * t,
                      easing: "cubic-bezier(0.23, 1, 0.32, 1)",
                    }
                  )
              )
            )
          );
        return e ? i.play() : i.finish(), i.finished;
      }
    };
    window.customElements.define("press-item", tf);
    var t$ = class extends d {
      connectedCallback() {
        (this.openingTimeout = null),
          (this.currentMegaMenu = null),
          this.delegate.on(
            "mouseenter",
            ".has-dropdown",
            (e, t) => {
              e.target === t &&
                null !== e.relatedTarget &&
                this.openDropdown(t);
            },
            !0
          ),
          this.delegate.on(
            "click",
            ".header__linklist-link[aria-expanded], .nav-dropdown__link[aria-expanded]",
            (e, t) => {
              !window.matchMedia("(hover: hover)").matches &&
                "true" !== t.getAttribute("aria-expanded") &&
                (e.preventDefault(), this.openDropdown(t.parentElement));
            }
          ),
          this.delegate.on("shopify:block:select", (e) =>
            this.openDropdown(e.target.parentElement)
          ),
          this.delegate.on("shopify:block:deselect", (e) =>
            this.closeDropdown(e.target.parentElement)
          );
      }
      openDropdown(e) {
        let t = e.querySelector("[aria-controls]"),
          i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
        this.currentMegaMenu = i.classList.contains("mega-menu") ? i : null;
        let n = setTimeout(() => {
          if ("true" === t.getAttribute("aria-expanded")) return;
          if (
            (t.setAttribute("aria-expanded", "true"),
            i.removeAttribute("hidden"),
            i.classList.contains("mega-menu") && !ek.prefersReducedMotion())
          ) {
            let s = Array.from(
              i.querySelectorAll(".mega-menu__column, .mega-menu__image-push")
            );
            s.forEach((e) => {
              e.getAnimations().forEach((e) => e.cancel()),
                (e.style.opacity = 0);
            });
            let r = new ez(
              new e4(
                s.map(
                  (e, t) =>
                    new eW(
                      e,
                      {
                        opacity: [0, 1],
                        transform: ["translateY(20px)", "translateY(0)"],
                      },
                      {
                        duration: 250,
                        delay: 100 + 60 * t,
                        easing: "cubic-bezier(0.65, 0, 0.35, 1)",
                      }
                    )
                )
              )
            );
            r.play();
          }
          let a = (t) => {
              null !== t.relatedTarget &&
                (this.closeDropdown(e), e.removeEventListener("mouseleave", a));
            },
            o = () => {
              this.closeDropdown(e),
                document.documentElement.removeEventListener("mouseleave", o);
            };
          e.addEventListener("mouseleave", a),
            document.documentElement.addEventListener("mouseleave", o),
            (n = null),
            this.dispatchEvent(
              new CustomEvent("desktop-nav:dropdown:open", { bubbles: !0 })
            );
        }, 100);
        e.addEventListener(
          "mouseleave",
          () => {
            n && clearTimeout(n);
          },
          { once: !0 }
        );
      }
      closeDropdown(e) {
        let t = e.querySelector("[aria-controls]"),
          i = e.querySelector(`#${t.getAttribute("aria-controls")}`);
        requestAnimationFrame(() => {
          i.classList.add("is-closing"),
            t.setAttribute("aria-expanded", "false"),
            setTimeout(
              () => {
                i.setAttribute("hidden", ""),
                  clearTimeout(this.openingTimeout),
                  i.classList.remove("is-closing");
              },
              i.classList.contains("mega-menu") && this.currentMegaMenu !== i
                ? 250
                : 0
            ),
            this.dispatchEvent(
              new CustomEvent("desktop-nav:dropdown:close", { bubbles: !0 })
            );
        });
      }
    };
    window.customElements.define("desktop-navigation", t$);
    var tg = class extends td {
      get apparitionAnimation() {
        if (this._apparitionAnimation) return this._apparitionAnimation;
        if (!ek.prefersReducedMotion()) {
          let e = Array.from(
              this.querySelectorAll('.mobile-nav__item[data-level="1"]')
            ),
            t = [];
          t.push(
            new e4(
              e.map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 1],
                      transform: ["translateX(-40px)", "translateX(0)"],
                    },
                    {
                      duration: 300,
                      delay: 300 + 120 * t - Math.min(2 * t * t, 120 * t),
                      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                    }
                  )
              )
            )
          );
          let i = this.querySelector(".drawer__footer");
          return (
            i &&
              t.push(
                new eW(
                  i,
                  {
                    opacity: [0, 1],
                    transform: ["translateY(100%)", "translateY(0)"],
                  },
                  {
                    duration: 300,
                    delay: 500 + Math.max(125 * e.length - 25 * e.length, 25),
                    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                  }
                )
              ),
            (this._apparitionAnimation = new ez(new e4(t)))
          );
        }
      }
      attributeChangedCallback(e, t, i) {
        super.attributeChangedCallback(e, t, i),
          "open" === e &&
            (this.open &&
              this.apparitionAnimation &&
              (Array.from(
                this.querySelectorAll(
                  '.mobile-nav__item[data-level="1"], .drawer__footer'
                )
              ).forEach((e) => (e.style.opacity = 0)),
              this.apparitionAnimation.play()),
            c(this, this.open ? "mobile-nav:open" : "mobile-nav:close"));
      }
    };
    window.customElements.define("mobile-navigation", tg);
    var tb = class extends d {
      connectedCallback() {
        window.ResizeObserver &&
          ((this.resizeObserver = new ResizeObserver(
            this._updateCustomProperties.bind(this)
          )),
          this.resizeObserver.observe(this),
          this.resizeObserver.observe(this.querySelector(".header__wrapper"))),
          this.isTransparent &&
            ((this.isTransparencyDetectionLocked = !1),
            this.delegate.on(
              "desktop-nav:dropdown:open",
              () => (this.lockTransparency = !0)
            ),
            this.delegate.on(
              "desktop-nav:dropdown:close",
              () => (this.lockTransparency = !1)
            ),
            this.rootDelegate.on(
              "mobile-nav:open",
              () => (this.lockTransparency = !0)
            ),
            this.rootDelegate.on(
              "mobile-nav:close",
              () => (this.lockTransparency = !1)
            ),
            this.delegate.on(
              "mouseenter",
              this._checkTransparentHeader.bind(this),
              !0
            ),
            this.delegate.on(
              "mouseleave",
              this._checkTransparentHeader.bind(this)
            ),
            this.isSticky &&
              (this._checkTransparentHeader(),
              (this._onWindowScrollListener = ea(
                this._checkTransparentHeader.bind(this),
                100
              )),
              window.addEventListener("scroll", this._onWindowScrollListener)));
      }
      disconnectedCallback() {
        super.disconnectedCallback(),
          window.ResizeObserver && this.resizeObserver.disconnect(),
          this.isTransparent &&
            this.isSticky &&
            window.removeEventListener("scroll", this._onWindowScrollListener);
      }
      get isSticky() {
        return this.hasAttribute("sticky");
      }
      get isTransparent() {
        return this.hasAttribute("transparent");
      }
      get transparentHeaderThreshold() {
        return 25;
      }
      set lockTransparency(e) {
        (this.isTransparencyDetectionLocked = e),
          this._checkTransparentHeader();
      }
      _updateCustomProperties(e) {
        e.forEach((e) => {
          if (e.target === this) {
            let t = e.borderBoxSize
              ? e.borderBoxSize.length > 0
                ? e.borderBoxSize[0].blockSize
                : e.borderBoxSize.blockSize
              : e.target.clientHeight;
            document.documentElement.style.setProperty(
              "--header-height",
              `${t}px`
            );
          }
          if (e.target.classList.contains("header__wrapper")) {
            let i = e.borderBoxSize
              ? e.borderBoxSize.length > 0
                ? e.borderBoxSize[0].blockSize
                : e.borderBoxSize.blockSize
              : e.target.clientHeight;
            document.documentElement.style.setProperty(
              "--header-height-without-bottom-nav",
              `${i}px`
            );
          }
        });
      }
      _checkTransparentHeader(e) {
        this.isTransparencyDetectionLocked ||
        window.scrollY > this.transparentHeaderThreshold ||
        (e && "mouseenter" === e.type)
          ? this.classList.remove("header--transparent")
          : this.classList.add("header--transparent");
      }
    };
    window.customElements.define("store-header", tb);
    var tv = class {
        constructor(e) {
          (this.photoSwipeInstance = e),
            (this.delegate = new o(this.photoSwipeInstance.scrollWrap)),
            (this.maxSpreadZoom =
              window.themeVariables.settings.mobileZoomFactor || 2),
            (this.pswpUi =
              this.photoSwipeInstance.scrollWrap.querySelector(".pswp__ui")),
            this.delegate.on(
              "click",
              '[data-action="pswp-close"]',
              this._close.bind(this)
            ),
            this.delegate.on(
              "click",
              '[data-action="pswp-prev"]',
              this._goToPrev.bind(this)
            ),
            this.delegate.on(
              "click",
              '[data-action="pswp-next"]',
              this._goToNext.bind(this)
            ),
            this.delegate.on(
              "click",
              '[data-action="pswp-move-to"]',
              this._moveTo.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "close",
              this._onPswpClosed.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "doubleTap",
              this._onPswpDoubleTap.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "beforeChange",
              this._onPswpBeforeChange.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "initialZoomInEnd",
              this._onPswpInitialZoomInEnd.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "initialZoomOut",
              this._onPswpInitialZoomOut.bind(this)
            ),
            this.photoSwipeInstance.listen(
              "parseVerticalMargin",
              this._onPswpParseVerticalMargin.bind(this)
            ),
            this.delegate.on(
              "pswpTap",
              ".pswp__img",
              this._onPswpTap.bind(this)
            );
        }
        init() {
          let e = this.pswpUi.querySelector(".pswp__prev-next-buttons"),
            t = this.pswpUi.querySelector(".pswp__dots-nav-wrapper");
          if (this.photoSwipeInstance.items.length <= 1) {
            (e.style.display = "none"), (t.style.display = "none");
            return;
          }
          (e.style.display = ""), (t.style.display = "");
          let i = "";
          this.photoSwipeInstance.items.forEach((e, t) => {
            i += `
        <button class="dots-nav__item tap-area" ${
          0 === t ? 'aria-current="true"' : ""
        } data-action="pswp-move-to">
          <span class="visually-hidden">Go to slide ${t}</span>
        </button>
      `;
          }),
            (t.querySelector(".pswp__dots-nav-wrapper .dots-nav").innerHTML =
              i);
        }
        _close() {
          this.photoSwipeInstance.close();
        }
        _goToPrev() {
          this.photoSwipeInstance.prev();
        }
        _goToNext() {
          this.photoSwipeInstance.next();
        }
        _moveTo(e, t) {
          this.photoSwipeInstance.goTo([...t.parentNode.children].indexOf(t));
        }
        _onPswpClosed() {
          this.delegate.off("pswpTap");
        }
        _onPswpDoubleTap(e) {
          let t = this.photoSwipeInstance.currItem.initialZoomLevel;
          this.photoSwipeInstance.getZoomLevel() !== t
            ? this.photoSwipeInstance.zoomTo(t, e, 333)
            : this.photoSwipeInstance.zoomTo(
                t < 0.7 ? 1 : this.maxSpreadZoom,
                e,
                333
              );
        }
        _onPswpTap(e) {
          "mouse" === e.detail.pointerType &&
            this.photoSwipeInstance.toggleDesktopZoom(e.detail.releasePoint);
        }
        _onPswpBeforeChange() {
          if (this.photoSwipeInstance.items.length <= 1) return;
          let e = this.photoSwipeInstance.scrollWrap.querySelector(
            `.dots-nav__item:nth-child(${
              this.photoSwipeInstance.getCurrentIndex() + 1
            })`
          );
          e.setAttribute("aria-current", "true"),
            eL(e).forEach((e) => e.removeAttribute("aria-current"));
        }
        _onPswpInitialZoomInEnd() {
          var e;
          null == (e = this.pswpUi) || e.classList.remove("pswp__ui--hidden");
        }
        _onPswpInitialZoomOut() {
          var e;
          null == (e = this.pswpUi) || e.classList.add("pswp__ui--hidden");
        }
        _onPswpParseVerticalMargin(e) {
          e.vGap.bottom =
            this.photoSwipeInstance.items.length <= 1 ||
            window.matchMedia(window.themeVariables.breakpoints.lapAndUp)
              .matches
              ? 0
              : 60;
        }
      },
      ty = class extends Y {
        connectedCallback() {
          super.connectedCallback(),
            (this.mediaElement = this.closest(".product__media")),
            (this.maxSpreadZoom =
              window.themeVariables.settings.mobileZoomFactor || 2),
            ey.load("photoswipe");
        }
        disconnectedCallback() {
          var e;
          super.disconnectedCallback(),
            null == (e = this.photoSwipeInstance) || e.destroy();
        }
        async attributeChangedCallback(e, t, i) {
          super.attributeChangedCallback(e, t, i),
            "open" === e &&
              this.open &&
              (await ey.load("photoswipe"), this._openPhotoSwipe());
        }
        async _openPhotoSwipe() {
          let e = await this._buildItems();
          this.photoSwipeInstance = new window.ThemePhotoSwipe(this, tv, e, {
            index: e.findIndex((e) => e.selected),
            maxSpreadZoom: this.maxSpreadZoom,
            loop: !1,
            allowPanToNext: !1,
            closeOnScroll: !1,
            closeOnVerticalDrag: ek.supportsHover(),
            showHideOpacity: !0,
            arrowKeys: !0,
            history: !1,
            getThumbBoundsFn: () => {
              let e = this.mediaElement.querySelector(
                  ".product__media-item.is-selected"
                ),
                t = window.pageYOffset || document.documentElement.scrollTop,
                i = e.getBoundingClientRect();
              return { x: i.left, y: i.top + t, w: i.width };
            },
            getDoubleTapZoom: (e, t) =>
              e ? (t.w > t.h ? 1.6 : 1) : t.initialZoomLevel < 0.7 ? 1 : 1.33,
          });
          let t = null;
          (this.photoSwipeInstance.updateSize = new Proxy(
            this.photoSwipeInstance.updateSize,
            {
              apply(e, i, n) {
                t !== window.innerWidth &&
                  (e(arguments), (t = window.innerWidth));
              },
            }
          )),
            this.photoSwipeInstance.listen("close", () => {
              this.open = !1;
            }),
            this.photoSwipeInstance.init();
        }
        async _buildItems() {
          let e = Array.from(
              this.mediaElement.querySelectorAll(
                '.product__media-item[data-media-type="image"]:not(.is-filtered)'
              )
            ),
            t = await eP.load(this.getAttribute("product-handle"));
          return Promise.resolve(
            e.map((e) => {
              let i = t.media.find(
                  (t) => t.id === parseInt(e.getAttribute("data-media-id"))
                ),
                n = e9(
                  i,
                  [
                    200, 300, 400, 500, 600, 700, 800, 1e3, 1200, 1400, 1600,
                    1800, 2e3, 2200, 2400, 2600, 2800, 3e3,
                  ]
                ),
                s = Math.min(n[n.length - 1], window.innerWidth);
              return {
                selected: e.classList.contains("is-selected"),
                src: eN(
                  i,
                  `${Math.ceil(
                    Math.min(
                      s * window.devicePixelRatio * this.maxSpreadZoom,
                      3e3
                    )
                  )}x`
                ),
                msrc: e.firstElementChild.currentSrc,
                originalMedia: i,
                w: s,
                h: parseInt(s / i.aspect_ratio),
              };
            })
          );
        }
      };
    window.customElements.define("product-image-zoom", ty);
    var t_ = class extends HTMLElement {
      connectedCallback() {
        var e;
        let t = this.querySelector("script");
        t &&
          ((this.inventories = JSON.parse(t.innerHTML)),
          null == (e = document.getElementById(this.getAttribute("form-id"))) ||
            e.addEventListener(
              "variant:changed",
              this._onVariantChanged.bind(this)
            ));
      }
      _onVariantChanged(e) {
        var t;
        null == (t = this.querySelector("span")) || t.remove(),
          e.detail.variant && "" !== this.inventories[e.detail.variant.id]
            ? ((this.hidden = !1),
              this.insertAdjacentHTML(
                "afterbegin",
                this.inventories[e.detail.variant.id]
              ))
            : (this.hidden = !0);
      }
    };
    window.customElements.define("product-inventory", t_);
    var t8 = class extends HTMLElement {
      connectedCallback() {
        var e;
        null == (e = document.getElementById(this.getAttribute("form-id"))) ||
          e.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          ),
          Shopify.designMode &&
            Shopify.PaymentButton &&
            Shopify.PaymentButton.init();
      }
      _onVariantChanged(e) {
        this._updateAddToCartButton(e.detail.variant),
          this._updateDynamicCheckoutButton(e.detail.variant);
      }
      _updateAddToCartButton(e) {
        let t = this.querySelector("[data-product-add-to-cart-button]");
        if (!t) return;
        let i = "";
        t.classList.remove(
          "button--primary",
          "button--secondary",
          "button--ternary"
        ),
          e
            ? e.available
              ? (t.removeAttribute("disabled"),
                t.classList.add(
                  t.hasAttribute("data-use-primary")
                    ? "button--primary"
                    : "button--secondary"
                ),
                (i = t.getAttribute("data-button-content")))
              : (t.setAttribute("disabled", "disabled"),
                t.classList.add("button--ternary"),
                (i = window.themeVariables.strings.productFormSoldOut))
            : (t.setAttribute("disabled", "disabled"),
              t.classList.add("button--ternary"),
              (i = window.themeVariables.strings.productFormUnavailable)),
          "loader-button" === t.getAttribute("is")
            ? (t.firstElementChild.innerHTML = i)
            : (t.innerHTML = i);
      }
      _updateDynamicCheckoutButton(e) {
        let t = this.querySelector(".shopify-payment-button");
        t && (t.style.display = e && e.available ? "block" : "none");
      }
    };
    window.customElements.define("product-payment-container", t8);
    var tw = class extends d {
      connectedCallback() {
        var e;
        null == (e = document.getElementById(this.getAttribute("form-id"))) ||
          e.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          );
      }
      _onVariantChanged(e) {
        let t = e.detail.variant;
        if (t) {
          let i = this.querySelector('[name="id"]');
          (i.value = t.id),
            i.dispatchEvent(new Event("change", { bubbles: !0 }));
        }
      }
    };
    window.customElements.define("product-payment-terms", tw);
    var tE = class extends HTMLFormElement {
      connectedCallback() {
        (this.id.disabled = !1),
          "page" !== window.themeVariables.settings.cartType &&
            "cart" !== window.themeVariables.settings.pageType &&
            this.addEventListener("submit", this._onSubmit.bind(this));
      }
      async _onSubmit(e) {
        if ((e.preventDefault(), !this.checkValidity())) {
          this.reportValidity();
          return;
        }
        let t = Array.from(this.elements).filter((e) => "submit" === e.type);
        t.forEach((e) => {
          e.setAttribute("disabled", "disabled"),
            e.setAttribute("aria-busy", "true");
        });
        let i = new FormData(this);
        i.append("sections", ["mini-cart"]),
          i.delete("option1"),
          i.delete("option2"),
          i.delete("option3");
        let n = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
          body: i,
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        t.forEach((e) => {
          e.removeAttribute("disabled"), e.removeAttribute("aria-busy");
        });
        let s = await n.json();
        n.ok &&
          (this.dispatchEvent(
            new CustomEvent("variant:added", {
              bubbles: !0,
              detail: { variant: s.hasOwnProperty("items") ? s.items[0] : s },
            })
          ),
          fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
            async (e) => {
              let t = await e.json();
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:updated", {
                  bubbles: !0,
                  detail: { cart: t },
                })
              ),
                (t.sections = s.sections),
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: !0,
                    detail: {
                      cart: t,
                      openMiniCart:
                        "drawer" === window.themeVariables.settings.cartType &&
                        null === this.closest(".drawer"),
                    },
                  })
                );
            }
          )),
          this.dispatchEvent(
            new CustomEvent("cart-notification:show", {
              bubbles: !0,
              cancelable: !0,
              detail: {
                status: n.ok ? "success" : "error",
                error: s.description || "",
              },
            })
          );
      }
    };
    window.customElements.define("product-form", tE, { extends: "form" });
    var tx = class extends d {
      async connectedCallback() {
        var e;
        (this.mainCarousel = this.querySelector("flickity-carousel")),
          this.hasAttribute("reveal-on-scroll") && this._setupVisibility(),
          1 !== this.mainCarousel.childElementCount &&
            ((this.selectedVariantMediaId = null),
            (this.viewInSpaceElement = this.querySelector(
              "[data-shopify-model3d-id]"
            )),
            (this.zoomButton = this.querySelector(".product__zoom-button")),
            (this.product = await eP.load(this.getAttribute("product-handle"))),
            null ==
              (e = document.getElementById(this.getAttribute("form-id"))) ||
              e.addEventListener(
                "variant:changed",
                this._onVariantChanged.bind(this)
              ),
            this.mainCarousel.addEventListener("model:played", () =>
              this.mainCarousel.setDraggable(!1)
            ),
            this.mainCarousel.addEventListener("model:paused", () =>
              this.mainCarousel.setDraggable(!0)
            ),
            this.mainCarousel.addEventListener("video:played", () =>
              this.mainCarousel.setDraggable(!1)
            ),
            this.mainCarousel.addEventListener("video:paused", () =>
              this.mainCarousel.setDraggable(!0)
            ),
            this.mainCarousel.addEventListener(
              "flickity:ready",
              this._onFlickityReady.bind(this)
            ),
            this.mainCarousel.addEventListener(
              "flickity:slide-changed",
              this._onFlickityChanged.bind(this)
            ),
            this.mainCarousel.addEventListener(
              "flickity:slide-settled",
              this._onFlickitySettled.bind(this)
            ),
            this._onFlickityReady());
      }
      get thumbnailsPosition() {
        return window.matchMedia(window.themeVariables.breakpoints.pocket)
          .matches
          ? "bottom"
          : this.getAttribute("thumbnails-position");
      }
      async _setupVisibility() {
        await this.untilVisible();
        let e = await this.mainCarousel.flickityInstance,
          t = e
            ? e.selectedElement.querySelector("img")
            : this.querySelector(".product__media-image-wrapper img"),
          i = ek.prefersReducedMotion();
        await eF(t);
        let n = new ez(
          new e4([
            new eW(
              t,
              {
                opacity: [0, 1],
                transform: [`scale(${i ? 1 : 1.1})`, "scale(1)"],
              },
              { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
            ),
            new e4(
              Array.from(
                this.querySelectorAll(
                  ".product__thumbnail-item:not(.is-filtered)"
                )
              ).map(
                (e, t) =>
                  new eW(
                    e,
                    {
                      opacity: [0, 1],
                      transform:
                        "left" === this.thumbnailsPosition
                          ? [`translateY(${i ? 0 : "40px"})`, "translateY(0)"]
                          : [`translateX(${i ? 0 : "50px"})`, "translateX(0)"],
                    },
                    {
                      duration: 250,
                      delay: i ? 0 : 100 * t,
                      easing: "cubic-bezier(0.75, 0, 0.175, 1)",
                    }
                  )
              )
            ),
          ])
        );
        this._hasSectionReloaded ? n.finish() : n.play();
      }
      async _onVariantChanged(e) {
        let t = e.detail.variant,
          i = [],
          n = !1;
        this.product.media.forEach((e) => {
          var s;
          let r = t.featured_media && e.id === t.featured_media.id;
          if (
            (null == (s = e.alt) ? void 0 : s.includes("#")) &&
            ((n = !0), !r)
          ) {
            let a = e.alt.split("#"),
              o = a.pop().split("_");
            this.product.options.forEach((n) => {
              n.name.toLowerCase() === o[0].toLowerCase() &&
                t.options[n.position - 1].toLowerCase() !==
                  o[1].trim().toLowerCase() &&
                i.push(e.id);
            });
          }
        });
        let s = [
          ...new Set(
            Array.from(
              this.querySelectorAll(".is-filtered[data-media-id]")
            ).map((e) => parseInt(e.getAttribute("data-media-id")))
          ),
        ];
        if (s.some((e) => !i.includes(e))) {
          let r = t.featured_media
            ? t.featured_media.id
            : this.product.media
                .map((e) => e.id)
                .filter((e) => !i.includes(e))[0];
          Array.from(this.querySelectorAll("[data-media-id]")).forEach((e) => {
            e.classList.toggle(
              "is-filtered",
              i.includes(parseInt(e.getAttribute("data-media-id")))
            ),
              e.classList.toggle(
                "is-selected",
                r === parseInt(e.getAttribute("data-media-id"))
              ),
              e.classList.toggle(
                "is-initial-selected",
                r === parseInt(e.getAttribute("data-media-id"))
              );
          }),
            this.mainCarousel.reload();
        } else {
          if (
            !e.detail.variant.featured_media ||
            this.selectedVariantMediaId === e.detail.variant.featured_media.id
          )
            return;
          this.mainCarousel.select(
            `[data-media-id="${e.detail.variant.featured_media.id}"]`
          );
        }
        this.selectedVariantMediaId = e.detail.variant.featured_media
          ? e.detail.variant.featured_media.id
          : null;
      }
      async _onFlickityReady() {
        let e = await this.mainCarousel.flickityInstance;
        ["video", "external_video"].includes(
          e.selectedElement.getAttribute("data-media-type")
        ) &&
          this.hasAttribute("autoplay-video") &&
          e.selectedElement.firstElementChild.play();
      }
      async _onFlickityChanged() {
        let e = await this.mainCarousel.flickityInstance;
        e.cells.forEach((e) => {
          ["external_video", "video", "model"].includes(
            e.element.getAttribute("data-media-type")
          ) && e.element.firstElementChild.pause();
        });
      }
      async _onFlickitySettled() {
        let e = await this.mainCarousel.flickityInstance,
          t = e.selectedElement;
        switch (
          (this.zoomButton &&
            (this.zoomButton.hidden =
              "image" !== t.getAttribute("data-media-type")),
          this.viewInSpaceElement &&
            this.viewInSpaceElement.setAttribute(
              "data-shopify-model3d-id",
              this.viewInSpaceElement.getAttribute(
                "data-shopify-model3d-default-id"
              )
            ),
          t.getAttribute("data-media-type"))
        ) {
          case "model":
            this.viewInSpaceElement.setAttribute(
              "data-shopify-model3d-id",
              t.getAttribute("data-media-id")
            ),
              t.firstElementChild.play();
            break;
          case "external_video":
          case "video":
            this.hasAttribute("autoplay-video") && t.firstElementChild.play();
        }
      }
    };
    function tk(e, t = "") {
      "string" == typeof e && (e = e.replace(".", ""));
      let i = /\{\{\s*(\w+)\s*\}\}/,
        n = t || window.themeVariables.settings.moneyFormat;
      function s(e, t) {
        return null == e || e != e ? t : e;
      }
      function r(e, t, i, n) {
        if (
          ((t = s(t, 2)),
          (i = s(i, ",")),
          (n = s(n, ".")),
          isNaN(e) || null == e)
        )
          return 0;
        let r = (e = (e / 100).toFixed(t)).split("."),
          a;
        return (
          r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
          (r[1] ? n + r[1] : "")
        );
      }
      let a = "";
      switch (n.match(i)[1]) {
        case "amount":
          a = r(e, 2);
          break;
        case "amount_no_decimals":
          a = r(e, 0);
          break;
        case "amount_with_space_separator":
          a = r(e, 2, " ", ".");
          break;
        case "amount_with_comma_separator":
          a = r(e, 2, ".", ",");
          break;
        case "amount_with_apostrophe_separator":
          a = r(e, 2, "'", ".");
          break;
        case "amount_no_decimals_with_comma_separator":
          a = r(e, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          a = r(e, 0, " ");
          break;
        case "amount_no_decimals_with_apostrophe_separator":
          a = r(e, 0, "'");
      }
      return n.indexOf("with_comma_separator"), n.replace(i, a);
    }
    window.customElements.define("product-media", tx);
    var tS = class extends HTMLElement {
      connectedCallback() {
        var e;
        null == (e = document.getElementById(this.getAttribute("form-id"))) ||
          e.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          );
      }
      get priceClass() {
        return this.getAttribute("price-class") || "";
      }
      get unitPriceClass() {
        return this.getAttribute("unit-price-class") || "";
      }
      _onVariantChanged(e) {
        this._updateLabels(e.detail.variant),
          this._updatePrices(e.detail.variant),
          this._updateSku(e.detail.variant);
      }
      _updateLabels(e) {
        let t = this.querySelector("[data-product-label-list]");
        if (t) {
          if (e) {
            if (((t.innerHTML = ""), e.available)) {
              if (e.compare_at_price > e.price) {
                let i = "";
                (i =
                  "percentage" === window.themeVariables.settings.discountMode
                    ? `${Math.round(
                        ((e.compare_at_price - e.price) * 100) /
                          e.compare_at_price
                      )}%`
                    : tk(e.compare_at_price - e.price)),
                  (t.innerHTML = `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace(
                    "@savings@",
                    i
                  )}</span>`);
              }
            } else
              t.innerHTML = `<span class="label label--subdued">${window.themeVariables.strings.collectionSoldOut}</span>`;
          } else t.innerHTML = "";
        }
      }
      _updatePrices(e) {
        let t = this.querySelector("[data-product-price-list]"),
          i = window.themeVariables.settings.currencyCodeEnabled
            ? window.themeVariables.settings.moneyWithCurrencyFormat
            : window.themeVariables.settings.moneyFormat;
        if (t) {
          if (e) {
            if (
              ((t.innerHTML = ""),
              e.compare_at_price > e.price
                ? ((t.innerHTML += `<span class="price price--highlight ${
                    this.priceClass
                  }"><span class="visually-hidden">${
                    window.themeVariables.strings.productSalePrice
                  }</span>${tk(e.price, i)}</span>`),
                  (t.innerHTML += `<span class="price price--compare"><span class="visually-hidden">${
                    window.themeVariables.strings.productRegularPrice
                  }</span>${tk(e.compare_at_price, i)}</span>`))
                : (t.innerHTML += `<span class="price ${
                    this.priceClass
                  }"><span class="visually-hidden">${
                    window.themeVariables.strings.productSalePrice
                  }</span>${tk(e.price, i)}</span>`),
              e.unit_price_measurement)
            ) {
              let n = "";
              1 !== e.unit_price_measurement.reference_value &&
                (n = `<span class="unit-price-measurement__reference-value">${e.unit_price_measurement.reference_value}</span>`),
                (this.querySelector(".unit-price-update").innerHTML = `
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${tk(
                e.unit_price
              )}</span>
              <span class="unit-price-measurement__separator">/</span>
              ${n}
              <span class="unit-price-measurement__reference-unit">${
                e.unit_price_measurement.reference_unit
              }</span>
            </div>
        `);
            }
            t.style.display = "";
          } else t.style.display = "none";
        }
      }
      _updateSku(e) {
        let t = this.querySelector("[data-product-sku-container]");
        if (!t) return;
        let i = t.querySelector("[data-product-sku-number]");
        e && e.sku
          ? ((i.innerHTML = e.sku), (t.style.display = ""))
          : (t.style.display = "none");
      }
    };
    window.customElements.define("product-meta", tS);
    var tL = class extends td {
      connectedCallback() {
        super.connectedCallback(),
          this.delegate.on(
            "variant:changed",
            this._onVariantChanged.bind(this)
          );
      }
      async _load() {
        await super._load(),
          (this.imageElement = this.querySelector(".quick-buy-product__image")),
          window.Shopify &&
            window.Shopify.PaymentButton &&
            window.Shopify.PaymentButton.init();
      }
      _onVariantChanged(e) {
        let t = e.detail.variant;
        if (
          (t &&
            Array.from(this.querySelectorAll('[href*="/products"]')).forEach(
              (e) => {
                let i = new URL(e.href);
                i.searchParams.set("variant", t.id),
                  e.setAttribute("href", i.toString());
              }
            ),
          !this.imageElement || !t || !t.featured_media)
        )
          return;
        let i = t.featured_media;
        i.alt && this.imageElement.setAttribute("alt", i.alt),
          this.imageElement.setAttribute("width", i.preview_image.width),
          this.imageElement.setAttribute("height", i.preview_image.height),
          this.imageElement.setAttribute("src", eN(i, "342x")),
          this.imageElement.setAttribute("srcset", eH(i, [114, 228, 342]));
      }
    };
    window.customElements.define("quick-buy-drawer", tL);
    var tT = class extends eb {
      connectedCallback() {
        super.connectedCallback(),
          this.delegate.on(
            "variant:changed",
            this._onVariantChanged.bind(this)
          ),
          this.delegate.on("variant:added", () => (this.open = !1));
      }
      async _load() {
        await super._load(),
          (this.imageElement = this.querySelector(".quick-buy-product__image"));
      }
      _onVariantChanged(e) {
        let t = e.detail.variant;
        if (
          (t &&
            Array.from(this.querySelectorAll('[href*="/products"]')).forEach(
              (e) => {
                let i = new URL(e.href);
                i.searchParams.set("variant", t.id),
                  e.setAttribute("href", i.toString());
              }
            ),
          !this.imageElement || !t || !t.featured_media)
        )
          return;
        let i = t.featured_media;
        i.alt && this.imageElement.setAttribute("alt", i.alt),
          this.imageElement.setAttribute("width", i.preview_image.width),
          this.imageElement.setAttribute("height", i.preview_image.height),
          this.imageElement.setAttribute("src", eN(i, "195x")),
          this.imageElement.setAttribute("srcset", eH(i, [65, 130, 195]));
      }
    };
    window.customElements.define("quick-buy-popover", tT);
    var tA = class extends HTMLElement {
      connectedCallback() {
        var e;
        null == (e = document.getElementById(this.getAttribute("form-id"))) ||
          e.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          );
      }
      _onVariantChanged(e) {
        e.detail.variant
          ? this._renderForVariant(e.detail.variant.id)
          : (this.innerHTML = "");
      }
      async _renderForVariant(e) {
        let t = await fetch(
            `${window.themeVariables.routes.rootUrlWithoutSlash}/variants/${e}?section_id=store-availability`
          ),
          i = document.createElement("div");
        (i.innerHTML = await t.text()),
          (this.innerHTML = i.firstElementChild.innerHTML.trim());
      }
    };
    window.customElements.define("store-pickup", tA);
    var tC = class extends d {
      async connectedCallback() {
        if (
          ((this.masterSelector = document.getElementById(
            this.getAttribute("form-id")
          ).id),
          (this.optionSelectors = Array.from(
            this.querySelectorAll("[data-selector-type]")
          )),
          !this.masterSelector)
        ) {
          console.warn(
            `The variant selector for product with handle ${this.productHandle} is not linked to any product form.`
          );
          return;
        }
        (this.product = await eP.load(this.productHandle)),
          this.delegate.on(
            "change",
            '[name^="option"]',
            this._onOptionChanged.bind(this)
          ),
          this.masterSelector.addEventListener(
            "change",
            this._onMasterSelectorChanged.bind(this)
          ),
          this._updateDisableSelectors(),
          this.selectVariant(this.selectedVariant.id);
      }
      get selectedVariant() {
        return this._getVariantById(parseInt(this.masterSelector.value));
      }
      get productHandle() {
        return this.getAttribute("handle");
      }
      get hideSoldOutVariants() {
        return this.hasAttribute("hide-sold-out-variants");
      }
      get updateUrl() {
        return this.hasAttribute("update-url");
      }
      selectVariant(e) {
        var t;
        if (
          (this._isVariantSelectable(this._getVariantById(e)) ||
            (e = this._getFirstMatchingAvailableOrSelectableVariant().id),
          (null == (t = this.selectedVariant) ? void 0 : t.id) !== e)
        ) {
          if (
            ((this.masterSelector.value = e),
            this.masterSelector.dispatchEvent(
              new Event("change", { bubbles: !0 })
            ),
            this.updateUrl && history.replaceState)
          ) {
            let i = new URL(window.location.href);
            e
              ? i.searchParams.set("variant", e)
              : i.searchParams.delete("variant"),
              window.history.replaceState(
                { path: i.toString() },
                "",
                i.toString()
              );
          }
          this._updateDisableSelectors(),
            c(this.masterSelector.form, "variant:changed", {
              variant: this.selectedVariant,
            });
        }
      }
      _onOptionChanged() {
        var e;
        this.selectVariant(
          null == (e = this._getVariantFromOptions()) ? void 0 : e.id
        );
      }
      _onMasterSelectorChanged() {
        var e;
        let t = (null == (e = this.selectedVariant) ? void 0 : e.options) || [];
        t.forEach((e, t) => {
          let i = this.querySelector(
              `input[name="option${t + 1}"][value="${CSS.escape(
                e
              )}"], select[name="option${t + 1}"]`
            ),
            n = !1;
          "SELECT" === i.tagName
            ? ((n = i.value !== e), (i.value = e))
            : "INPUT" === i.tagName &&
              ((n = !i.checked && i.value === e), (i.checked = i.value === e)),
            n && i.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
      }
      _getVariantById(e) {
        return this.product.variants.find((t) => t.id === e);
      }
      _getVariantFromOptions() {
        let e = this._getSelectedOptionValues();
        return this.product.variants.find((t) =>
          t.options.every((t, i) => t === e[i])
        );
      }
      _isVariantSelectable(e) {
        return (
          !!e && (e.available || (!this.hideSoldOutVariants && !e.available))
        );
      }
      _getFirstMatchingAvailableOrSelectableVariant() {
        let e = this._getSelectedOptionValues(),
          t = null,
          i = 0;
        do
          e.pop(),
            (i += 1),
            (t = this.product.variants.find((t) =>
              this.hideSoldOutVariants
                ? t.available &&
                  t.options
                    .slice(0, t.options.length - i)
                    .every((t, i) => t === e[i])
                : t.options
                    .slice(0, t.options.length - i)
                    .every((t, i) => t === e[i])
            ));
        while (!t && e.length > 0);
        return t;
      }
      _getSelectedOptionValues() {
        let e = [];
        return (
          Array.from(
            this.querySelectorAll(
              'input[name^="option"]:checked, select[name^="option"]'
            )
          ).forEach((t) => e.push(t.value)),
          e
        );
      }
      _updateDisableSelectors() {
        let e = this.selectedVariant;
        if (!e) return;
        let t = (e, t, i, n) => {
          let s = e.getAttribute("data-selector-type"),
            r = "";
          switch (s) {
            case "color":
              r = `.color-swatch:nth-child(${t + 1})`;
              break;
            case "variant-image":
              r = `.variant-swatch:nth-child(${t + 1})`;
              break;
            case "block":
              r = `.block-swatch:nth-child(${t + 1})`;
              break;
            case "dropdown":
              r = `.combo-box__option-item:nth-child(${t + 1})`;
          }
          e.querySelector(r).toggleAttribute("hidden", !n),
            this.hideSoldOutVariants
              ? e.querySelector(r).toggleAttribute("hidden", !i)
              : e.querySelector(r).classList.toggle("is-disabled", !i);
        };
        this.optionSelectors &&
          this.optionSelectors[0] &&
          this.product.options[0].values.forEach((i, n) => {
            let s = this.product.variants.some((e) => e.option1 === i && e),
              r = this.product.variants.some(
                (e) => e.option1 === i && e.available
              );
            t(this.optionSelectors[0], n, r, s),
              this.optionSelectors[1] &&
                this.product.options[1].values.forEach((i, n) => {
                  let s = this.product.variants.some(
                      (t) => t.option2 === i && t.option1 === e.option1 && t
                    ),
                    r = this.product.variants.some(
                      (t) =>
                        t.option2 === i &&
                        t.option1 === e.option1 &&
                        t.available
                    );
                  t(this.optionSelectors[1], n, r, s),
                    this.optionSelectors[2] &&
                      this.product.options[2].values.forEach((i, n) => {
                        let s = this.product.variants.some(
                            (t) =>
                              t.option3 === i &&
                              t.option1 === e.option1 &&
                              t.option2 === e.option2 &&
                              t
                          ),
                          r = this.product.variants.some(
                            (t) =>
                              t.option3 === i &&
                              t.option1 === e.option1 &&
                              t.option2 === e.option2 &&
                              t.available
                          );
                        t(this.optionSelectors[2], n, r, s);
                      });
                });
          });
      }
    };
    window.customElements.define("product-variants", tC);
    var tP = class extends d {
      connectedCallback() {
        (this.primaryImageList = Array.from(
          this.querySelectorAll(".product-item__primary-image")
        )),
          this.delegate.on(
            "change",
            ".product-item-meta__swatch-list .color-swatch__radio",
            this._onColorSwatchChanged.bind(this)
          ),
          this.delegate.on(
            "mouseenter",
            ".product-item-meta__swatch-list .color-swatch__item",
            this._onColorSwatchHovered.bind(this),
            !0
          );
      }
      async _onColorSwatchChanged(e, t) {
        if (
          (Array.from(this.querySelectorAll('[href*="/products"]')).forEach(
            (e) => {
              let i;
              (i =
                "A" === e.tagName
                  ? new URL(e.href)
                  : new URL(
                      e.getAttribute("href"),
                      `https://${window.themeVariables.routes.host}`
                    )).searchParams.set(
                "variant",
                t.getAttribute("data-variant-id")
              ),
                e.setAttribute("href", i.toString());
            }
          ),
          t.hasAttribute("data-variant-featured-media"))
        ) {
          let i = this.primaryImageList.find(
            (e) =>
              e.getAttribute("data-media-id") ===
              t.getAttribute("data-variant-featured-media")
          );
          i.setAttribute("loading", "eager");
          let n = i.complete
            ? Promise.resolve()
            : new Promise((e) => (i.onload = e));
          await n, i.removeAttribute("hidden");
          let s = {};
          await i.animate(
            (s = Array.from(i.parentElement.classList).some((e) =>
              [
                "aspect-ratio--short",
                "aspect-ratio--tall",
                "aspect-ratio--square",
              ].includes(e)
            )
              ? [
                  {
                    clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
                    transform: "translate(calc(-50% - 20px), -50%)",
                    zIndex: 1,
                    offset: 0,
                  },
                  {
                    clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
                    transform: "translate(calc(-50% - 20px), -50%)",
                    zIndex: 1,
                    offset: 0.3,
                  },
                  {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1,
                    offset: 1,
                  },
                ]
              : [
                  {
                    clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
                    transform: "translateX(-20px)",
                    zIndex: 1,
                    offset: 0,
                  },
                  {
                    clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
                    transform: "translateX(-20px)",
                    zIndex: 1,
                    offset: 0.3,
                  },
                  {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    transform: "translateX(0px)",
                    zIndex: 1,
                    offset: 1,
                  },
                ]),
            { duration: 500, easing: "ease-in-out" }
          ).finished,
            this.primaryImageList
              .filter(
                (e) =>
                  e.classList.contains("product-item__primary-image") && e !== i
              )
              .forEach((e) => e.setAttribute("hidden", ""));
        }
      }
      _onColorSwatchHovered(e, t) {
        let i = t.previousElementSibling;
        if (i.hasAttribute("data-variant-featured-media")) {
          let n = this.primaryImageList.find(
            (e) =>
              e.getAttribute("data-media-id") ===
              i.getAttribute("data-variant-featured-media")
          );
          n.setAttribute("loading", "eager");
        }
      }
    };
    window.customElements.define("product-item", tP);
    var tI = class extends d {
      connectedCallback() {
        this.delegate.on("pagination:page-changed", this._rerender.bind(this)),
          this.delegate.on("facet:criteria-changed", this._rerender.bind(this)),
          this.delegate.on("facet:abort-loading", this._abort.bind(this));
      }
      async _rerender(e) {
        history.replaceState({}, "", e.detail.url),
          this._abort(),
          this.showLoadingBar();
        let t = new URL(window.location);
        t.searchParams.set("section_id", this.getAttribute("section-id"));
        try {
          this.abortController = new AbortController();
          let i = await fetch(t.toString(), {
              signal: this.abortController.signal,
            }),
            n = await i.text(),
            s = document.createElement("div");
          (s.innerHTML = n),
            (this.querySelector("#facet-main").innerHTML =
              s.querySelector("#facet-main").innerHTML);
          let r = Array.from(s.querySelectorAll(".product-facet__active-list")),
            a = document.querySelector(".mobile-toolbar__item--filters");
          a && a.classList.toggle("has-filters", r.length > 0);
          let o = s.querySelector("#facet-filters");
          if (o) {
            let l = this.querySelector(
              "#facet-filters .drawer__content"
            ).scrollTop;
            Array.from(
              this.querySelectorAll(
                "#facet-filters-form .collapsible-toggle[aria-controls]"
              )
            ).forEach((e) => {
              let t = o.querySelector(
                  `[aria-controls="${e.getAttribute("aria-controls")}"]`
                ),
                i = "true" === e.getAttribute("aria-expanded");
              t.setAttribute("aria-expanded", i ? "true" : "false"),
                t.nextElementSibling.toggleAttribute("open", i),
                (t.nextElementSibling.style.overflow = i ? "visible" : "");
            }),
              (this.querySelector("#facet-filters").innerHTML = o.innerHTML),
              (this.querySelector("#facet-filters .drawer__content").scrollTop =
                l);
          }
          let c =
            this.querySelector(".product-facet__meta-bar") ||
            this.querySelector(".product-facet__product-list") ||
            this.querySelector(".product-facet__main");
          requestAnimationFrame(() => {
            c.scrollIntoView({ block: "start", behavior: "smooth" });
          }),
            this.hideLoadingBar();

    ratingSnippet("ruk_rating_snippet", {
      store: "www.goodbuy.eu",
      mode: "default",
      color: "#F0EB75",
      linebreak: false,
      text: "Bewertungen",
      singularText: "Bewertung",
      lang: "de-in",
      usePolaris: true,
      showEmptyStars: true,
    });
          
        } catch (h) {
          if ("AbortError" === h.name) return;
        }

        
      }
      _abort() {
        this.abortController && this.abortController.abort();
      }
    };
    window.customElements.define("product-facet", tI);
    var t0 = class extends td {
      connectedCallback() {
        super.connectedCallback(),
          this.delegate.on(
            "change",
            '[name^="filter."]',
            this._onFilterChanged.bind(this)
          ),
          this.rootDelegate.on(
            "click",
            '[data-action="clear-filters"]',
            this._onFiltersCleared.bind(this)
          ),
          this.alwaysVisible &&
            ((this.matchMedia = window.matchMedia(
              window.themeVariables.breakpoints.pocket
            )),
            this.matchMedia.addListener(this._adjustDrawer.bind(this)),
            this._adjustDrawer(this.matchMedia));
      }
      get alwaysVisible() {
        return this.hasAttribute("always-visible");
      }
      _onFiltersCleared(e, t) {
        e.preventDefault(), c(this, "facet:criteria-changed", { url: t.href });
      }
      _onFilterChanged() {
        let e = new FormData(this.querySelector("#facet-filters-form")),
          t = new URLSearchParams(e).toString();
        c(this, "facet:criteria-changed", {
          url: `${window.location.pathname}?${t}`,
        });
      }
      _adjustDrawer(e) {
        this.classList.toggle("drawer", e.matches),
          this.classList.toggle("drawer--from-left", e.matches);
      }
    };
    window.customElements.define("facet-filters", t0);
    var tq = class extends eb {
      connectedCallback() {
        super.connectedCallback(),
          this.delegate.on(
            "change",
            '[name="sort_by"]',
            this._onSortChanged.bind(this)
          );
      }
      _onSortChanged(e, t) {
        let i = new URL(location.href);
        i.searchParams.set("sort_by", t.value),
          i.searchParams.delete("page"),
          (this.open = !1),
          this.dispatchEvent(
            new CustomEvent("facet:criteria-changed", {
              bubbles: !0,
              detail: { url: i.toString() },
            })
          );
      }
    };
    window.customElements.define("sort-by-popover", tq);
    var tV = class extends d {
      connectedCallback() {
        this.rootDelegate.on(
          "cart:updated",
          (e) => (this.innerText = e.detail.cart.item_count)
        ),
          this.rootDelegate.on(
            "cart:refresh",
            (e) => (this.innerText = e.detail.cart.item_count)
          );
      }
    };
    window.customElements.define("cart-count", tV);
    var tM = class extends td {
      connectedCallback() {
        super.connectedCallback(),
          (this.nextReplacementDelay = 0),
          this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this)),
          this.addEventListener(
            "variant:added",
            () => (this.nextReplacementDelay = 600)
          );
      }
      async _rerenderCart(e) {
        var t;
        let i = null,
          n = "";
        if (e.detail && e.detail.cart && e.detail.cart.sections)
          (i = e.detail.cart), (n = e.detail.cart.sections["mini-cart"]);
        else {
          let s = await fetch(
            `${
              window.themeVariables.routes.cartUrl
            }?section_id=${this.getAttribute("section")}`
          );
          n = await s.text();
        }
        let r = document.createElement("div");
        (r.innerHTML = n),
          setTimeout(async () => {
            var t;
            let n = this.querySelector(".drawer__content").scrollTop;
            if (i && 0 === i.item_count) {
              let s = new ez(
                new e4(
                  Array.from(
                    this.querySelectorAll(".drawer__content, .drawer__footer")
                  ).map(
                    (e) =>
                      new eW(
                        e,
                        { opacity: [1, 0] },
                        { duration: 250, easing: "ease-in" }
                      )
                  )
                )
              );
              s.play(), await s.finished;
            }
            (this.innerHTML = r.querySelector("cart-drawer").innerHTML),
              i && 0 === i.item_count
                ? this.querySelector(".drawer__content").animate(
                    {
                      opacity: [0, 1],
                      transform: ["translateY(40px)", "translateY(0)"],
                    },
                    { duration: 450, easing: "cubic-bezier(0.33, 1, 0.68, 1)" }
                  )
                : (this.querySelector(".drawer__content").scrollTop = n),
              (null == (t = null == e ? void 0 : e.detail)
                ? void 0
                : t.openMiniCart) && (this.clientWidth, (this.open = !0));
          }, (null == (t = null == e ? void 0 : e.detail) ? void 0 : t.replacementDelay) || this.nextReplacementDelay),
          (this.nextReplacementDelay = 0);
      }
      async attributeChangedCallback(e, t, i) {
        if (
          (super.attributeChangedCallback(e, t, i),
          "open" === e &&
            this.open &&
            ((this.querySelector(".drawer__content").scrollTop = 0),
            !ek.prefersReducedMotion()))
        ) {
          let n = Array.from(this.querySelectorAll(".line-item")),
            s = this.querySelector(".mini-cart__recommendations-inner"),
            r = this.querySelector(".drawer__footer"),
            a = [];
          s &&
            window.matchMedia(window.themeVariables.breakpoints.pocket)
              .matches &&
            n.push(s),
            n.forEach((e) => (e.style.opacity = 0)),
            s && (s.style.opacity = 0),
            r && (r.style.opacity = 0),
            a.push(
              new e4(
                n.map(
                  (e, t) =>
                    new eW(
                      e,
                      {
                        opacity: [0, 1],
                        transform: ["translateX(40px)", "translateX(0)"],
                      },
                      {
                        duration: 400,
                        delay: 400 + 120 * t - Math.min(2 * t * t, 120 * t),
                        easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                      }
                    )
                )
              )
            ),
            r &&
              a.push(
                new eW(
                  r,
                  {
                    opacity: [0, 1],
                    transform: ["translateY(100%)", "translateY(0)"],
                  },
                  {
                    duration: 300,
                    delay: 400,
                    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                  }
                )
              ),
            s &&
              !window.matchMedia(window.themeVariables.breakpoints.pocket)
                .matches &&
              a.push(
                new eW(
                  s,
                  {
                    opacity: [0, 1],
                    transform: ["translateX(100%)", "translateX(0)"],
                  },
                  {
                    duration: 250,
                    delay: 400 + Math.max(120 * n.length - 25 * n.length, 25),
                    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
                  }
                )
              );
          new ez(new e4(a)).play();
        }
      }
    };
    window.customElements.define("cart-drawer", tM);
    var tD = class extends HTMLElement {
        async connectedCallback() {
          tD.recommendationsCache[this.productId] ||
            (tD.recommendationsCache[this.productId] = fetch(
              `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`
            ));
          let e = await tD.recommendationsCache[this.productId],
            t = document.createElement("div");
          t.innerHTML = await e.clone().text();
          let i = t.querySelector("cart-drawer-recommendations");
          i && i.hasChildNodes()
            ? (this.innerHTML = i.innerHTML)
            : (this.hidden = !0);
        }
        get productId() {
          return this.getAttribute("product-id");
        }
        get sectionId() {
          return this.getAttribute("section-id");
        }
      },
      t1 = tD;
    i(t1, "recommendationsCache", {}),
      window.customElements.define("cart-drawer-recommendations", t1);
    var tO = class extends HTMLTextAreaElement {
      connectedCallback() {
        this.addEventListener("change", this._onNoteChanged.bind(this));
      }
      get ownedToggle() {
        return this.hasAttribute("aria-owns")
          ? document.getElementById(this.getAttribute("aria-owns"))
          : null;
      }
      async _onNoteChanged() {
        this.ownedToggle &&
          (this.ownedToggle.innerHTML =
            "" === this.value
              ? window.themeVariables.strings.cartAddOrderNote
              : window.themeVariables.strings.cartEditOrderNote);
        let e = await fetch(
            `${window.themeVariables.routes.cartUrl}/update.js`,
            {
              body: JSON.stringify({ note: this.value }),
              credentials: "same-origin",
              method: "POST",
              headers: { "Content-Type": "application/json" },
            }
          ),
          t = await e.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: !0, detail: { cart: t } })
        );
      }
    };
    window.customElements.define("cart-note", tO, { extends: "textarea" });
    var tB = class extends HTMLElement {
      connectedCallback() {
        document.documentElement.addEventListener(
          "cart:updated",
          this._onCartUpdated.bind(this)
        );
      }
      get threshold() {
        return parseFloat(this.getAttribute("threshold"));
      }
      _onCartUpdated(e) {
        this.style.setProperty(
          "--progress",
          Math.min(parseFloat(e.detail.cart.total_price) / this.threshold, 1)
        );
      }
    };
    window.customElements.define("free-shipping-bar", tB);
    var tR = class extends d {
      connectedCallback() {
        this.delegate.on("click", "a", this._onQuantityLinkClicked.bind(this)),
          this.delegate.on(
            "change",
            "input",
            this._onQuantityChanged.bind(this)
          );
      }
      _onQuantityLinkClicked(e, t) {
        e.preventDefault(), this._updateFromLink(t.href);
      }
      _onQuantityChanged(e, t) {
        this._updateFromLink(
          `${window.themeVariables.routes.cartChangeUrl}?quantity=${
            t.value
          }&line=${t.getAttribute("data-line")}`
        );
      }
      async _updateFromLink(e) {
        if ("cart" === window.themeVariables.settings.pageType) {
          window.location.href = e;
          return;
        }
        let t = new URL(e, `https://${window.themeVariables.routes.host}`),
          i = t.searchParams,
          n = i.get("line"),
          s = i.get("id"),
          r = parseInt(i.get("quantity"));
        this.dispatchEvent(
          new CustomEvent("line-item-quantity:change:start", {
            bubbles: !0,
            detail: { newLineQuantity: r },
          })
        );
        let a = await fetch(
            `${window.themeVariables.routes.cartChangeUrl}.js`,
            {
              body: JSON.stringify({
                line: n,
                id: s,
                quantity: r,
                sections: ["mini-cart"],
              }),
              credentials: "same-origin",
              method: "POST",
              headers: { "Content-Type": "application/json" },
            }
          ),
          o = await a.json();
        this.dispatchEvent(
          new CustomEvent("line-item-quantity:change:end", {
            bubbles: !0,
            detail: { cart: o, newLineQuantity: r },
          })
        ),
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: !0,
              detail: { cart: o },
            })
          ),
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: !0,
              detail: { cart: o, replacementDelay: 0 === r ? 600 : 750 },
            })
          );
      }
    };
    window.customElements.define("line-item-quantity", tR);
    var t3 = class extends HTMLElement {
      connectedCallback() {
        (this.lineItemLoader = this.querySelector(".line-item__loader")),
          this.addEventListener(
            "line-item-quantity:change:start",
            this._onQuantityStart.bind(this)
          ),
          this.addEventListener(
            "line-item-quantity:change:end",
            this._onQuantityEnd.bind(this)
          );
      }
      _onQuantityStart() {
        this.lineItemLoader &&
          ((this.lineItemLoader.hidden = !1),
          (this.lineItemLoader.firstElementChild.hidden = !1),
          (this.lineItemLoader.lastElementChild.hidden = !0));
      }
      async _onQuantityEnd(e) {
        0 !== e.detail.cart.item_count &&
          this.lineItemLoader &&
          (await this.lineItemLoader.firstElementChild.animate(
            {
              opacity: [1, 0],
              transform: ["translateY(0)", "translateY(-10px)"],
            },
            75
          ).finished,
          (this.lineItemLoader.firstElementChild.hidden = !0),
          0 === e.detail.newLineQuantity
            ? (await this.animate(
                { opacity: [1, 0], height: [`${this.clientHeight}px`, 0] },
                { duration: 300, easing: "ease" }
              ).finished,
              this.remove())
            : ((this.lineItemLoader.lastElementChild.hidden = !1),
              await this.lineItemLoader.lastElementChild.animate(
                {
                  opacity: [0, 1],
                  transform: ["translateY(10px)", "translateY(0)"],
                },
                { duration: 75, endDelay: 300 }
              ).finished,
              (this.lineItemLoader.hidden = !0)));
      }
    };
    window.customElements.define("line-item", t3);
    var tN = class extends d {
      connectedCallback() {
        this.rootDelegate.on(
          "cart-notification:show",
          this._onShow.bind(this),
          !this.hasAttribute("global")
        ),
          this.delegate.on("click", '[data-action="close"]', (e) => {
            e.stopPropagation(), (this.hidden = !0);
          }),
          this.addEventListener("mouseenter", this.stopTimer.bind(this)),
          this.addEventListener("mouseleave", this.startTimer.bind(this)),
          window.addEventListener("pagehide", () => (this.hidden = !0));
      }
      set hidden(e) {
        e ? this.stopTimer() : this.startTimer(),
          this.toggleAttribute("hidden", e);
      }
      get isInsideDrawer() {
        return this.classList.contains("cart-notification--drawer");
      }
      stopTimer() {
        clearTimeout(this._timeout);
      }
      startTimer() {
        this._timeout = setTimeout(() => (this.hidden = !0), 3e3);
      }
      _onShow(e) {
        if (
          (this.isInsideDrawer && !this.closest(".drawer").open) ||
          (this.hasAttribute("global") &&
            "success" === e.detail.status &&
            "drawer" === window.themeVariables.settings.cartType)
        )
          return;
        e.stopPropagation();
        let t = "";
        this.isInsideDrawer ||
          (t = `
        <button class="cart-notification__close tap-area hidden-phone" data-action="close">
          <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
          <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
            <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
          </svg>
        </button>
      `),
          "success" === e.detail.status
            ? (this.classList.remove("cart-notification--error"),
              (this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading hidden-phone">${window.themeVariables.strings.cartItemAdded}</span>
                <span class="cart-notification__heading heading hidden-tablet-and-up">${window.themeVariables.strings.cartItemAddedShort}</span>
                <a href="${window.themeVariables.routes.cartUrl}" class="cart-notification__view-cart link">${window.themeVariables.strings.cartViewCart}</a>
              </div>
              
              ${t}
            </div>
          </div>
        </div>
      `))
            : (this.classList.add("cart-notification--error"),
              (this.innerHTML = `
        <div class="cart-notification__overflow">
          <div class="container">
            <div class="cart-notification__wrapper">
              <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
                <rect width="20" height="20" rx="10" fill="currentColor"></rect>
                <path d="M9.6748 13.2798C9.90332 13.0555 10.1763 12.9434 10.4937 12.9434C10.811 12.9434 11.0819 13.0555 11.3062 13.2798C11.5347 13.5041 11.6489 13.7749 11.6489 14.0923C11.6489 14.4097 11.5347 14.6847 11.3062 14.9175C11.0819 15.146 10.811 15.2603 10.4937 15.2603C10.1763 15.2603 9.90332 15.146 9.6748 14.9175C9.45052 14.6847 9.33838 14.4097 9.33838 14.0923C9.33838 13.7749 9.45052 13.5041 9.6748 13.2798ZM9.56689 12.1816V5.19922H11.4141V12.1816H9.56689Z" fill="rgb(var(--error-color))"></path>
              </svg>
              
              <div class="cart-notification__text-wrapper">
                <span class="cart-notification__heading heading">${e.detail.error}</span>
              </div>
              
              ${t}
            </div>
          </div>
        </div>
      `)),
          this.clientHeight,
          (this.hidden = !1);
      }
    };
    window.customElements.define("cart-notification", tN);
    var tH = class extends HTMLElement {
      connectedCallback() {
        (this.submitButton = this.querySelector('[type="button"]')),
          this.submitButton.addEventListener(
            "click",
            this._estimateShipping.bind(this)
          );
      }
      async _estimateShipping() {
        let e = this.querySelector('[name="shipping-estimator[zip]"]').value,
          t = this.querySelector('[name="shipping-estimator[country]"]').value,
          i = this.querySelector('[name="shipping-estimator[province]"]').value;
        this.submitButton.setAttribute("aria-busy", "true");
        let n = await fetch(
          `${window.themeVariables.routes.cartUrl}/prepare_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`,
          { method: "POST" }
        );
        if (n.ok) {
          let s = await this._getAsyncShippingRates(e, t, i);
          this._formatShippingRates(s);
        } else {
          let r = await n.json();
          this._formatError(r);
        }
        this.submitButton.removeAttribute("aria-busy");
      }
      async _getAsyncShippingRates(e, t, i) {
        let n = await fetch(
            `${window.themeVariables.routes.cartUrl}/async_shipping_rates.json?shipping_address[zip]=${e}&shipping_address[country]=${t}&shipping_address[province]=${i}`
          ),
          s = await n.text();
        return "null" === s
          ? this._getAsyncShippingRates(e, t, i)
          : JSON.parse(s).shipping_rates;
      }
      _formatShippingRates(e) {
        var t;
        null == (t = this.querySelector(".shipping-estimator__results")) ||
          t.remove();
        let i = "";
        e.forEach((e) => {
          i += `<li>${e.presentment_name}: ${tk(
            100 * parseFloat(e.price)
          )}</li>`;
        });
        let n = `
      <div class="shipping-estimator__results">
        <p>${
          0 === e.length
            ? window.themeVariables.strings.shippingEstimatorNoResults
            : 1 === e.length
            ? window.themeVariables.strings.shippingEstimatorOneResult
            : window.themeVariables.strings.shippingEstimatorMultipleResults
        }</p>
        ${"" === i ? "" : `<ul class="unordered-list">${i}</ul>`}
      </div>
    `;
        this.insertAdjacentHTML("beforeend", n);
      }
      _formatError(e) {
        var t;
        null == (t = this.querySelector(".shipping-estimator__results")) ||
          t.remove();
        let i = "";
        Object.keys(e).forEach((t) => {
          i += `<li>${t} ${e[t]}</li>`;
        });
        let n = `
      <div class="shipping-estimator__results">
        <p>${window.themeVariables.strings.shippingEstimatorError}</p>
        <ul class="unordered-list">${i}</ul>
      </div>
    `;
        this.insertAdjacentHTML("beforeend", n);
      }
    };
    window.customElements.define("shipping-estimator", tH);
    var t9 = class extends HTMLAnchorElement {
      constructor() {
        super(), this.addEventListener("click", this._onClick.bind(this));
      }
      _onClick() {
        let e = document.getElementById("shopify-product-reviews");
        e &&
          (window.matchMedia(window.themeVariables.breakpoints.pocket).matches
            ? (e.closest("collapsible-content").open = !0)
            : document
                .querySelector(
                  `[aria-controls="${
                    e.closest(".product-tabs__tab-item-wrapper").id
                  }"]`
                )
                .click());
      }
    };
    window.customElements.define("review-link", t9, { extends: "a" });
    var tF = class extends HTMLElement {
      connectedCallback() {
        var e;
        null == (e = document.getElementById(this.getAttribute("form-id"))) ||
          e.addEventListener(
            "variant:changed",
            this._onVariantChanged.bind(this)
          ),
          (this.imageElement = this.querySelector(
            ".product-sticky-form__image"
          )),
          (this.priceElement = this.querySelector(
            ".product-sticky-form__price"
          )),
          (this.unitPriceElement = this.querySelector(
            ".product-sticky-form__unit-price"
          )),
          this._setupVisibilityObservers();
      }
      disconnectedCallback() {
        this.intersectionObserver.disconnect();
      }
      set hidden(e) {
        this.toggleAttribute("hidden", e),
          e
            ? document.documentElement.style.removeProperty(
                "--cart-notification-offset"
              )
            : document.documentElement.style.setProperty(
                "--cart-notification-offset",
                `${this.clientHeight}px`
              );
      }
      _onVariantChanged(e) {
        let t = e.detail.variant,
          i = window.themeVariables.settings.currencyCodeEnabled
            ? window.themeVariables.settings.moneyWithCurrencyFormat
            : window.themeVariables.settings.moneyFormat;
        if (!t) return;
        if (
          (this.priceElement && (this.priceElement.innerHTML = tk(t.price, i)),
          this.unitPriceElement &&
            ((this.unitPriceElement.style.display = t.unit_price_measurement
              ? "block"
              : "none"),
            t.unit_price_measurement))
        ) {
          let n = "";
          1 !== t.unit_price_measurement.reference_value &&
            (n = `<span class="unit-price-measurement__reference-value">${t.unit_price_measurement.reference_value}</span>`),
            (this.unitPriceElement.innerHTML = `
          <div class="unit-price-measurement">
            <span class="unit-price-measurement__price">${tk(
              t.unit_price
            )}</span>
            <span class="unit-price-measurement__separator">/</span>
            ${n}
            <span class="unit-price-measurement__reference-unit">${
              t.unit_price_measurement.reference_unit
            }</span>
          </div>
        `);
        }
        if (!this.imageElement || !t || !t.featured_media) return;
        let s = t.featured_media;
        s.alt && this.imageElement.setAttribute("alt", s.alt),
          this.imageElement.setAttribute("width", s.preview_image.width),
          this.imageElement.setAttribute("height", s.preview_image.height),
          this.imageElement.setAttribute("src", eN(s, "165x")),
          this.imageElement.setAttribute("srcset", eH(s, [55, 110, 165]));
      }
      _setupVisibilityObservers() {
        let e = document.getElementById("MainPaymentContainer"),
          t = document.querySelector(".shopify-section--footer"),
          i = es();
        (this._isFooterVisible = this._isPaymentContainerPassed = !1),
          (this.intersectionObserver = new IntersectionObserver(
            (n) => {
              n.forEach((n) => {
                if (
                  (n.target === t &&
                    (this._isFooterVisible = n.intersectionRatio > 0),
                  n.target === e)
                ) {
                  let s = e.getBoundingClientRect();
                  this._isPaymentContainerPassed =
                    0 === n.intersectionRatio && s.top + s.height <= i;
                }
              }),
                window.matchMedia(window.themeVariables.breakpoints.pocket)
                  .matches
                  ? (this.hidden =
                      !this._isPaymentContainerPassed || this._isFooterVisible)
                  : (this.hidden = !this._isPaymentContainerPassed);
            },
            { rootMargin: `-${i}px 0px 0px 0px` }
          )),
          this.intersectionObserver.observe(e),
          this.intersectionObserver.observe(t);
      }
    };
    window.customElements.define("product-sticky-form", tF),
      new l(),
      Shopify.designMode &&
        document.addEventListener("shopify:section:load", () => {
          window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts());
        }),
      (window.SPRCallbacks = {
        onFormSuccess(e, t) {
          document
            .getElementById(`form_${t.id}`)
            .classList.add("spr-form--success");
        },
      }),
      (() => {
        let e = window.visualViewport
            ? window.visualViewport.width
            : document.documentElement.clientWidth,
          t = () => {
            let t = window.visualViewport
                ? window.visualViewport.width
                : document.documentElement.clientWidth,
              i = window.visualViewport
                ? window.visualViewport.height
                : document.documentElement.clientHeight;
            t !== e &&
              requestAnimationFrame(() => {
                document.documentElement.style.setProperty(
                  "--window-height",
                  i + "px"
                ),
                  (e = t);
              });
          };
        t(),
          window.visualViewport
            ? window.visualViewport.addEventListener("resize", t)
            : window.addEventListener("resize", t);
      })(),
      (() => {
        let e = new o(document.body);
        e.on(
          "keyup",
          'input:not([type="checkbox"]):not([type="radio"]), textarea',
          (e, t) => {
            t.classList.toggle("is-filled", "" !== t.value);
          }
        ),
          e.on("change", "select", (e, t) => {
            t.parentNode.classList.toggle("is-filled", "" !== t.value);
          });
      })(),
      document.querySelectorAll(".rte table").forEach((e) => {
        e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
      }),
      document.querySelectorAll(".rte iframe").forEach((e) => {
        (-1 !== e.src.indexOf("youtube") ||
          -1 !== e.src.indexOf("youtu.be") ||
          -1 !== e.src.indexOf("vimeo")) &&
          (e.outerHTML =
            '<div class="video-wrapper">' + e.outerHTML + "</div>");
      }),
      new o(document.documentElement).on(
        "click",
        "[data-smooth-scroll]",
        (e, t) => {
          let i = document.querySelector(t.getAttribute("href"));
          i &&
            (e.preventDefault(),
            i.scrollIntoView({ behavior: "smooth", block: "start" }));
        }
      ),
      document.addEventListener("keyup", function (e) {
        "Tab" === e.key &&
          (document.body.classList.remove("no-focus-outline"),
          document.body.classList.add("focus-outline"));
      });
  })(),
  /*!
   * focus-trap 6.7.1
   * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
   */ /*!
   * tabbable 5.2.1
   * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
   */ (() => {
    var e = {
        "./src/js/modules/ed-quantity-discounts.js"() {
          function e(t) {
            return (e =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(t);
          }
          function t(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n);
            }
          }
          function i(e) {
            var t = "function" == typeof Map ? new Map() : void 0;
            return (i = function e(i) {
              var s;
              if (
                null === i ||
                ((s = i),
                -1 === Function.toString.call(s).indexOf("[native code]"))
              )
                return i;
              if ("function" != typeof i)
                throw TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== t) {
                if (t.has(i)) return t.get(i);
                t.set(i, o);
              }
              function o() {
                return n(i, arguments, a(this).constructor);
              }
              return (
                (o.prototype = Object.create(i.prototype, {
                  constructor: {
                    value: o,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                r(o, i)
              );
            })(e);
          }
          function n(e, t, i) {
            return (n = s()
              ? Reflect.construct.bind()
              : function e(t, i, n) {
                  var s = [null];
                  s.push.apply(s, i);
                  var a = new (Function.bind.apply(t, s))();
                  return n && r(a, n.prototype), a;
                }).apply(null, arguments);
          }
          function s() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {})
                ),
                !0
              );
            } catch (e) {
              return !1;
            }
          }
          function r(e, t) {
            return (r = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function e(t, i) {
                  return (t.__proto__ = i), t;
                })(e, t);
          }
          function a(e) {
            return (a = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function e(t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                })(e);
          }
          var o = (function (i) {
            !(function e(t, i) {
              if ("function" != typeof i && null !== i)
                throw TypeError(
                  "Super expression must either be null or a function"
                );
              (t.prototype = Object.create(i && i.prototype, {
                constructor: { value: t, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(t, "prototype", { writable: !1 }),
                i && r(t, i);
            })(u, i);
            var n,
              o,
              l,
              c,
              h,
              d =
                ((n = u),
                (o = s()),
                function t() {
                  var i,
                    s = a(n);
                  if (o) {
                    var r = a(this).constructor;
                    i = Reflect.construct(s, arguments, r);
                  } else i = s.apply(this, arguments);
                  return (function t(i, n) {
                    if (n && ("object" === e(n) || "function" == typeof n))
                      return n;
                    if (void 0 !== n)
                      throw TypeError(
                        "Derived constructors may only return object or undefined"
                      );
                    return (function e(t) {
                      if (void 0 === t)
                        throw ReferenceError(
                          "this hasn't been initialised - super() hasn't been called"
                        );
                      return t;
                    })(i);
                  })(this, i);
                });
            function u() {
              return (
                (function e(t, i) {
                  if (!(t instanceof i))
                    throw TypeError("Cannot call a class as a function");
                })(this, u),
                d.apply(this, arguments)
              );
            }
            return (
              (l = u),
              (c = [
                {
                  key: "connectedCallback",
                  value: function e() {
                    this._attachSelectors(), this._attachListeners();
                  },
                },
                {
                  key: "_attachSelectors",
                  value: function e() {
                    (this.quantityInput = this.querySelector("input")),
                      (this.quantityItems =
                        this.querySelectorAll(".quantity-item"));
                  },
                },
                {
                  key: "_attachListeners",
                  value: function e() {
                    var t = this;
                    this.quantityItems.forEach(function (e) {
                      e.addEventListener(
                        "click",
                        t.onQuantityItemClick.bind(t)
                      ),
                        "true" === e.dataset.preselect && t.applyPreSelect(e);
                    });
                  },
                },
                {
                  key: "onQuantityItemClick",
                  value: function e(t) {
                    var i = this;
                    this.quantityItems.forEach(function (e) {
                      e.classList.remove("selected"),
                        t.target === e &&
                          (e.classList.add("selected"),
                          (i.quantityInput.value = e.dataset.qty));
                    });
                  },
                },
                {
                  key: "applyPreSelect",
                  value: function e(t) {
                    var i = this;
                    this.quantityItems.forEach(function (e) {
                      e.classList.remove("selected"),
                        t === e &&
                          (e.classList.add("selected"),
                          (i.quantityInput.value = e.dataset.qty));
                    });
                  },
                },
              ]),
              t(l.prototype, c),
              h && t(l, h),
              Object.defineProperty(l, "prototype", { writable: !1 }),
              u
            );
          })(i(HTMLElement));
          customElements.define("ed-quantity-discounts", o);
        },
        "./src/js/modules/ed-video-component.js"() {
          function e(t) {
            return (e =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (e) {
                    return typeof e;
                  }
                : function (e) {
                    return e &&
                      "function" == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? "symbol"
                      : typeof e;
                  })(t);
          }
          function t(e, t) {
            if (!(e instanceof t))
              throw TypeError("Cannot call a class as a function");
          }
          function i(e, t) {
            for (var i = 0; i < t.length; i++) {
              var n = t[i];
              (n.enumerable = n.enumerable || !1),
                (n.configurable = !0),
                "value" in n && (n.writable = !0),
                Object.defineProperty(e, n.key, n);
            }
          }
          function n(e, t, n) {
            return (
              t && i(e.prototype, t),
              n && i(e, n),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              e
            );
          }
          function s(e, t) {
            if ("function" != typeof t && null !== t)
              throw TypeError(
                "Super expression must either be null or a function"
              );
            (e.prototype = Object.create(t && t.prototype, {
              constructor: { value: e, writable: !0, configurable: !0 },
            })),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              t && c(e, t);
          }
          function r(t) {
            var i = l();
            return function n() {
              var s,
                r = h(t);
              if (i) {
                var a = h(this).constructor;
                s = Reflect.construct(r, arguments, a);
              } else s = r.apply(this, arguments);
              return (function t(i, n) {
                if (n && ("object" === e(n) || "function" == typeof n))
                  return n;
                if (void 0 !== n)
                  throw TypeError(
                    "Derived constructors may only return object or undefined"
                  );
                return (function e(t) {
                  if (void 0 === t)
                    throw ReferenceError(
                      "this hasn't been initialised - super() hasn't been called"
                    );
                  return t;
                })(i);
              })(this, s);
            };
          }
          function a(e) {
            var t = "function" == typeof Map ? new Map() : void 0;
            return (a = function e(i) {
              var n;
              if (
                null === i ||
                ((n = i),
                -1 === Function.toString.call(n).indexOf("[native code]"))
              )
                return i;
              if ("function" != typeof i)
                throw TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== t) {
                if (t.has(i)) return t.get(i);
                t.set(i, s);
              }
              function s() {
                return o(i, arguments, h(this).constructor);
              }
              return (
                (s.prototype = Object.create(i.prototype, {
                  constructor: {
                    value: s,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                c(s, i)
              );
            })(e);
          }
          function o(e, t, i) {
            return (o = l()
              ? Reflect.construct.bind()
              : function e(t, i, n) {
                  var s = [null];
                  s.push.apply(s, i);
                  var r = new (Function.bind.apply(t, s))();
                  return n && c(r, n.prototype), r;
                }).apply(null, arguments);
          }
          function l() {
            if (
              "undefined" == typeof Reflect ||
              !Reflect.construct ||
              Reflect.construct.sham
            )
              return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {})
                ),
                !0
              );
            } catch (e) {
              return !1;
            }
          }
          function c(e, t) {
            return (c = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function e(t, i) {
                  return (t.__proto__ = i), t;
                })(e, t);
          }
          function h(e) {
            return (h = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function e(t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                })(e);
          }
          var d = (function (e) {
            s(a, e);
            var i = r(a);
            function a() {
              var e;
              return (
                t(this, a),
                ((e = i.call(this)).popUp = document.querySelector(
                  ".video-popup-container"
                )),
                (e.popUpVideo = e.popUp.querySelector(".video-container")),
                (e.openButton = e.querySelector(".btn-open")),
                (e.closeButton = e.popUp.querySelector(".btn-close")),
                (e.playButton = e.querySelector(".play-btn")),
                e.popUp &&
                  document
                    .querySelector("ed-video-popup")
                    .setAttribute("enabled", ""),
                e._attachListeners(),
                e
              );
            }
            return (
              n(a, [
                {
                  key: "videoSrc",
                  get: function e() {
                    return this.getAttribute("video-src");
                  },
                },
                {
                  key: "autoPlay",
                  get: function e() {
                    return this.getAttribute("autoplay");
                  },
                },
                {
                  key: "controls",
                  get: function e() {
                    return this.getAttribute("controls");
                  },
                },
                {
                  key: "_attachListeners",
                  value: function e() {
                    document.addEventListener(
                      "keydown",
                      this.closeOnEsc.bind(this)
                    ),
                      this.openButton.addEventListener(
                        "click",
                        this.openPopup.bind(this)
                      ),
                      this.playButton.addEventListener(
                        "click",
                        this.openPopup.bind(this)
                      ),
                      this.popUp.addEventListener(
                        "click",
                        this.closePopup.bind(this)
                      ),
                      this.closeButton.addEventListener(
                        "click",
                        this.closePopup.bind(this)
                      );
                  },
                },
                {
                  key: "openPopup",
                  value: function e(t) {
                    t.stopPropagation(),
                      this.createVideo(),
                      this.popUp.classList.add("open"),
                      document.documentElement.classList.add(
                        "ed-video-popup-open"
                      );
                  },
                },
                {
                  key: "closePopup",
                  value: function e(t) {
                    t.stopPropagation(),
                      (this.popUpVideo.innerHTML = ""),
                      this.popUp.classList.remove("open"),
                      document.documentElement.classList.remove(
                        "ed-video-popup-open"
                      );
                  },
                },
                {
                  key: "closeOnEsc",
                  value: function e(t) {
                    "Escape" === t.key &&
                      ((this.popUpVideo.innerHTML = ""),
                      document.documentElement.classList.remove(
                        "ed-video-popup-open"
                      ),
                      this.popUp.classList.remove("open"));
                  },
                },
                {
                  key: "createVideo",
                  value: function e() {
                    var t = document.createElement("video");
                    (t.src = this.videoSrc),
                      (t.autoplay = !0),
                      (t.controls = !0),
                      "false" === this.autoPlay && (t.autoplay = !1),
                      "false" === this.controls && (t.controls = !1),
                      this.popUpVideo.appendChild(t);
                  },
                },
              ]),
              a
            );
          })(a(HTMLElement));
          customElements.define("ed-video-thumbnail", d);
          var u = (function (e) {
            s(a, e);
            var i = r(a);
            function a() {
              return t(this, a), i.call(this);
            }
            return n(a);
          })(a(HTMLElement));
          customElements.define("ed-video-popup", u);
        },
      },
      t = {};
    function i(n) {
      var s = t[n];
      if (void 0 !== s) return s.exports;
      var r = (t[n] = { exports: {} });
      return e[n](r, r.exports, i), r.exports;
    }
    (i.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return i.d(t, { a: t }), t;
    }),
      (i.d = (e, t) => {
        for (var n in t)
          i.o(t, n) &&
            !i.o(e, n) &&
            Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
      }),
      (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
      (i.r = (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      });
    var n = {};
    (() => {
      "use strict";
      var e = {};
      /*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/ i.r(e);
      var t = i(
          /*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js"
        ),
        n = i.n(t),
        s = i(
          /*! ./modules/ed-quantity-discounts */ "./src/js/modules/ed-quantity-discounts.js"
        ),
        r = i.n(s);
    })(),
      /*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/ i.r(n);
  })();
